/* eslint-disable no-new-object */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React from "react";
import { Box, Grid, CircularProgress, Typography, Divider, useMediaQuery } from "@mui/material";
import update from "immutability-helper";
import _, { uniqueId } from "lodash";
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector, batch } from "react-redux";
import styles from "../assets/styles/Hospital.module.scss";
import {
	AdmissionADTDetailsDialog,
	AdmissionCardDetailsDialog,
	AdmissionHeader,
	DxCardList,
	HospitalList,
	TransferADTCardListTable,
	ViewTransferStatusOfAdmission,
} from "../features/admissions/components";
import AdmissionHeaderCardFilterPanel from "../features/admissions/components/AdmissionHeaderCardFilterPanel";
import AdmissionHeaderAdtTabFilterPanel from "../features/admissions/components/AdmissionHeaderAdtTabFilterPanel";
import Card from "../components/dashboard/card/Card";
import dashboardStyles from "../components/dashboard/Dashboard.module.scss";
import DoctorCard from "../components/dashboard/doctorCard/DoctorCard";
import { AverageLengthOfStayCard } from "../features/admissions/components";
import {
	DayCardList,
	DynamicDataCardList,
	FloorCardList,
	HospitalRowContainer,
	TotalCountCircle,
	TotalTransferCard,
} from "../features/hospital/components";
import InsuranceCard from "../components/dashboard/InsuranceCard/InsuranceCard";
import SelectableCard from "../components/dashboard/selectableCard/SelectableCard";
import TaggedList from "../components/dashboard/shared/taggedList/TaggedList";
import usePdfReport from "../components/hooks/usePdfReport";
import Page from "../components/Page";
import ADTCard from "../components/shared/ADTCard/ADTCard";
import ColorInfoBox from "../components/shared/dashboard/ColorInfoBox";
import PickProjectionDaysPopup from "../components/shared/PickProjectionDaysPopup/PickProjectionDaysPopup";
import MobileCardList from "../components/shared/MobileCardList";
import { ADMISSION_TYPES } from "../data/admission.data";
import { allADTData, getAllAdmissionsPatient } from "../services/admission.service";
import {
	DEFAULT_CARD_FILTER,
	openADTDetailsDialog,
	openDetailsDialog,
	setCardFilter,
	setDefaultADTData,
	setDynamicCards,
	setIsAdtLoading,
	setLockedTotalBy,
	setLockFilterTotalState,
	setLockTotal,
	setMainTotal,
	setReversedColorAdmission,
	setSelectedADTTableData,
	setTransferType,
	setLoading as setAdmissionLoading,
	setCachedMainResult,
	setCachedComparisonResult,
	clearCachedResults,
	setDefaultCardEdited,
} from "../store/reducers/admission.slice";
import {
	openADTDetailsDialog as openADTDetailsDialogComparison,
	openDetailsDialog as openDetailsDialogComparison,
	setCardFilter as setCardFilterComparison,
	setDefaultADTData as setDefaultADTDataComparison,
	setFilterListData as setFilterListDataComparison,
	setLockFilterTotalState as setLockFilterTotalStateComparison,
	setMainTotal as setMainTotalComparison,
	setPatientList as setPatientListComparison,
	setSelectedADTTableData as setSetSelectedADTTableDataComparison,
	setTransferType as setTransferTypeComparison,
} from "../store/reducers/comparisonReducers/admissionComparison.slice";
import { ADD_NOTIFICATION, REPORT_META_PATHS } from "../store/types";
import { ADMISSION_CARDS_LABELS, ADMISSION_CARDS_TYPE, ADMISSION_FILTER_TYPE } from "../types/admission.type";
import { PATIENT_RELATION } from "../types/chart-dialog.type";
import { ADT_TABLE_TYPE, ADT_TYPES, CUSTOM_TAB_TYPE } from "../types/common.type";
import { PAGE_TYPE } from "../types/pages.type";
import {
	adtCardFilterParam,
	getADTDataDefault,
	updateAdmissionChartFilter,
	updateADTChartFilter,
	updateFilterListDataBoth,
} from "../utilis/admission-common";
import { admissionPriorityFilter, getDynamicPercentageBy, isOnlyHospitalTabAccess, itemPercentage, pickObjectByPaths, processCustomRangeCombinedData, projectionPerMonth, selectedTabAccess } from "../utilis/common";
import { setIsLayoutMode } from "../store/reducers/common.slice";
import { toSaveDate, toSaveEndDate } from "../utilis/date-formats";
import tooltipsInfo from "../utilis/tooltipContents";

import { setAdmissionCards, setAdmissionLayout } from "../store/reducers/customCard.slice";
import AddCardDrawer from "../components/shared/add-filter-card/add-card-drawer";
import { ADMISSION_CUSTOM_CARD } from "../types/custom-card-type";
import CardAnimation from "../components/shared/CardAnimation";
import ShadowLineWithText from "../components/shared/ShadowLineWithText";
import { setRefetchComparison } from "../store/reducers/comparisonReducers/comparison.slice";
import NoteContainer from "../components/shared/NoteContainer";
import { getQuestionsData } from "../services/dynamic-data-tab.service";
import useAdditionalData from "../components/hooks/useAdditionalData";
import useSharedUsersByCustomTab from "../hooks/useSharedUsersByCustomTab";
import { useDashboard } from "../context/DashboardContext";
import DynamicCardItem from "../components/shared/dynamic-card/DynamicCardItem";
import { usePageNotifications } from "../hooks/usePageNotifications";
import useIsMobileDevice from "../hooks/useIsMobileDevice";
import ShareNotificationDialog from "../components/shared/ShareNotificationDialog";
import CategoryBox from "../components/shared/CategoryBox";
import DragDropLayout from "../components/shared/DragDropLayout";
import LayoutController from "../components/shared/LayoutController";
import AdmissionCardLayoutPreview from "../features/admissions/components/layoutPreview/AdmissionCardLayoutPreview";
import ToastNotification from "../components/shared/ToastNotification";
import { getCardWidth } from "../constants/card-layout";
import {
	getCustomTabCardLayoutId,
	getDynamicCardLayoutId,
	resolveLayoutCardIdForSelectedCard,
} from "../utilis/layout-card-ids";
import { saveLayoutToDatabase } from "../services/layout.service";
import {
	applyCollapsedStateToLayout,
	getCollapsedIdsFromLayout,
} from "../utils/categoryCollapsedState";
import useCollapsedCategoriesPersistence from "../components/hooks/useCollapsedCategoriesPersistence";
import { findCategoryIdContainingCard } from "../utils/dashboardScrollToCard";
import { usePageLayoutFetch } from "../hooks/usePageLayoutFetch";
import useAddCategoryFromMenu from "../hooks/useAddCategoryFromMenu";
import { ensureHospitalRootOrder } from "../utils/ensureHospitalRootOrder";
import {
	computeLayoutAfterCardMove,
	computeLayoutAfterRootGapInsert,
	estimateCategoryGridRowUnits,
	getPointerClientCoords,
	getStandaloneInsertBeforeIdFromPoint,
	getCategoryInsertBeforeTargetFromPoint,
	pointInRect,
	pointerOverHospitalRootStandaloneArea,
	resolveHospitalCategoryIdUnderPointer,
} from "../utils/hospitalCategoryLayoutHelpers";
import { AUTH_ROLES } from "../types/auth.type";
import { useAIChatContext } from "../hooks/useAIChatContext";
import { useAiChatAccess } from "../hooks/useAiChatAccess";
import { registerVectorStoreId } from "../services/vector-store-tracking.service";
import useFilterTutorial from "../hooks/useFilterTutorial";
import useTutorialTrigger from "../hooks/useTutorialTrigger";
import { TUTORIAL_FEATURES } from "../config/tutorials.config";
import AiChatFloatButton from "../components/shared/ai-chat/AiChatFloatButton";
import AiChatDrawer from "../components/shared/ai-chat/AiChatDrawer";
// import aiCensusActionsService from "../services/ai-census-actions.service";
// import aiDateSuggestionsService from "../services/ai-date-suggestions.service";
// import aiDateActionsService from "../services/ai-date-actions.service";
// import aiFilterActionsService from "../services/ai-filter-actions.service";
// import aiReportActionsService from "../services/ai-report-actions.service";
// import aiTransferActionsService from "../services/ai-transfer-actions.service";
// import aiDialogActionsService from "../services/ai-dialog-actions.service";
import {
	PAGE_CONVERTER_ADMISSION_FETCH_FLAG,
	readAndClearPageConverterAdmissionSource,
} from "../services/page-converter-navigation.service";
import useFacilityId from "../hooks/useFacilityId";
import useAccountId from "../hooks/useAccountId";
import useShareReport from "../hooks/useShareReport";
import ShareNotesDialog from "../components/shared/notes/ShareNotesDialog";

/**
 * Layout mode dashboard zoom — same factors as Hospital / Community Transfer
 * so `transformScale` on RGL matches the visual `transform: scale(...)`.
 */
const ADMISSION_LAYOUT_MODE_ZOOM_DESKTOP = 0.76;
const ADMISSION_LAYOUT_MODE_ZOOM_MOBILE = 0.86;

const DEFAULT_LIST = {
	list: [],
	adtList: [],
	customTabs: [],
	allPagesCustomTabs: {},
	diffDashboardPatients: []
};

function normalizeAdmissionLayoutCardIds(layout, dynamicCards, customTabs) {
	if (!layout) return layout;
	const mapCard = (c) => {
		if (!c || c.id == null) return c;
		const newId = resolveLayoutCardIdForSelectedCard(c.id, dynamicCards, customTabs);
		return newId === c.id ? c : { ...c, id: newId };
	};
	const mappedRootOrder = Array.isArray(layout.rootOrder)
		? layout.rootOrder
			.map((entry) => {
				if (!entry || entry.id == null) return entry;
				const nextId = resolveLayoutCardIdForSelectedCard(entry.id, dynamicCards, customTabs);
				return nextId === entry.id ? entry : { ...entry, id: nextId };
			})
			.filter(Boolean)
		: undefined;
	return {
		...layout,
		standalone: (layout.standalone || []).map(mapCard),
		categories: (layout.categories || []).map((cat) => ({
			...cat,
			cards: (cat.cards || []).map(mapCard),
		})),
		rootOrder: mappedRootOrder,
	};
}

function augmentAdmissionLayoutWithSelectedCards(layout, admissionCards, dynamicCards, customTabs) {
	if (!layout || !Array.isArray(admissionCards) || admissionCards.length === 0) return layout;
	
	const ownedBaseAccessors = new Set();
	
	// Process categories first to prioritize cards explicitly placed there
	const cleanCategories = (layout.categories || []).map(cat => {
		const cleanCards = [];
		(cat.cards || []).forEach(c => {
			const base = c.id.replace(/^(dynamic_|custom_)/, '');
			if (!ownedBaseAccessors.has(base)) {
				ownedBaseAccessors.add(base);
				cleanCards.push(c);
			}
		});
		return { ...cat, cards: cleanCards };
	});

	// Remove duplicates from standalone
	const cleanStandalone = [];
	(layout.standalone || []).forEach(c => {
		const base = c.id.replace(/^(dynamic_|custom_)/, '');
		if (!ownedBaseAccessors.has(base)) {
			ownedBaseAccessors.add(base);
			cleanStandalone.push(c);
		}
	});

	// Find truly missing cards
	const additions = [];
	for (const cId of admissionCards) {
		const base = cId.replace(/^(dynamic_|custom_)/, '');
		if (!ownedBaseAccessors.has(base)) {
			ownedBaseAccessors.add(base);
			const gridId = resolveLayoutCardIdForSelectedCard(cId, dynamicCards, customTabs);
			additions.push({ id: gridId, width: getCardWidth(cId), gridH: 24 });
		}
	}

	const existingRootOrder = Array.isArray(layout.rootOrder) ? layout.rootOrder : [];
	const validStandaloneIds = new Set(cleanStandalone.map(c => c.id));
	const orderedIds = new Set();
	
	// Clean root order of duplicates that were removed
	const cleanRootOrder = existingRootOrder.filter(entry => {
		if (entry.type === 'category') {
			orderedIds.add(entry.id);
			return true;
		}
		if (validStandaloneIds.has(entry.id)) {
			orderedIds.add(entry.id);
			return true;
		}
		return false;
	});

	const appendedRootEntries = additions
		.filter((card) => !orderedIds.has(card.id))
		.map((card, idx) => ({
			id: card.id,
			type: "card",
			width: card.width || 4,
			position: cleanRootOrder.length + idx,
		}));

	const nextRootOrder = [...cleanRootOrder, ...appendedRootEntries].map((entry, idx) => ({
		...entry,
		position: idx,
	}));

	return {
		...layout,
		categories: cleanCategories,
		standalone: [...cleanStandalone, ...additions],
		rootOrder: nextRootOrder,
	};
}

function isStoredLayoutV3(layout) {
	return layout && typeof layout === "object" && !Array.isArray(layout) && layout.version === "3.0";
}

function shouldLoadLayoutFromDatabase(layout) {
	if (layout == null) return true;
	if (Array.isArray(layout)) return layout.length === 0;
	if (typeof layout === "object" && !Array.isArray(layout) && Object.keys(layout).length === 0) {
		return true;
	}
	return false;
}

const AdmissionPage = () => {
	const isMobile = useIsMobileDevice();
	const compactCategoryInnerDesktop = useMediaQuery("(max-width:1280px)");
	const categoryInnerTwoCol = !isMobile && compactCategoryInnerDesktop;
	const { downloadPdf, saveAutomaticReport, downloadExcel } = usePdfReport();
	const dispatch = useDispatch();
	const [patientList, setPatientList] = useState(DEFAULT_LIST);
	const [isDateUpdated, setIsDateUpdated] = useState(false);
	/** Dashboard page type when user opened Admissions via page converter (Hospital / Community / Deceased / Overall). Cleared after read on mount. */
	const [pageConverterSourcePage, setPageConverterSourcePage] = useState(null);
	const { rangesSet, refetchComparison, comparisonRanges } = useSelector((state) => state.comparison);

	// One-shot refresh after page converter navigation (same as choosing dates via DateFilterComponent)
	useEffect(() => {
		try {
			if (sessionStorage.getItem(PAGE_CONVERTER_ADMISSION_FETCH_FLAG)) {
				sessionStorage.removeItem(PAGE_CONVERTER_ADMISSION_FETCH_FLAG);
				setIsDateUpdated(true);
			}
			const source = readAndClearPageConverterAdmissionSource();
			if (source?.pageType) {
				setPageConverterSourcePage(source.pageType);
			}
		} catch {
			/* ignore */
		}
	}, []);
	const [filterListData, setFilterListData] = useState(DEFAULT_CARD_FILTER);
	const { lastADTDate, projectionDays, isCustomTabAdded, skipMainFetch, enableComparisonFetch } = useSelector((state) => state.common);
	const { admissionCards } = useSelector((state) => state.customCard);

	const [isHeaderVisible, setIsHeaderVisible] = useState(true);
	const {
		filter,
		dbData,
		transferType,
		cardFilter,
		dbSelectedFilters,
		selectedADTTableData,
		detailsDialog,
		detailsADTDialog,
		defaultADTData,
		isAdtLoading,
		mainNumPercentage,
		lockedTotal,
		adtFacilityPercentage,
		isCensusTotalLocked,
		lockedByFacility,
		lockedTotalBy,
		lockeByADT,
		lockFilterTotalState,
		reversedColorAdmission,
		filterTotal,
		loading: admissionLoading,
		dynamicCards,
		cachedMainResults,
		cachedComparisonResults,
		defaultCardEdited,
	} = useSelector((state) => state.admission);
	const { selectedAccount, percentageBy, isLayoutMode } = useSelector((state) => state.common);
	const activeRequestRef = useRef(null);
	const selectedTab = selectedTabAccess();

	// Layout mode state - now managed by Redux
	const [hasLayoutChanges, setHasLayoutChanges] = useState(false);
	const [tempLayout, setTempLayout] = useState([]);
	const [currentLayoutType, setCurrentLayoutType] = useState('personal'); // 'personal' or 'default'
	const [layoutTypeLoading, setLayoutTypeLoading] = useState(false);
	const { fetchSavedLayout, fetchLayoutByType, fetchDefaultLayout } = usePageLayoutFetch(PAGE_TYPE.ADMISSION);
	const [draggedCardId, setDraggedCardId] = useState(null);
	const [hoveredCategoryId, setHoveredCategoryId] = useState(null);
	const [hoveredStandalone, setHoveredStandalone] = useState(false);
	const [dragSource, setDragSource] = useState(null);
	const [collapsedCategoryIds, setCollapsedCategoryIds] = useState({});
	const hasInitializedCollapsedStateRef = useRef(false);
	const [dropFlashCategoryId, setDropFlashCategoryId] = useState(null);
	const [admissionGeneralDropHighlight, setAdmissionGeneralDropHighlight] = useState(false);
	const handleToggleLayoutModeRef = useRef(null);
	const dropFlashTimeoutRef = useRef(null);
	const suppressCategoryInnerPersistRef = useRef(false);
	const draggedCardIdRef = useRef(null);
	const dragSourceRef = useRef(null);
	const hoveredStandaloneRef = useRef(false);
	const categoryDragPointerRef = useRef(null);
	const standaloneDropZoneRef = useRef(null);
	const lastPointerRef = useRef({ x: 0, y: 0, timestamp: 0 });
	const generalDropHighlightRef = useRef(false);
	const handleToggleADTTabRef = useRef(null);
	const handleToggleAllADTTabRef = useRef(null);

	// Get auth user for super user check
	const authUser = useSelector((state) => state.auth);
	const isSuperUser = authUser?.role?.slug === AUTH_ROLES.SUPER;

	// Toast notification state
	const [toastNotification, setToastNotification] = useState({
		open: false,
		type: 'success',
		title: '',
		message: '',
	});

	// AI Chat state
	const [aiChatOpen, setAiChatOpen] = useState(false);
	const [aiChatUnreadCount, setAiChatUnreadCount] = useState(0);
	const [aiChatMinimized, setAiChatMinimized] = useState(false);
	const [aiConversationId, setAiConversationId] = useState(null);
	// const [aiVectorStoreId, setAiVectorStoreId] = useState(null); // disabled: new agent API does not use vector stores

	// Check AI Chat access
	const { hasAccess: hasAiChatAccess, loading: aiChatAccessLoading } = useAiChatAccess();

	// Share Report hook
	const {
		shareReportState,
		users,
		availableIntegrations,
		handleOnClickShareReport,
		handleCloseShareReport,
		handleShareReport,
	} = useShareReport({
		downloadPdf,
		generateExcel: downloadExcel, // Pass Excel generator for chart dialogs
		reportData: {
			cardFilter,
			filter,
			dbData,
			filterListData,
			selectedADTTableData,
		},
		pageType: PAGE_TYPE.ADMISSION,
	});

	const { admissionLayout } = useSelector((state) => state.customCard);

	const isOnlyHospitalDashboard = useMemo(() => {
		return isOnlyHospitalTabAccess();
	}, []);

	const percentageAgainst = useMemo(() => {
		return getDynamicPercentageBy(dbData, percentageBy, isOnlyHospitalDashboard);
	}, [dbData, percentageBy, isOnlyHospitalDashboard]);

	const {
		filterListData: filterListDataComparison,
		dbData: dbDataComparison,
		filter: filterComparison,
		dbSelectedFilters: dbSelectedFiltersComparison,
		cardFilter: cardFilterComparison,
		patientList: patientListComparison,
		transferType: transferTypeComparison,
		selectedADTTableData: selectedADTTableDataComparison,
		defaultADTData: defaultADTDataComparison,
		lockFilterTotalState: lockFilterTotalStateComparison,
		lockedTotal: lockedTotalComparison,
		lockedByFacility: lockedByFacilityComparison,
		isCensusTotalLocked: isCensusTotalLockedComparison,
		adtFacilityPercentage: adtFacilityPercentageComparison,
	} = useSelector((state) => state.admissionComparison);
	const { comparingAgainstDifferentFacility } = useSelector((state) => state.comparison);
	const [disableTotalHospitalizationsCard, setDisableTotalHospitalizationsCard] = useState(false);
	const activeFacilities = useSelector((state) => state.activeFacilities.facilities);
	const activeFacilitiesComparison = useSelector((state) => state.comparison.activeComparisonFacilitiesId);
	const triggerFilterTutorial = useFilterTutorial();
	const { triggerTutorial, trackFeatureUsage } = useTutorialTrigger();
	const transferStatusTutorialTriggeredRef = useRef(false);

	// Use ref to track previous facilities locally to avoid false positives on component remount
	const prevFacilitiesRef = useRef(null);
	const isInitialMountRef = useRef(true);
	const isInitialDataFetchRef = useRef(true);
	const prevIsCustomTabAddedRef = useRef(isCustomTabAdded);
	const lastMainFetchSignatureRef = useRef(null);

	// Clear cache when facilities change
	useEffect(() => {
		// Skip on initial mount - don't clear cache when component first loads
		if (isInitialMountRef.current) {
			isInitialMountRef.current = false;
			prevFacilitiesRef.current = [...activeFacilities].sort((a, b) => {
				const aStr = String(a);
				const bStr = String(b);
				return aStr.localeCompare(bStr);
			});
			return;
		}

		// Compare current facilities with previous facilities (from ref, not Redux)
		// This ensures we only clear cache when facilities actually change during component lifecycle
		const sortedActive = [...activeFacilities].sort((a, b) => {
			const aStr = String(a);
			const bStr = String(b);
			return aStr.localeCompare(bStr);
		});
		const sortedPrev = prevFacilitiesRef.current || [];
		const facilitiesActuallyChanged = !_.isEqual(sortedActive, sortedPrev);

		if (facilitiesActuallyChanged) {
			// Facilities changed - clear all cached results
			dispatch(clearCachedResults());
		}

		// Update ref with current facilities for next comparison
		prevFacilitiesRef.current = sortedActive;
	}, [activeFacilities, dispatch]);

	// Helper function to generate cache key for vector store ID
	// Key includes: page type + date range + facility IDs (sorted for consistency)
	// const getVectorStoreCacheKey = useCallback(() => {
	// 	if (!filter?.startDate || !filter?.endDate || !activeFacilities?.length) {
	// 		return null;
	// 	}
	// 	const sortedFacilityIds = [...activeFacilities].sort().join(',');
	// 	return `admission_vector_store_${filter.startDate}_${filter.endDate}_${sortedFacilityIds}`;
	// }, [filter?.startDate, filter?.endDate, activeFacilities]);

	// Vector store cache restore — disabled (new agent API does not use vector stores)
	/*
	useEffect(() => {
		const cacheKey = getVectorStoreCacheKey();
		if (cacheKey) {
			const cachedVectorStoreId = localStorage.getItem(cacheKey);
			if (cachedVectorStoreId) {
				setAiVectorStoreId(cachedVectorStoreId);

				// Re-register restored vector store ID for cleanup tracking
				registerVectorStoreId(cachedVectorStoreId, 'admission');
			}
		}
	}, [getVectorStoreCacheKey]);
	*/

	// Vector store invalidate-on-context-change — disabled (new agent API does not use vector stores)
	/*
	useEffect(() => {
		const cacheKey = getVectorStoreCacheKey();
		const previousCacheKey = sessionStorage.getItem('admission_vector_store_cache_key');

		// If context changed (date range or facilities), clear old cache and vector store
		if (previousCacheKey && previousCacheKey !== cacheKey) {
			// Clear old cached vector store ID from localStorage
			if (previousCacheKey) {
				localStorage.removeItem(previousCacheKey);
			}

			// Clear vector store ID - forces new vector store creation with fresh data
			setAiVectorStoreId(null);

			// Clear conversation ID - starts fresh conversation with new context
			setAiConversationId(null);

		}

		// Update stored cache key
		if (cacheKey) {
			sessionStorage.setItem('admission_vector_store_cache_key', cacheKey);
		}
	}, [getVectorStoreCacheKey]);
	*/


	const handleOnclickCard = useCallback(
		(value, total, mainTotal, totalComparison, mainTotalComparison) => {
			if (transferType && transferType === value) {
				dispatch(setTransferType(null));
				dispatch(setMainTotal(mainTotal));

				dispatch(setTransferTypeComparison(null));
				dispatch(setMainTotalComparison(mainTotalComparison));
			} else {
				dispatch(setTransferType(value));
				dispatch(setMainTotal(total));

				dispatch(setTransferTypeComparison(value));
				dispatch(setMainTotalComparison(totalComparison));
			}
		},
		[dispatch, transferType]
	);
	const { facilityId: facilityIdFromHook } = useFacilityId();
	const { accountId: accountIdFromHook } = useAccountId();
	const activeFacilityLocalStorage = facilityIdFromHook;
	const [projectionPopupOpen, setProjectionPopupOpen] = useState(false);

	// loading states
	const [loading, setLoading] = useState(true);
	const [loadingComparison, setLoadingComparison] = useState(true);

	// Track if data came from cache
	const [isDataFromCache, setIsDataFromCache] = useState(false);

	const getDynamicTab = useCallback(async (page) => {
		let query = { page, isCustom: true };

		const res = await getQuestionsData(query);
		let dynamicCardsData = [];
		let defaultCardEditedData = [];
		if (res && res.length > 0) {
			const defaultCardTabs = _.groupBy(res, 'isDefaultCard');
			defaultCardEditedData = (defaultCardTabs.true || [])?.filter((item) => item.forType === "transfer" && item.forTransferType === "hospitalTransfer" && item.isDefaultCard === true);
			dynamicCardsData = [
				...(defaultCardTabs?.false || []),
				...(defaultCardTabs?.undefined || [])
			];
		}
		dispatch(setDefaultCardEdited(defaultCardEditedData));
		dispatch(setDynamicCards(dynamicCardsData));
	}, [dispatch]); // Add dispatch to the dependency array

	const { updateDashboard } = useDashboard();

	// Page-specific notifications for Admission page
	const {
		shareNotifications,
		showShareDialog,
		handleNotificationResponse,
		handleViewTab,
		handleCloseShareDialog
	} = usePageNotifications(PAGE_TYPE.ADMISSION);

	// AI Census Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiCensusActionsService.initialize(dispatch, () => ({
			common: { percentageBy },
			admission: { dbData },
			dashboardData: { isOnlyHospitalDashboard }
		}));
	}, [dispatch, percentageBy, dbData, isOnlyHospitalDashboard]);
	*/

	// AI Date Suggestions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiDateSuggestionsService.initialize(dispatch, () => ({}));
	}, [dispatch]);
	*/

	// AI Date Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		const validationContext = {
			filter,
			activeFacilities
		};

		const handleFilterUpdateForAI = () => setIsDateUpdated(true);

		aiDateActionsService.initialize(validationContext, updateDashboard, handleFilterUpdateForAI);
	}, [filter, activeFacilities, updateDashboard]);
	*/

	useEffect(() => {
		if (dbData) {
			updateDashboard({
				dbData,
				page: PAGE_TYPE.ADMISSION,
				dbDataComparison,
				isOnlyHospitalDashboard,
				filter
			});
		}
	}, [dbData, updateDashboard, dbDataComparison, isOnlyHospitalDashboard, filter]);

	useEffect(() => {
		if (selectedAccount?._id) {
			getDynamicTab(PAGE_TYPE.HOSPITAL);
		}
	}, [selectedAccount?._id, getDynamicTab]);

	// Load saved layout from database on component mount
	useEffect(() => {
		const loadLayoutFromDatabase = async () => {
			try {
				const rawLayout = await fetchSavedLayout(currentLayoutType);
				if (rawLayout != null && typeof rawLayout === "object") {
					dispatch(setAdmissionLayout(rawLayout));
					setCollapsedCategoryIds(getCollapsedIdsFromLayout(rawLayout, rawLayout.isFallbackToDefault));
				}
			} catch (error) {
				// Continue with default layout if database load fails
			}
		};

		if (shouldLoadLayoutFromDatabase(admissionLayout)) {
			loadLayoutFromDatabase();
		}
	}, [dispatch, admissionLayout, currentLayoutType, fetchSavedLayout]);

	useEffect(() => {
		if (hasInitializedCollapsedStateRef.current) return;
		if (isLayoutMode) return;
		const categories = Array.isArray(admissionLayout?.categories) ? admissionLayout.categories : [];
		if (categories.length === 0) return;
		setCollapsedCategoryIds(getCollapsedIdsFromLayout(admissionLayout, admissionLayout.isFallbackToDefault));
		hasInitializedCollapsedStateRef.current = true;
	}, [admissionLayout, isLayoutMode]);

	useEffect(() => {
		hoveredStandaloneRef.current = hoveredStandalone;
	}, [hoveredStandalone]);

	useEffect(() => {
		const draggingFromCategory =
			isLayoutMode &&
			(draggedCardIdRef.current || draggedCardId) &&
			dragSource &&
			dragSource !== "standalone";

		if (!draggingFromCategory) {
			generalDropHighlightRef.current = false;
			setAdmissionGeneralDropHighlight(false);
			return;
		}

		const updateHighlight = (clientX, clientY) => {
			const next = pointerOverHospitalRootStandaloneArea({ x: clientX, y: clientY });
			if (next !== generalDropHighlightRef.current) {
				generalDropHighlightRef.current = next;
				setAdmissionGeneralDropHighlight(next);
			}
		};

		const onMove = (e) => {
			if (e.touches?.[0]) {
				updateHighlight(e.touches[0].clientX, e.touches[0].clientY);
			} else if (typeof e.clientX === "number") {
				updateHighlight(e.clientX, e.clientY);
			}
		};

		const clear = () => {
			generalDropHighlightRef.current = false;
			setAdmissionGeneralDropHighlight(false);
		};

		document.addEventListener("mousemove", onMove, true);
		document.addEventListener("touchmove", onMove, { passive: true, capture: true });
		document.addEventListener("mouseup", clear, true);
		document.addEventListener("touchend", clear, true);
		return () => {
			document.removeEventListener("mousemove", onMove, true);
			document.removeEventListener("touchmove", onMove, { capture: true });
			document.removeEventListener("mouseup", clear, true);
			document.removeEventListener("touchend", clear, true);
			clear();
		};
	}, [isLayoutMode, draggedCardId, dragSource]);

	// Pointer tracking + live category/standalone hover via geometry (shared with Hospital).
	useEffect(() => {
		if (!isLayoutMode || !draggedCardId) return;

		const resolveHoverTargets = (x, y) => {
			if (typeof x !== "number" || typeof y !== "number") return;
			const resolvedCategoryId = resolveHospitalCategoryIdUnderPointer(x, y);
			const overStandalone =
				!resolvedCategoryId && pointerOverHospitalRootStandaloneArea({ x, y });

			setHoveredCategoryId((prev) => (prev === resolvedCategoryId ? prev : resolvedCategoryId));
			setHoveredStandalone((prev) => (prev === overStandalone ? prev : overStandalone));
		};

		// While the cursor sits in the auto-scroll trigger zone (top/bottom edge),
		// skip the heavy hover resolution. This app uses React 17 (legacy
		// `ReactDOM.render`), so renders are synchronous and any state change here
		// blocks the main thread — including the auto-scroll's own rAF tick. The
		// user isn't deciding a drop target while at the edge anyway; they're
		// positioning. The drop handler re-resolves the target from the release
		// point geometrically, so dropping while still in the zone is unaffected.
		const AUTOSCROLL_ZONE_PX = 160;
		const inAutoScrollZone = (y) => {
			if (typeof y !== "number" || typeof window === "undefined") return false;
			return y < AUTOSCROLL_ZONE_PX || y > window.innerHeight - AUTOSCROLL_ZONE_PX;
		};

		const track = (e) => {
			const clientX = e.touches?.[0]?.clientX ?? e.clientX;
			const clientY = e.touches?.[0]?.clientY ?? e.clientY;
			if (typeof clientX !== "number" || typeof clientY !== "number") return;
			lastPointerRef.current = { x: clientX, y: clientY, timestamp: Date.now() };
			if (inAutoScrollZone(clientY)) return;
			resolveHoverTargets(clientX, clientY);
		};
		document.addEventListener("mousemove", track, { passive: true, capture: true });
		document.addEventListener("touchmove", track, { passive: true, capture: true });
		return () => {
			document.removeEventListener("mousemove", track, true);
			document.removeEventListener("touchmove", track, true);
		};
	}, [isLayoutMode, draggedCardId]);

	useEffect(() => {
		return () => {
			if (dropFlashTimeoutRef.current) {
				clearTimeout(dropFlashTimeoutRef.current);
			}
		};
	}, []);

	useEffect(() => {
		const getAllData = async (filter, skipCache = false) => {
			// Check cache synchronously before resetting locked values
			// Use the same cache key generation logic as getDashboardData
			const mainFilterWithADTAndFacilities = { ...filter, lastADTDate: lastADTDate, facilityIds: activeFacilities };
			const mainCacheKey = generateCacheKey(mainFilterWithADTAndFacilities, false, 'main');

			// Skip cache check if skipCache flag is true
			const hasMainCache = skipCache ? false : !!cachedMainResults[mainCacheKey];

			// Check comparison cache if rangesSet
			const comparisonFilter = rangesSet ? {
				...filterComparison,
				lastADTDate: lastADTDate,
				facilityIds: activeFacilitiesComparison,
				startDate: comparisonRanges?.[0]?.startDate,
				endDate: comparisonRanges?.[0]?.endDate,
			} : null;
			const comparisonCacheKey = comparisonFilter ? generateCacheKey(comparisonFilter, true, 'comparisonFromDialog') : null;
			const hasComparisonCache = skipCache ? false : (comparisonCacheKey ? !!cachedComparisonResults[comparisonCacheKey] : false);

			// Only reset locked values if data is NOT from cache (either main or comparison)
			if (!hasMainCache && !hasComparisonCache) {
				batch(() => {
					dispatch(setLockTotal(null));
					dispatch(setLockedTotalBy(null));
				});
			}

			getDashboardData(filter, skipCache)
		};

		const isInitialRender = isInitialDataFetchRef.current;

		if (
			(!skipMainFetch || enableComparisonFetch) &&
			(isDateUpdated || refetchComparison) &&
			filter &&
			filter.startDate &&
			facilityIdFromHook &&
			activeFacilities.length > 0
		) {
			const shouldSkipCache = !isInitialRender && prevIsCustomTabAddedRef.current !== isCustomTabAdded;
			const mainFilterWithFacilities = {
				...filter,
				lastADTDate: lastADTDate,
				facilityIds: activeFacilities,
			};
			const mainCacheKey = generateCacheKey(mainFilterWithFacilities, false, "main");
			const comparisonFilter = rangesSet
				? {
					...filterComparison,
					lastADTDate: lastADTDate,
					facilityIds: activeFacilitiesComparison,
					startDate: comparisonRanges?.[0]?.startDate,
					endDate: comparisonRanges?.[0]?.endDate,
				}
				: null;
			const comparisonCacheKey = comparisonFilter
				? generateCacheKey(comparisonFilter, true, "comparisonFromDialog")
				: "__no_comparison_cache_key__";
			const requestSignature = `${mainCacheKey}|cmp:${comparisonCacheKey}|customTab:${String(
				isCustomTabAdded
			)}|skip:${String(shouldSkipCache)}|refetchCmp:${String(refetchComparison)}`;

			// Guard against rerender-driven effect runs where effective fetch inputs didn't change.
			if (lastMainFetchSignatureRef.current === requestSignature) {
				return;
			}
			lastMainFetchSignatureRef.current = requestSignature;

			getAllData({ ...filter, facilityIds: activeFacilities }, shouldSkipCache);
			prevIsCustomTabAddedRef.current = isCustomTabAdded;

			// Mark that this useEffect has run at least once
			if (isInitialDataFetchRef.current) {
				isInitialDataFetchRef.current = false;
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filter, filterComparison, activeFacilityLocalStorage, isCustomTabAdded, comparisonRanges]);

	useEffect(() => {
		updateTotalToDBFilter(patientList);
		rangesSet && updateTotalToDBFilter(patientListComparison, undefined, true);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [mainNumPercentage, lockedTotal, patientList, rangesSet, projectionDays, percentageAgainst]);

	useEffect(() => {
		updateTotalToDBFilter(patientList);
		rangesSet && updateTotalToDBFilter(patientListComparison, undefined, true);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [patientList, patientListComparison, rangesSet, transferType, projectionDays]);

	const reloadAdmissionFilter = useCallback(
		async (latestPriorityData, latestDefaultADTData) => {
			const dataFilters = await updateFilterListDataBoth(
				patientList,
				cardFilter,
				transferType,
				latestPriorityData,
				latestDefaultADTData,
				false,
				defaultCardEdited
			);
			let latestPatientList = dataFilters.patientList;
			setFilterListData((prevState) => ({
				...prevState,
				...latestPatientList,
			}));
			dispatch(setSelectedADTTableData(dataFilters.adtList));
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[patientList, cardFilter, transferType, selectedADTTableData, dispatch, projectionDays]
	);

	const updateTotalToDBFilter = async (res, defaultADTDataRes, forComparison) => {
		let defaultADTDataResData = defaultADTDataRes
			? defaultADTDataRes
			: forComparison
				? defaultADTDataComparison
				: defaultADTData;

		const dataFilters = await updateFilterListDataBoth(
			res,
			forComparison ? cardFilterComparison : cardFilter,
			transferType,
			forComparison ? cardFilterComparison?.mainPriorityData : cardFilter.mainPriorityData,
			defaultADTDataResData,
			forComparison,
			defaultCardEdited
		);

		let latestPatientList = dataFilters.patientList;

		forComparison
			? dispatch(setFilterListDataComparison({ ...filterListDataComparison, ...latestPatientList }))
			: setFilterListData((prevState) => ({
				...prevState,
				...latestPatientList,
			}));
		dispatch(
			forComparison
				? setSetSelectedADTTableDataComparison(dataFilters.adtList)
				: setSelectedADTTableData(dataFilters.adtList)
		);
	};

	const getAllADTData = async (filter, { forComparison = false }, updatedPatientListNew) => {
		dispatch(setIsAdtLoading(true));
		allADTData(filter, forComparison ? "comparison" : "main")
			.then(async (res) => {
				dispatch(setIsAdtLoading(false));
				if (res && res.list) {
					if (forComparison) {
						const defaultListFilterData = await getADTDataDefault(res, cardFilterComparison.adtData, forComparison);
						dispatch(setDefaultADTDataComparison(defaultListFilterData));
						let updatedPatientListLatest = {
							...updatedPatientListNew,
							adtList: res,
							...(res.customCombineTabData != null && { customCombineTabData: res.customCombineTabData }),
							...(res.customDiffrentDashboardData != null && { customDiffrentDashboardData: res.customDiffrentDashboardData }),
						};
						dispatch(setPatientListComparison(updatedPatientListLatest));
						await updateTotalToDBFilter(updatedPatientListLatest, defaultListFilterData, forComparison);
					} else {

						const defaultListFilterData = await getADTDataDefault(res, cardFilter.adtData);
						dispatch(setDefaultADTData(defaultListFilterData));
						let updatedPatientListLatest = {
							...updatedPatientListNew,
							adtList: res,
							...(res.customCombineTabData != null && { customCombineTabData: res.customCombineTabData }),
							...(res.customDiffrentDashboardData != null && { customDiffrentDashboardData: res.customDiffrentDashboardData }),
						};
						setPatientList(updatedPatientListLatest);
						await updateTotalToDBFilter(updatedPatientListLatest, defaultListFilterData);
					}
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const defaultFilterData = (forComparison) => {
		if (forComparison) {
			dispatch(setPatientListComparison(DEFAULT_LIST));
			dispatch(setFilterListDataComparison(DEFAULT_CARD_FILTER));
		} else {
			setPatientList(DEFAULT_LIST);
			setFilterListData(DEFAULT_CARD_FILTER);
		}
	}

	// Utility function to generate cache key from filter parameters (including lastADTDate and accountId)
	const generateCacheKey = (filterData, forComparison, type) => {
		const cleanedData = JSON.parse(
			JSON.stringify(filterData, (_key, value) => (value == null ? undefined : value))
		);

		// Sort facilityIds array to ensure consistent cache keys regardless of selection order
		// This is critical when multiple facilities are selected - same facilities in different order should generate same key
		if (cleanedData.facilityIds && Array.isArray(cleanedData.facilityIds)) {
			cleanedData.facilityIds = [...cleanedData.facilityIds].sort((a, b) => {
				const aStr = String(a);
				const bStr = String(b);
				return aStr.localeCompare(bStr);
			});
		}

		const accountId = authUser?.accountId || null;
		return JSON.stringify({ data: cleanedData, type, forComparison, accountId });
	};

	const getDashboardData = async (filter, skipCache = false) => {
		setLoading(true);
		setLoadingComparison(true);
		const currentRequest = uniqueId();
		activeRequestRef.current = currentRequest;

		try {
			// Generate cache keys (including lastADTDate and activeFacilities in the filter)
			const mainFilterWithADTAndFacilities = { ...filter, lastADTDate: lastADTDate, facilityIds: activeFacilities };
			const mainCacheKey = generateCacheKey(mainFilterWithADTAndFacilities, false, 'main');
			const comparisonFilter = rangesSet ? {
				...filterComparison,
				lastADTDate: lastADTDate,
				facilityIds: activeFacilitiesComparison,
				startDate: comparisonRanges?.[0]?.startDate,
				endDate: comparisonRanges?.[0]?.endDate,
			} : null;
			const comparisonCacheKey = comparisonFilter ? generateCacheKey(comparisonFilter, true, 'comparisonFromDialog') : null;

			// Check cache for main result - skip cache if skipCache flag is true
			let mainResult = skipCache ? null : cachedMainResults[mainCacheKey];
			let comparisonResult = skipCache ? null : (comparisonCacheKey ? cachedComparisonResults[comparisonCacheKey] : null);

			// Track if data came from cache (both main and comparison)
			const isFromCache = !!mainResult || !!comparisonResult;
			setIsDataFromCache(isFromCache);

			// Fetch from API if not in cache
			const fetchPromises = [];

			if (!mainResult) {
				fetchPromises.push(getAllAdmissionsPatient(mainFilterWithADTAndFacilities, false, "main"));
			} else {
				fetchPromises.push(Promise.resolve(mainResult));
			}

			if (rangesSet) {
				if (!comparisonResult) {
					fetchPromises.push(getAllAdmissionsPatient(comparisonFilter, true, "comparisonFromDialog"));
				} else {
					fetchPromises.push(Promise.resolve(comparisonResult));
				}
			} else {
				fetchPromises.push(Promise.resolve(null));
			}

			const [fetchedMainResult, fetchedComparisonResult] = await Promise.all(fetchPromises);

			// Update main result - use cached if available, otherwise use fetched and cache it
			if (!mainResult) {
				mainResult = fetchedMainResult;
				// Clear old cache before saving new cache
				dispatch(clearCachedResults('main'));
				// Save to cache
				if (mainResult) {
					dispatch(setCachedMainResult({ filterKey: mainCacheKey, result: mainResult }));
				}
			} else {
				mainResult = fetchedMainResult; // Use cached result (resolved from promise)
			}

			// Update comparison result - use cached if available, otherwise use fetched and cache it
			if (rangesSet) {
				if (!comparisonResult) {
					comparisonResult = fetchedComparisonResult;
					// Clear old cache before saving new cache
					dispatch(clearCachedResults('comparison'));
					// Save to cache
					if (comparisonResult) {
						dispatch(setCachedComparisonResult({ filterKey: comparisonCacheKey, result: comparisonResult }));
					}
				} else {
					comparisonResult = fetchedComparisonResult; // Use cached result (resolved from promise)
				}
			}

			if (activeRequestRef.current !== currentRequest) return;

			if (mainResult && mainResult.list) {

				await updateTotalToDBFilter({ ...patientList, list: mainResult.list });
				const updatedPatientList = {
					...patientList,
					list: mainResult.list,
					customTabs: mainResult.customTabs,
					allPagesCustomTabs: mainResult.allPagesCustomTabs ?? {},
					diffDashboardPatients: mainResult.diffDashboardPatients,
					customCombineTabData: mainResult.customCombineTabData
				};
				setPatientList({ ...updatedPatientList })
				if (cardFilter && cardFilter.adtData.length > 0) {

					await handleOnClickRun(updatedPatientList, false);
				}
			} else {
				defaultFilterData(false)
			}

			if (comparisonResult && comparisonResult.list) {
				const defaultListFilterData = await getADTDataDefault(comparisonResult, cardFilter.adtData, true);
				await updateTotalToDBFilter({ ...patientListComparison, list: comparisonResult.list }, defaultListFilterData, true);
				const updatedPatientList = {
					...patientListComparison,
					list: comparisonResult.list,
					customTabs: comparisonResult.customTabs,
					allPagesCustomTabs: comparisonResult?.allPagesCustomTabs ?? {},
					diffDashboardPatients: comparisonResult?.diffDashboardPatients ?? [],
					customCombineTabData: comparisonResult?.customCombineTabData ?? []
				};
				dispatch(setPatientListComparison({ ...updatedPatientList }))
				if (cardFilter && cardFilter.adtData.length > 0) {
					await handleOnClickRun(updatedPatientList, true);
				}
			} else {
				defaultFilterData(true);
			}

		} catch (e) {
			if (activeRequestRef.current !== currentRequest) return;
			if (e?.message !== "canceled") {
				setLoading(false);
				setLoadingComparison(false);
				dispatch(setRefetchComparison(false));
				if (admissionLoading) {
					dispatch(setAdmissionLoading(false));
				}
			}
		} finally {
			if (activeRequestRef.current === currentRequest) {
				setLoading(false);
				setLoadingComparison(false);
				dispatch(setRefetchComparison(false));
				if (admissionLoading) {
					dispatch(setAdmissionLoading(false));
				}
			}
		}
	};

	const handleToggle = useCallback(
		async ({ item, itemComparison, type: typeData, cardTitle, question, isSpacialItem = false }) => {
			triggerFilterTutorial();
			if (item) {
				let type = typeData;
				if (isSpacialItem) {
					type = `${type}_spacial`;
				}
				// For custom tabs (both customTab and combineTab) with duplicate titles, use composite key (accessor__uniqueKey) instead of item._id
				// This allows multiple selections of the same dashboard
				const value = question?.compositeKey || item._id;

				// For composite keys (both customTab and combineTab), get patientIds from the specific totalByPage entry using uniqueKey
				// This ensures we use the correct patientIds for each specific item, not the mutated data[0]
				// For combineTab: always has totalByPage with entries like hospital_0, admission_3, etc.
				// For customTab: may or may not have totalByPage depending on structure
				let patientIds = item?.patientIds ?? [];
				if (question?.compositeKey && question?.uniqueKey && item?.totalByPage) {
					// Get patientIds from the specific totalByPage entry for this uniqueKey
					// Works for both combineTab (always has totalByPage) and customTab (if it has totalByPage)
					const specificItem = item.totalByPage[question.uniqueKey];
					if (specificItem && specificItem.patientIds) {
						patientIds = specificItem.patientIds;
					}
				}
				// If no totalByPage or no specific entry found, patientIds already set to item?.patientIds above

				// Get patientIds from comparison data for comparison filter
				// Use itemComparison if provided, otherwise find it in filterListDataComparison
				// This works for both customTab and combineTab
				let patientIdsComparison = [];
				if (rangesSet) {
					let comparisonItem = itemComparison;

					// If itemComparison not provided, try to find it
					if (!comparisonItem && filterListDataComparison && question?.accessor) {
						// Try to find by accessor and id/_id match first
						comparisonItem = filterListDataComparison[question.accessor]?.find(
							(compItem) => compItem?.id === item?.id || compItem?._id === item?._id
						);

						// If not found by id match, try using the first item from the accessor array
						if (!comparisonItem) {
							comparisonItem = filterListDataComparison[question.accessor]?.[0];
						}
					}

					if (comparisonItem) {
						// For composite keys (both customTab and combineTab), get patientIds from the specific totalByPage entry in comparison data
						// This is the most important part - we need the specific entry's patientIds, not the main item's
						// For combineTab: always has totalByPage, so we get from specific entry
						// For customTab: if it has totalByPage, get from specific entry; otherwise use main item's patientIds
						if (question?.compositeKey && question?.uniqueKey && comparisonItem?.totalByPage) {
							const specificComparisonItem = comparisonItem.totalByPage[question.uniqueKey];
							if (specificComparisonItem && specificComparisonItem.patientIds) {
								patientIdsComparison = specificComparisonItem.patientIds;
							} else {
								// Fallback to main comparison item's patientIds if specific entry not found
								patientIdsComparison = comparisonItem?.patientIds ?? [];
							}
						} else {
							// For non-composite keys or customTab without totalByPage, use the main comparison item's patientIds
							patientIdsComparison = comparisonItem?.patientIds ?? [];
						}
					}
				}

				const filtersItem = { ...cardFilter };
				if (filtersItem[type] === undefined) {
					filtersItem[type] = [];
				}

				const filterData = filtersItem[type];

				// Check if this specific composite key is already selected
				// For composite keys, check for the composite key; for regular items, check for item._id
				let currentIndex = -1;
				if (question?.compositeKey) {
					// Check for composite key first
					currentIndex = filterData?.indexOf(question.compositeKey);
					// If not found and we have an old format entry (item._id), we'll handle it below
				} else {
					// For non-composite keys, check normally
					currentIndex = filterData?.indexOf(value);
				}

				const newChecked = filterData ? [...filterData] : [];
				let isRemoveIds = false;
				let isReplaceIds = false;

				if (currentIndex === -1) {
					// Adding new selection - push the composite key or item._id
					newChecked.push(value);
					// If we're adding a composite key and there's an old format entry (item._id), remove it
					// This ensures we don't have both old and new format in the array
					if (question?.compositeKey) {
						const oldFormatIndex = newChecked.indexOf(item._id);
						if (oldFormatIndex !== -1) {
							newChecked.splice(oldFormatIndex, 1);
						}
					}
				} else {
					// Removing selection
					isRemoveIds = true;
					newChecked.splice(currentIndex, 1);

					// For composite keys (both customTab and combineTab), when unselecting, recalculate patientIds from all remaining selected items
					// This ensures we have the correct combined patientIds from all remaining selections
					if (question?.compositeKey && newChecked.length > 0) {
						// Recalculate patientIds from all remaining selected composite keys
						// Works for both combineTab (has totalByPage) and customTab (may or may not have totalByPage)
						const remainingPatientIds = [];
						const remainingPatientIdsComparison = [];

						// Get comparison item for recalculating comparison patientIds
						let comparisonItem = itemComparison;
						if (!comparisonItem && filterListDataComparison && question?.accessor) {
							comparisonItem = filterListDataComparison[question.accessor]?.find(
								(compItem) => compItem?.id === item?.id || compItem?._id === item?._id
							);
							if (!comparisonItem) {
								comparisonItem = filterListDataComparison[question.accessor]?.[0];
							}
						}

						newChecked.forEach(selectedKey => {
							// Check if it's a composite key (format: accessor__uniqueKey)
							if (selectedKey.includes('__')) {
								const [, uniqueKey] = selectedKey.split('__');

								// For main data: get from totalByPage if it exists (combineTab or customTab with totalByPage)
								if (item?.totalByPage) {
									const specificItem = item.totalByPage[uniqueKey];
									if (specificItem && specificItem.patientIds) {
										remainingPatientIds.push(...specificItem.patientIds);
									}
								} else {
									// For customTab without totalByPage, use item.patientIds
									if (item.patientIds) {
										remainingPatientIds.push(...item.patientIds);
									}
								}

								// For comparison data: get from totalByPage if it exists
								if (rangesSet && comparisonItem) {
									if (comparisonItem?.totalByPage) {
										const specificComparisonItem = comparisonItem.totalByPage[uniqueKey];
										if (specificComparisonItem && specificComparisonItem.patientIds) {
											remainingPatientIdsComparison.push(...specificComparisonItem.patientIds);
										}
									} else {
										// For customTab without totalByPage, use comparisonItem.patientIds
										if (comparisonItem.patientIds) {
											remainingPatientIdsComparison.push(...comparisonItem.patientIds);
										}
									}
								}
							} else {
								// Old format - use item.patientIds
								if (item.patientIds) {
									remainingPatientIds.push(...item.patientIds);
								}
								// For comparison data
								if (rangesSet && comparisonItem?.patientIds) {
									remainingPatientIdsComparison.push(...comparisonItem.patientIds);
								}
							}
						});

						// Use union to combine and deduplicate patientIds from all remaining selections
						patientIds = _.union(remainingPatientIds);
						if (rangesSet) {
							patientIdsComparison = _.union(remainingPatientIdsComparison);
						}
						// Since we've recalculated, we should replace the entire patientIds array
						isReplaceIds = true;
						isRemoveIds = false;
					}
				}
				if (!isSpacialItem) {
					const [mainPriorityData, mainPriorityDataComparison] = await Promise.all([
						admissionPriorityFilter(
							cardFilter.mainPriorityData,
							{ type },
							newChecked.length,
							ADMISSION_FILTER_TYPE.ADMISSION,
							cardTitle,
							question,
							patientIds,
							isRemoveIds,
							newChecked,
							isReplaceIds
						),
						rangesSet
							? admissionPriorityFilter(
								cardFilterComparison?.mainPriorityData,
								{ type },
								newChecked.length,
								ADMISSION_FILTER_TYPE.ADMISSION,
								cardTitle,
								question,
								patientIdsComparison.length > 0 ? patientIdsComparison : patientIds,
								isRemoveIds,
								newChecked,
								isReplaceIds
							)
							: undefined,
					]);

					const [dataFilters, dataFiltersComparison] = await Promise.all([
						updateFilterListDataBoth(
							patientList,
							{ ...cardFilter, [type]: newChecked },
							transferType,
							mainPriorityData,
							defaultADTData,
							false,
							defaultCardEdited
						),
						rangesSet
							? updateFilterListDataBoth(
								patientListComparison,
								{ ...cardFilterComparison, [type]: newChecked },
								transferTypeComparison,
								mainPriorityDataComparison,
								defaultADTDataComparison,
								true,
								defaultCardEdited
							)
							: undefined,
					]);

					const latestPatientList = dataFilters.patientList;
					const latestPatientListComparison = dataFiltersComparison?.patientList;

					setFilterListData((prevState) => {
						return {
							...prevState,
							...latestPatientList,
						};
					});

					batch(() => {
						if (rangesSet) {
							const updatedFilterListData = { ...filterListDataComparison, ...latestPatientListComparison };
							dispatch(setFilterListDataComparison(updatedFilterListData));
						}

						dispatch(setSelectedADTTableData(dataFilters.adtList));
						rangesSet && dispatch(setSetSelectedADTTableDataComparison(dataFiltersComparison?.adtList));

						dispatch(
							setCardFilter({
								[type]: newChecked,
								mainPriorityData: mainPriorityData,
							})
						);
						rangesSet &&
							dispatch(
								setCardFilterComparison({
									[type]: newChecked,
									mainPriorityData: mainPriorityDataComparison,
								})
							);
					});
				} else {
					batch(() => {
						const updatedFilter = { [type]: newChecked };

						dispatch(setCardFilter(updatedFilter));

						if (rangesSet) {
							dispatch(setCardFilterComparison(updatedFilter));
						}
					});
				}
			}
		},
		[
			cardFilter,
			rangesSet,
			cardFilterComparison,
			patientList,
			transferType,
			defaultADTData,
			patientListComparison,
			transferTypeComparison,
			defaultADTDataComparison,
			dispatch,
			filterListDataComparison,
			triggerFilterTutorial,
			defaultCardEdited,
		]
	);

	const handleToggleAll = useCallback(async ({ items, type, cardTitle = null }) => {
		triggerFilterTutorial();
		const filtersItem = cardFilter;
		const filterData = filtersItem[type];
		const itemIds = items.map((x) => x._id);
		const valuesAlreadyInFilterData = itemIds.every((x) => filterData.includes(x));
		let newChecked = [];
		if (valuesAlreadyInFilterData) {
			newChecked = filterData.filter((x) => !itemIds.some((y) => y === x));
		} else {
			newChecked = [...filterData, ...itemIds];
		}

		const [mainPriorityData, mainPriorityDataComparison] = await Promise.all([
			admissionPriorityFilter(
				cardFilter.mainPriorityData,
				{ type },
				newChecked.length,
				ADMISSION_FILTER_TYPE.ADMISSION,
				cardTitle
			),
			rangesSet
				? admissionPriorityFilter(
					cardFilterComparison?.mainPriorityData,
					{ type },
					newChecked.length,
					ADMISSION_FILTER_TYPE.ADMISSION,
					cardTitle
				)
				: undefined,
		]);

		const [dataFilters, dataFiltersComparison] = await Promise.all([
			updateFilterListDataBoth(
				patientList,
				{ ...cardFilter, [type]: newChecked },
				transferType,
				mainPriorityData,
				defaultADTData,
				false,
				defaultCardEdited
			),
			rangesSet
				? updateFilterListDataBoth(
					patientListComparison,
					{ ...cardFilterComparison, [type]: newChecked },
					transferTypeComparison,
					mainPriorityDataComparison,
					defaultADTDataComparison,
					true,
					defaultCardEdited
				)
				: undefined,
		]);

		const latestPatientList = dataFilters.patientList;
		const latestPatientListComparison = dataFiltersComparison?.patientList;

		setFilterListData((prevState) => {
			return {
				...prevState,
				...latestPatientList,
			};
		});

		if (rangesSet) {
			const updatedFilterListData = { ...filterListDataComparison, ...latestPatientListComparison };
			dispatch(setFilterListDataComparison(updatedFilterListData));
		}

		dispatch(setSelectedADTTableData(dataFilters.adtList));
		rangesSet && dispatch(setSetSelectedADTTableDataComparison(dataFiltersComparison?.adtList));

		dispatch(
			setCardFilter({
				[type]: newChecked,
				mainPriorityData: mainPriorityData,
			})
		);
		rangesSet &&
			dispatch(
				setCardFilterComparison({
					[type]: newChecked,
					mainPriorityData: mainPriorityDataComparison,
				})
			);
	}, [
		cardFilter,
		rangesSet,
		cardFilterComparison,
		patientList,
		transferType,
		defaultADTData,
		patientListComparison,
		transferTypeComparison,
		defaultADTDataComparison,
		dispatch,
		filterListDataComparison,
		triggerFilterTutorial,
		defaultCardEdited,
	]);

	// AI Filter Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		// Create a callback that triggers data refresh when filter is applied
		const onFilterApplied = () => {
			setIsDateUpdated(true);
		};

		aiFilterActionsService.initialize(
			dispatch,
			() => ({
				admission: {
					filterListData,
					cardFilter,
					dynamicCards, // CRITICAL: Pass dynamicCards so AI can access custom/dynamic filters
					patientList   // CRITICAL: Pass patientList so AI can access customTabs
				}
			}),
			handleToggle,
			handleToggleAll,
			onFilterApplied
		);

	}, [dispatch, filterListData, cardFilter, dynamicCards, patientList, handleToggle, handleToggleAll]);
	*/

	const handleToggleADTTab = async ({
		savedData,
		savedDataComparison,
		selectedTransferIds,
		selectedTransferIdsComparison,
		item,
		itemComparison = null,
		parentItem,
		parentItemComparison = {},
		total,
		selectedIds,
		isChecked,
		/** When set for ADT combine-tab slices: 1 = lock+, -1 = lock−, 0 = leave lock unchanged */
		combineAdtLockDelta,
		isSpacialItem = false
	}) => {
		triggerFilterTutorial();
		let adtAdmitPatientIds = cardFilter.adtAdmitPatientIds.length > 0 ? cardFilter.adtAdmitPatientIds : [];
		let adtAdmitPatientIdsComparison =
			cardFilterComparison.adtAdmitPatientIds.length > 0 ? cardFilterComparison.adtAdmitPatientIds : [];

		const { childId, cardId, subTitle, relation } = parentItem;
		const {
			childId: childIdComparison,
			cardId: cardIdComparison,
			subTitle: subTitleComparison,
			relation: relationComparison,
		} = parentItemComparison;
		const type = item?.type;
		const element = item?.element || item;
		let typeComparison;
		let elementComparison;
		if (itemComparison) {
			typeComparison = itemComparison?.typeComparison || itemComparison?.type;
			elementComparison = itemComparison?.elementComparison || itemComparison;
		}

		//const { type: typeComparison, element: elementComparison } = itemComparison;
		const selectedData = _.find(adtAdmitPatientIds, {
			id: childId,
			cardId: cardId,
		});

		const selectedDataComparison = _.find(adtAdmitPatientIdsComparison, {
			id: childIdComparison,
			cardId: cardIdComparison,
		});
		let latestAdmitFilters = [];
		let latestAdmitFiltersComparison = [];

		if (selectedData) {
			if (savedData.length > 0) {
				latestAdmitFilters = await update(adtAdmitPatientIds, {
					$set: adtAdmitPatientIds.map((elem) => {
						if (elem.id === childId) {
							return {
								...elem,
								ids: savedData,
								admissionIds: savedData,
								...!isSpacialItem && { selectedIds: selectedIds },
								...isSpacialItem && { selectedSpecialIds: selectedIds },
								transferIds: selectedTransferIds,
								total,
							};
						} else {
							return elem;
						}
					}),
				});
			} else {
				latestAdmitFilters = await update(adtAdmitPatientIds, {
					$splice: [[adtAdmitPatientIds.indexOf(selectedData), 1]],
				});
			}
		} else {
			let adtFilterObj = new Object();
			adtFilterObj.id = childId;
			adtFilterObj.cardId = cardId;
			adtFilterObj.childId = childId;
			adtFilterObj.label = subTitle;
			adtFilterObj.total = total;
			adtFilterObj.ids = savedData;
			adtFilterObj.admissionIds = savedData;
			adtFilterObj.transferIds = selectedTransferIds;
			adtFilterObj.type = type;
			adtFilterObj.isSpacialItem = isSpacialItem || false;

			adtFilterObj.relation = relation;
			adtFilterObj.selectedIds = !isSpacialItem ? selectedIds : [];
			adtFilterObj.selectedSpecialIds = isSpacialItem ? selectedIds : [];
			latestAdmitFilters = await update(adtAdmitPatientIds, {
				$push: [
					{
						...adtFilterObj,
						...element,
						...parentItem,
						ids: savedData,
						admissionIds: savedData,
						transferIds: selectedTransferIds,
					},
				],
			});
		}

		if (selectedDataComparison) {
			if (savedDataComparison.length > 0) {
				latestAdmitFiltersComparison = await update(adtAdmitPatientIdsComparison, {
					$set: adtAdmitPatientIdsComparison.map((elem) => {
						if (elem.id === childId) {
							return {
								...elem,
								ids: savedDataComparison,
								admissionIds: savedDataComparison,
								...!isSpacialItem && { selectedIds: selectedIds },
								...isSpacialItem && { selectedSpecialIds: selectedIds },
								transferIds: selectedTransferIdsComparison,
								total,
							};
						} else {
							return elem;
						}
					}),
				});
			} else {
				latestAdmitFiltersComparison = await update(adtAdmitPatientIdsComparison, {
					$splice: [[adtAdmitPatientIdsComparison.indexOf(selectedDataComparison), 1]],
				});
			}
		} else {
			let adtFilterObjComparison = new Object();
			adtFilterObjComparison.id = childIdComparison;
			adtFilterObjComparison.cardId = cardIdComparison;
			adtFilterObjComparison.childId = childIdComparison;
			adtFilterObjComparison.label = subTitleComparison;
			adtFilterObjComparison.total = total;
			adtFilterObjComparison.ids = savedDataComparison;
			adtFilterObjComparison.admissionIds = savedDataComparison;
			adtFilterObjComparison.transferIds = selectedTransferIdsComparison;
			adtFilterObjComparison.type = typeComparison;
			adtFilterObjComparison.isSpacialItem = isSpacialItem;
			adtFilterObjComparison.relation = relationComparison;
			adtFilterObjComparison.selectedIds = !isSpacialItem ? selectedIds : [];
			adtFilterObjComparison.selectedSpecialIds = isSpacialItem ? selectedIds : [];

			latestAdmitFiltersComparison = await update(adtAdmitPatientIdsComparison, {
				$push: [
					{
						...adtFilterObjComparison,
						...elementComparison,
						...parentItemComparison,
						ids: savedDataComparison,
						admissionIds: savedDataComparison,
						transferIds: selectedTransferIdsComparison,
					},
				],
			});
		}

		let mainPriorityData = await admissionPriorityFilter(
			cardFilter.mainPriorityData,
			{ childId, cardId },
			latestAdmitFilters,
			ADMISSION_FILTER_TYPE.ADT
		);

		let mainPriorityDataComparison = await admissionPriorityFilter(
			cardFilterComparison.mainPriorityData,
			{ childId: childIdComparison, cardId: cardIdComparison },
			latestAdmitFiltersComparison,
			ADMISSION_FILTER_TYPE.ADT
		);

		const combineAccessorSync =
			parentItem?.customTab?.type === CUSTOM_TAB_TYPE.combineTab ? parentItem?.accessor : null;
		const adtEntryAfter = combineAccessorSync
			? _.find(latestAdmitFilters, { id: childId, cardId })
			: null;
		const comparisonAccessorSync =
			(parentItemComparison?.customTab?.type === CUSTOM_TAB_TYPE.combineTab
				? parentItemComparison?.accessor
				: null) || combineAccessorSync;
		const adtEntryComparisonAfter =
			comparisonAccessorSync && childIdComparison != null && cardIdComparison != null
				? _.find(latestAdmitFiltersComparison, {
					id: childIdComparison,
					cardId: cardIdComparison,
				})
				: null;
		const combineCardFilterPatch =
			combineAccessorSync != null
				? { [combineAccessorSync]: adtEntryAfter?.selectedIds ?? [] }
				: {};
		const combineCardFilterComparisonPatch =
			comparisonAccessorSync != null &&
				childIdComparison != null &&
				cardIdComparison != null
				? { [comparisonAccessorSync]: adtEntryComparisonAfter?.selectedIds ?? [] }
				: {};

		if (isSpacialItem) {
			dispatch(
				setCardFilterComparison({
					adtAdmitPatientIds: latestAdmitFiltersComparison,
					mainPriorityData: mainPriorityDataComparison,
					...combineCardFilterComparisonPatch,
				})
			);
			dispatch(
				setCardFilter({
					adtAdmitPatientIds: latestAdmitFilters,
					mainPriorityData: mainPriorityData,
					...combineCardFilterPatch,
				})
			);
			return true;
		}

		const useCombineLock =
			parentItem?.customTab?.type === CUSTOM_TAB_TYPE.combineTab &&
			combineAdtLockDelta !== undefined &&
			combineAdtLockDelta !== null;
		const shouldBumpLock = useCombineLock ? combineAdtLockDelta > 0 : !isChecked;
		const shouldDropLock = useCombineLock ? combineAdtLockDelta < 0 : isChecked;

		if (useCombineLock && combineAdtLockDelta === 0) {
			// Adding/removing a slice while other slices stay selected — do not change lock totals
		} else if (shouldBumpLock) {
			const lockedFilterTotal =
				lockFilterTotalState.count === 0 ? dbData?.bedCapacity : lockFilterTotalState.lockedFilterTotal;
			// dispatch(setReversedColorAdmission(false));
			const lockedFilterTotalComparison =
				lockFilterTotalStateComparison.count === 0
					? dbDataComparison?.bedCapacity
					: lockFilterTotalStateComparison.lockedFilterTotal;
			dispatch(
				setLockFilterTotalState({
					count: lockFilterTotalState.count + 1,
					isLocked: true,
					lockedFilterTotal,
				})
			);
			dispatch(
				setLockFilterTotalStateComparison({
					count: lockFilterTotalStateComparison.count + 1,
					isLocked: true,
					lockedFilterTotal: lockedFilterTotalComparison,
				})
			);
		} else if (shouldDropLock) {
			const newCount = lockFilterTotalState.count - 1;
			const isLocked = newCount !== 0;
			const newCountComparison = lockFilterTotalStateComparison.count - 1;
			const isLockedComparison = newCountComparison !== 0;
			dispatch(setReversedColorAdmission(true));
			dispatch(
				setLockFilterTotalState({
					...lockFilterTotalState,
					count: lockFilterTotalState.count - 1,
					isLocked,
				})
			);
			dispatch(
				setLockFilterTotalStateComparison({
					...lockFilterTotalStateComparison,
					count: lockFilterTotalStateComparison.count - 1,
					isLocked: isLockedComparison,
				})
			);
		}

		const dataFilters = await updateFilterListDataBoth(
			patientList,
			{ ...cardFilter },
			transferType,
			mainPriorityData,
			defaultADTData,
			false,
			defaultCardEdited
		);
		const dataFiltersComparison = await updateFilterListDataBoth(
			patientListComparison,
			{ ...cardFilterComparison },
			transferTypeComparison,
			mainPriorityDataComparison,
			defaultADTDataComparison,
			true,
			defaultCardEdited
		);

		let latestPatientList = dataFilters.patientList;
		let latestPatientListComparison = dataFiltersComparison.patientList;

		dispatch(
			setFilterListDataComparison({
				...filterListDataComparison,
				...latestPatientListComparison,
			})
		);
		setFilterListData((prevState) => ({
			...prevState,
			...latestPatientList,
		}));

		dispatch(setSetSelectedADTTableDataComparison(dataFiltersComparison.adtList));
		dispatch(setSelectedADTTableData(dataFilters.adtList));

		dispatch(
			setCardFilterComparison({
				adtAdmitPatientIds: latestAdmitFiltersComparison,
				mainPriorityData: mainPriorityDataComparison,
				...combineCardFilterComparisonPatch,
			})
		);
		dispatch(
			setCardFilter({
				adtAdmitPatientIds: latestAdmitFilters,
				mainPriorityData: mainPriorityData,
				...combineCardFilterPatch,
			})
		);
	};

	const handleToggleAllADTTab = async ({
		savedData,
		savedDataComparison,
		selectedTransferIds,
		selectedTransferIdsComparison,
		items,
		itemsComparison = null,
		parentItem,
		parentItemComparison = {},
		total,
		selectedIds,
		isChecked,
		setSelected,
	}) => {
		try {
			triggerFilterTutorial();

			let adtAdmitPatientIds = cardFilter.adtAdmitPatientIds.length > 0 ? cardFilter.adtAdmitPatientIds : [];
			let adtAdmitPatientIdsComparison =
				cardFilterComparison.adtAdmitPatientIds.length > 0 ? cardFilterComparison.adtAdmitPatientIds : [];

			const { childId, cardId, subTitle, relation } = parentItem;
			const {
				childId: childIdComparison,
				cardId: cardIdComparison,
				subTitle: subTitleComparison,
				relation: relationComparison,
			} = parentItemComparison;

			const selectedData = _.find(adtAdmitPatientIds, {
				id: childId,
				cardId: cardId,
			});
			const selectedDataComparison = _.find(adtAdmitPatientIdsComparison, {
				id: childIdComparison,
				cardId: cardIdComparison,
			});
			let latestAdmitFilters = [];
			let latestAdmitFiltersComparison = [];

			if (selectedData) {
				if (savedData.length > 0) {
					latestAdmitFilters = !isChecked
						? []
						: update(adtAdmitPatientIds, {
							$set: adtAdmitPatientIds.map((elem) => {
								if (elem.id === childId) {
									return {
										...elem,
										ids: savedData,
										selectedIds: selectedIds,
										transferIds: selectedTransferIds,
										total,
									};
								} else {
									return elem;
								}
							}),
						});
				} else {
					latestAdmitFilters = !isChecked
						? []
						: await update(adtAdmitPatientIds, {
							$splice: [[adtAdmitPatientIds.indexOf(selectedData), 1]],
						});
				}
			} else {
				items.map((item) => {
					let adtFilterObj = {};
					adtFilterObj.id = childId;
					adtFilterObj.cardId = cardId;
					adtFilterObj.childId = childId;
					adtFilterObj.label = subTitle;
					adtFilterObj.total = total;
					adtFilterObj.ids = savedData;
					adtFilterObj.transferIds = selectedTransferIds;
					adtFilterObj.type = item.type;
					adtFilterObj.relation = relation;
					adtFilterObj.selectedIds = selectedIds;

					latestAdmitFilters = update(adtAdmitPatientIds, {
						$push: [{ ...adtFilterObj, ...item.element, ...parentItem }],
					});
				});
			}

			if (selectedDataComparison) {
				if (savedDataComparison.length > 0) {
					latestAdmitFiltersComparison = update(adtAdmitPatientIdsComparison, {
						$set: adtAdmitPatientIdsComparison.map((elem) => {
							if (elem.id === childId) {
								return {
									...elem,
									ids: savedDataComparison,
									selectedIds: selectedIds,
									transferIds: selectedTransferIdsComparison,
									total,
								};
							} else {
								return elem;
							}
						}),
					});
				} else {
					latestAdmitFiltersComparison = await update(adtAdmitPatientIdsComparison, {
						$splice: [[adtAdmitPatientIdsComparison.indexOf(selectedDataComparison), 1]],
					});
				}
			} else {
				itemsComparison.map((itemComparison) => {
					let adtFilterObjComparison = {};
					adtFilterObjComparison.id = childIdComparison;
					adtFilterObjComparison.cardId = cardIdComparison;
					adtFilterObjComparison.childId = childIdComparison;
					adtFilterObjComparison.label = subTitleComparison;
					adtFilterObjComparison.total = total;
					adtFilterObjComparison.ids = savedDataComparison;
					adtFilterObjComparison.transferIds = selectedTransferIdsComparison;
					adtFilterObjComparison.type = itemComparison.type;
					adtFilterObjComparison.relation = relationComparison;
					adtFilterObjComparison.selectedIds = selectedIds;

					latestAdmitFiltersComparison = update(adtAdmitPatientIdsComparison, {
						$push: [{ ...adtFilterObjComparison, ...itemComparison.element, ...parentItemComparison }],
					});
				});
			}

			let mainPriorityData = await admissionPriorityFilter(
				cardFilter.mainPriorityData,
				{ childId, cardId },
				latestAdmitFilters,
				ADMISSION_FILTER_TYPE.ADT
			);

			let mainPriorityDataComparison = await admissionPriorityFilter(
				cardFilterComparison.mainPriorityData,
				{ childId: childIdComparison, cardId: cardIdComparison },
				latestAdmitFiltersComparison,
				ADMISSION_FILTER_TYPE.ADT
			);

			if (!isChecked) {
				const lockedFilterTotal =
					lockFilterTotalState.count === 0 ? dbData?.bedCapacity : lockFilterTotalState.lockedFilterTotal;
				// dispatch(setReversedColorAdmission(false));
				const lockedFilterTotalComparison =
					lockFilterTotalStateComparison.count === 0
						? dbDataComparison?.bedCapacity
						: lockFilterTotalStateComparison.lockedFilterTotal;
				dispatch(
					setLockFilterTotalState({
						count: lockFilterTotalState.count + 1,
						isLocked: true,
						lockedFilterTotal,
					})
				);
				dispatch(
					setLockFilterTotalStateComparison({
						count: lockFilterTotalStateComparison.count + 1,
						isLocked: true,
						lockedFilterTotal: lockedFilterTotalComparison,
					})
				);
			} else {
				const newCount = lockFilterTotalState.count - 1;
				const isLocked = newCount !== 0;
				const newCountComparison = lockFilterTotalStateComparison.count - 1;
				const isLockedComparison = newCountComparison !== 0;
				dispatch(setReversedColorAdmission(true));
				dispatch(
					setLockFilterTotalState({
						...lockFilterTotalState,
						count: lockFilterTotalState.count - 1,
						isLocked,
					})
				);
				dispatch(
					setLockFilterTotalStateComparison({
						...lockFilterTotalStateComparison,
						count: lockFilterTotalStateComparison.count - 1,
						isLocked: isLockedComparison,
					})
				);
			}

			const dataFilters = await updateFilterListDataBoth(
				patientList,
				{ ...cardFilter },
				transferType,
				mainPriorityData,
				defaultADTData,
				false,
				defaultCardEdited
			);
			const dataFiltersComparison = await updateFilterListDataBoth(
				patientListComparison,
				{ ...cardFilterComparison },
				transferTypeComparison,
				mainPriorityDataComparison,
				defaultADTDataComparison,
				true,
				defaultCardEdited
			);

			let latestPatientList = dataFilters.patientList;
			let latestPatientListComparison = dataFiltersComparison.patientList;

			dispatch(
				setFilterListDataComparison({
					...filterListDataComparison,
					...latestPatientListComparison,
				})
			);
			setFilterListData((prevState) => ({
				...prevState,
				...latestPatientList,
			}));

			dispatch(setSetSelectedADTTableDataComparison(dataFiltersComparison.adtList));
			dispatch(setSelectedADTTableData(dataFilters.adtList));
			dispatch(
				setCardFilterComparison({
					adtAdmitPatientIds: latestAdmitFiltersComparison,
					mainPriorityData: mainPriorityDataComparison,
				})
			);
			dispatch(
				setCardFilter({
					adtAdmitPatientIds: latestAdmitFilters,
					mainPriorityData: mainPriorityData,
				})
			);
		} catch (e) {
			console.log(e);
		}
	};

	handleToggleADTTabRef.current = handleToggleADTTab;
	handleToggleAllADTTabRef.current = handleToggleAllADTTab;

	const handleClickTotal = useCallback(
		(total, totalComparison) => {
			dispatch(setTransferType(transferType === ADMISSION_TYPES.ALL ? null : ADMISSION_TYPES.ALL));
			dispatch(setTransferTypeComparison(transferType === ADMISSION_TYPES.ALL ? null : ADMISSION_TYPES.ALL));
			dispatch(setMainTotal(total));
			dispatch(setMainTotalComparison(totalComparison));
		},
		[dispatch, transferType]
	);

	const handleOnClickRun = useCallback(
		async (updatedPatientList, forComparison) => {
			let isSelectedChildData = false;
			cardFilter.adtData.map((item) => {
				const isChildSelected = _.find(item.children, { isSelected: true });
				if (isChildSelected) {
					isSelectedChildData = true;
				}
			});

			if (isSelectedChildData) {
				const adtFilters = await adtCardFilterParam(cardFilter.adtData);
				const adtFiltersComparison = await adtCardFilterParam(cardFilterComparison?.adtData);
				if (forComparison) {
					let updatedPatientListNew = updatedPatientList ? updatedPatientList : patientListComparison;
					await getAllADTData(
						{ facilityIds: activeFacilities, ...adtFilters, ...filterComparison },
						{
							...filterComparison,
							forComparison,
							facilityIds: activeFacilities,
							...adtFiltersComparison,
						},
						updatedPatientListNew
					);
				} else {
					let updatedPatientListNew = updatedPatientList ? updatedPatientList : patientList;
					await getAllADTData(
						{ ...filter, facilityIds: activeFacilities, ...adtFilters },
						{
							...filterComparison,
							forComparison,
							facilityIds: activeFacilities,
							...adtFiltersComparison,
						},
						updatedPatientListNew
					);
				}
			} else {
				dispatch({
					type: ADD_NOTIFICATION,
					payload: {
						type: "error",
						label: `Please select at least one option`,
						id: "admissionPleaseSelectOne",
					},
				});
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[cardFilter.adtData, dispatch, filter, activeFacilities, filterComparison, patientListComparison]
	);

	// Wrapper function for Transfer Status of Admission section to trigger tutorial on first click
	const handleTransferStatusRun = useCallback(
		async () => {
			// Trigger tutorial on first click
			if (!transferStatusTutorialTriggeredRef.current) {
				transferStatusTutorialTriggeredRef.current = true;

				// Track feature usage
				trackFeatureUsage(TUTORIAL_FEATURES.TRANSFER_STATUS_ADMISSION).catch((error) => {
					console.error('Failed to track tutorial usage:', error);
				});

				// Trigger tutorial
				triggerTutorial(TUTORIAL_FEATURES.TRANSFER_STATUS_ADMISSION).catch((error) => {
					console.error('Failed to trigger tutorial:', error);
				});
			}

			// Call the original handleOnClickRun function
			await handleOnClickRun(patientList);

			// Handle comparison if needed
			if (filterComparison && rangesSet) {
				setTimeout(() => {
					handleOnClickRun(patientListComparison, true);
				}, 2000);
			}
		},
		[handleOnClickRun, patientList, patientListComparison, filterComparison, rangesSet, triggerTutorial, trackFeatureUsage]
	);

	const handleADTTabChartDialog = useCallback(
		async (selectedCardItem, type = null, defaultTab = null, question = null) => {
			let latestCardFilter = await updateADTChartFilter(cardFilter, selectedCardItem);
			let selectedFilterData = [];
			let data;
			if (selectedCardItem?.type === ADT_TABLE_TYPE.ALL || selectedCardItem?.type === ADT_TABLE_TYPE.TOTAL) {
				data = [];
				selectedFilterData = [];
			} else {
				data = selectedCardItem?.tableData || [];
				selectedFilterData = selectedCardItem?.selectedIds;
			}
			if (question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab) {
				const rawFromItem = Array.isArray(selectedFilterData) ? selectedFilterData : [];
				const rawFromAdt =
					rawFromItem.length > 0
						? rawFromItem
						: _.find(cardFilter.adtAdmitPatientIds, {
							id: selectedCardItem?.childId,
							cardId: selectedCardItem?.cardId,
						})?.selectedIds ?? [];
				selectedFilterData = Array.isArray(rawFromAdt)
					? rawFromAdt.map((key) => {
						if (typeof key === "string" && key.includes("__")) {
							const [, uniqueKey] = key.split("__");
							return uniqueKey || key;
						}
						return key;
					})
					: [];
			}
			let patientFilterData = patientList.list;
			if (transferType === ADMISSION_TYPES.ADMISSION || transferType === ADMISSION_TYPES.READMISSION) {
				patientFilterData = _.filter(patientList.list, {
					type: transferType,
				});
			}
			let filterTotalByTransferType = _(patientFilterData)
				.groupBy("facilityId")
				.sortBy((group) => patientFilterData.indexOf(group[0]))
				.map((product) => {
					return {
						id: product[0].facilityId || null,
						total: product.length || 0,
					};
				})
				.value();
			const filters = {
				facilityId: facilityIdFromHook,
				facilityIds: activeFacilities,
				cardFilter: latestCardFilter,
				selectedFilterData,
				type: selectedCardItem,
				filter,
				transferType,
				selectedCardItem,
				relation: selectedCardItem?.relation || null,
				mainPriorityData: cardFilter.mainPriorityData,
				filterTotalByTransferType: filterTotalByTransferType,
				filterSelected:
					cardFilter.mainPriorityData.length > 0 &&
					!_.find(cardFilter.mainPriorityData, {
						childId: selectedCardItem?.childId,
						cardId: selectedCardItem?.cardId,
					}),
				adtFacilityPercentage: adtFacilityPercentage,
				lockedByFacility,
				lockedTotal,
				isCensusTotalLocked: false,
				filterListData,
				selectedADTTableData,
				defaultTab,
				question
			};
			dispatch(
				openADTDetailsDialog({
					isOpen: true,
					selectedCardItem,
					type,
					data,
					filters,
					admissionTotal: filterListData?.admissionTotal || 0,
					dbData,
				})
			);

			// COMPARISON BLOCK
			let latestCardFilterComparison = await updateADTChartFilter(cardFilterComparison, selectedCardItem);
			let selectedFilterDataComparison = [];
			let dataComparison;
			if (selectedCardItem?.type === ADT_TABLE_TYPE.ALL || selectedCardItem?.type === ADT_TABLE_TYPE.TOTAL) {
				dataComparison = [];
				selectedFilterDataComparison = [];
			} else {
				dataComparison = selectedCardItem?.tableData || [];
				selectedFilterDataComparison = selectedCardItem?.selectedIds;
			}
			if (question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab) {
				const rawFromItemC = Array.isArray(selectedFilterDataComparison) ? selectedFilterDataComparison : [];
				const rawFromAdtC =
					rawFromItemC.length > 0
						? rawFromItemC
						: _.find(cardFilterComparison.adtAdmitPatientIds, {
							id: selectedCardItem?.childId,
							cardId: selectedCardItem?.cardId,
						})?.selectedIds ?? [];
				selectedFilterDataComparison = Array.isArray(rawFromAdtC)
					? rawFromAdtC.map((key) => {
						if (typeof key === "string" && key.includes("__")) {
							const [, uniqueKey] = key.split("__");
							return uniqueKey || key;
						}
						return key;
					})
					: [];
			}
			let patientFilterDataComparison = patientListComparison.list;
			if (transferType === ADMISSION_TYPES.ADMISSION || transferType === ADMISSION_TYPES.READMISSION) {
				patientFilterDataComparison = _.filter(patientListComparison.list, {
					type: transferType,
				});
			}
			let filterTotalByTransferTypeComparison = _(patientFilterDataComparison)
				.groupBy("facilityId")
				.sortBy((group) => patientFilterDataComparison.indexOf(group[0]))
				.map((product) => {
					return {
						id: product[0].facilityId || null,
						total: product.length || 0,
					};
				})
				.value();
			const filtersComparison = {
				facilityId: activeFacilitiesComparison[0],
				facilityIds: activeFacilitiesComparison,
				cardFilter: latestCardFilterComparison,
				selectedFilterData:
					question?.customTab?.type === CUSTOM_TAB_TYPE.combineTab
						? selectedFilterDataComparison
						: selectedADTTableDataComparison,
				type: selectedCardItem,
				filter: filterComparison,
				transferType: transferTypeComparison,
				selectedCardItem,
				relation: selectedCardItem?.relation || null,
				mainPriorityData: cardFilterComparison?.mainPriorityData,
				filterTotalByTransferType: filterTotalByTransferTypeComparison,
				filterSelected:
					cardFilterComparison?.mainPriorityData.length > 0 &&
					!_.find(cardFilterComparison?.mainPriorityData, {
						childId: selectedCardItem?.childId,
						cardId: selectedCardItem?.cardId,
					}),
				adtFacilityPercentage: adtFacilityPercentageComparison,
				lockedByFacility: lockedByFacilityComparison,
				lockedTotal: lockedTotalComparison,
				isCensusTotalLocked: false,
			};
			dispatch(
				openADTDetailsDialogComparison({
					isOpen: true,
					selectedCardItem,
					type,
					data: dataComparison,
					filters: filtersComparison,
					admissionTotal: filterListDataComparison?.admissionTotal || 0,
				})
			);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			cardFilter,
			patientList.list,
			transferType,
			activeFacilities,
			filter,
			adtFacilityPercentage,
			lockedByFacility,
			lockedTotal,
			dispatch,
			filterListData.admissionTotal,
			cardFilterComparison,
			patientListComparison.list,
			activeFacilitiesComparison,
			selectedADTTableDataComparison,
			filterComparison,
			transferTypeComparison,
			adtFacilityPercentageComparison,
			lockedByFacilityComparison,
			lockedTotalComparison,
			filterListDataComparison?.admissionTotal,
		]
	);

	const handleChartDialog = useCallback(
		async (title, type, relation = null, isTotalCard = false, defaultTab = null, question = null) => {

			const adtAdmissionResolveContext = {
				transferList: patientList?.adtList?.list ?? [],
				admissionPatientList: patientList?.list ?? [],
				adtCardList: selectedADTTableData ?? [],
			};
			let latestCardFilter = await updateAdmissionChartFilter(cardFilter, type, adtAdmissionResolveContext);
			latestCardFilter = _.omit(latestCardFilter, ["adtData"]);
			let filterSelected =
				(cardFilter.mainPriorityData.length > 0 && cardFilter.mainPriorityData[0]["type"] !== type) ||
				transferType != null;
			if (
				type === ADMISSION_CARDS_TYPE.ADMISSION ||
				type === ADMISSION_CARDS_TYPE.READMISSION ||
				type === ADMISSION_CARDS_TYPE.TOTAL
			) {
				filterSelected = false;
			}

			// Normalize selectedFilterData for combineTab-style custom cards:
			// parent card uses composite keys like `${accessor}__hospital_0`
			// details dialog uses only per-dashboard keys (`hospital_0`, etc.)
			const rawSelectedFilterData = cardFilter[type] || [];
			const selectedFilterData =
				question?.customTab?.type === "combineTab" && Array.isArray(rawSelectedFilterData)
					? rawSelectedFilterData.map((key) => {
						if (typeof key === "string" && key.includes("__")) {
							const [, uniqueKey] = key.split("__");
							return uniqueKey || key;
						}
						return key;
					})
					: rawSelectedFilterData;

			const filters = {
				facilityId: facilityIdFromHook,
				facilityIds: activeFacilities,
				cardFilter: latestCardFilter,
				selectedFilterData,
				type,
				filter,
				relation,
				transferType,
				filterSelected,
				lockedByFacility,
				lockedTotal,
				isCensusTotalLocked,
				isTotalCard,
				selectedADTTableData,
				filterListData,
				defaultTab,
				question,
				cardTitle: title,
				lastADTDate
			};
			let data = [];
			if (
				type === ADMISSION_CARDS_TYPE.ADMISSION ||
				type === ADMISSION_CARDS_TYPE.READMISSION ||
				type === ADMISSION_CARDS_TYPE.TOTAL
			) {
				data = [];
			} else {
				data = filterListData[type];
			}
			const { customRangeCombinedData } = processCustomRangeCombinedData(question, filterListData, type);
			const filtersWithCustomData = {
				...filters,
				customRangeCombinedData
			};
			dispatch(
				openDetailsDialog({
					isOpen: true,
					title,
					type,
					data: data.length > 0 ? data?.filter(item => !item?.isSpacialItem) : [],
					filters: {
						...filtersWithCustomData,
						patientListFromPage: patientList.list, // Pass the full unfiltered patient list
						dynamicCards: dynamicCards, // Pass dynamic cards
						customTabs: patientList.customTabs, // Pass custom tabs
					},
					dbData,
				})
			);

			// COMPARISON ANALOG ------------>
			const adtAdmissionResolveContextComparison = {
				transferList: patientListComparison?.adtList?.list ?? [],
				admissionPatientList: patientListComparison?.list ?? [],
				adtCardList: selectedADTTableDataComparison ?? [],
			};
			let latestCardFilterComparison = await updateAdmissionChartFilter(
				cardFilterComparison,
				type,
				adtAdmissionResolveContextComparison
			);
			latestCardFilterComparison = _.omit(latestCardFilterComparison, ["adtData", "cardFilter.mainPriorityData"]);
			let filterSelectedComparison =
				(cardFilterComparison.mainPriorityData.length > 0 &&
					cardFilterComparison.mainPriorityData[0]["type"] !== type) ||
				transferType != null;
			if (
				type === ADMISSION_CARDS_TYPE.ADMISSION ||
				type === ADMISSION_CARDS_TYPE.READMISSION ||
				type === ADMISSION_CARDS_TYPE.TOTAL
			) {
				filterSelectedComparison = false;
			}

			// Normalize comparison selectedFilterData for combineTab-style custom cards
			const rawSelectedFilterDataComparison = cardFilterComparison[type] || [];
			const selectedFilterDataComparison =
				question?.customTab?.type === "combineTab" && Array.isArray(rawSelectedFilterDataComparison)
					? rawSelectedFilterDataComparison.map((key) => {
						if (typeof key === "string" && key.includes("__")) {
							const [, uniqueKey] = key.split("__");
							return uniqueKey || key;
						}
						return key;
					})
					: rawSelectedFilterDataComparison;

			const filtersComparison = {
				facilityId: activeFacilitiesComparison[0],
				facilityIds: activeFacilitiesComparison,
				cardFilter: latestCardFilterComparison,
				selectedFilterData: selectedFilterDataComparison,
				type,
				filter: filterComparison,
				relation,
				transferType: transferTypeComparison,
				filterSelected: filterSelectedComparison,
				lockedByFacility: lockedByFacilityComparison,
				lockedTotal: lockedTotalComparison,
				isCensusTotalLocked: isCensusTotalLockedComparison,
				lastADTDate
			};
			let dataComparison = [];
			if (
				type === ADMISSION_CARDS_TYPE.ADMISSION ||
				type === ADMISSION_CARDS_TYPE.READMISSION ||
				type === ADMISSION_CARDS_TYPE.TOTAL
			) {
				dataComparison = [];
			} else {
				dataComparison = filterListDataComparison[type];
			}
			const { customRangeCombinedData: customRangeCombinedDataComparison } = processCustomRangeCombinedData(question, filterListDataComparison, type);
			const filtersComparisonWithCustomData = {
				...filtersComparison,
				customRangeCombinedData: customRangeCombinedDataComparison
			};
			dispatch(
				openDetailsDialogComparison({
					isOpen: true,
					title,
					type,
					data: dataComparison,
					filters: filtersComparisonWithCustomData,
				})
			);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[dispatch, filterListData, cardFilter, filter, filterListDataComparison, cardFilterComparison, filterComparison, lastADTDate]
	);

	const getPriorityNumber = useCallback(
		(type) => {
			const idx = cardFilter.mainPriorityData.findIndex((p) => p.type === type);
			return idx != null && idx !== -1 ? idx + 1 : null;
		},
		[cardFilter]
	);

	const getADTPriorityNumber = useCallback(
		(item) => {
			const idx = cardFilter.mainPriorityData.findIndex((p) => p.childId === item.childId && p.cardId === item.cardId);
			return idx != null && idx !== -1 ? idx + 1 : null;
		},
		[cardFilter]
	);

	const handleOnClickReport = useCallback(async (
		type,
		title,
		isTotalCard = false,
		isAdtType = false,
		automaticallyReport = null,
		customData = null
	) => {
		try {
			if (automaticallyReport) {
				return await saveAutomaticReport({
					type,
					title,
					cardFilter,
					filter: {
						...filter,
						startDate: toSaveDate(filter.startDate),
						endDate: toSaveEndDate(filter.endDate),
					},
					dbData,
					page: PAGE_TYPE.ADMISSION,
					filterListData,
					isTotalCard,
					selectedADTTableData,
					isAdt: true,
					admissionReportType: isAdtType ? ADMISSION_FILTER_TYPE.ADT : ADMISSION_FILTER_TYPE.ADMISSION,
					automaticallyReport: { ...automaticallyReport, ...customData },
					transferType,
					lockedTotalBy,
					isCensusTotalLocked,
					lockeByADT,
					lastADTDate,
					percentageBy,
				});
			} else {
				await downloadPdf({
					type,
					title,
					cardFilter,
					filter,
					dbData,
					page: PAGE_TYPE.ADMISSION,
					filterListData,
					isTotalCard,
					selectedADTTableData,
					isAdt: true,
					admissionReportType: isAdtType ? ADMISSION_FILTER_TYPE.ADT : ADMISSION_FILTER_TYPE.ADMISSION,
					customData
				});
			}
		} catch (error) {
			console.error("Error generating report:", error);
			dispatch({
				type: ADD_NOTIFICATION,
				payload: {
					type: "error",
					label: "Failed to generate report. Please check if popups are blocked and try again.",
					id: "reportGenerationError",
				},
			});
		}
	}, [cardFilter, filter, dbData, filterListData, selectedADTTableData, transferType, lockedTotalBy, isCensusTotalLocked, lockeByADT, lastADTDate, percentageBy, saveAutomaticReport, downloadPdf, dispatch]);

	const handleOnClickReportGraph = async (graphData, isAdtType = false) => {
		if (graphData && graphData.automaticallyReport) {
			const graphDataUpdated = _.omit(graphData, ["chartData", "filterData", "tableElementRef", "buildingElementRef"]);
			const reportMeta = pickObjectByPaths(graphDataUpdated?.detailsDialog, REPORT_META_PATHS);
			const filterPaths = REPORT_META_PATHS.filter((path) => path.startsWith("filters.")).map((path) => path.replace("filters.", ""));
			const graphFiltersUpdated = pickObjectByPaths(graphDataUpdated?.filters, filterPaths);

			const graphDataSanitized = {
				...graphDataUpdated,
				filters: graphFiltersUpdated,
				detailsDialog: reportMeta,
			};

			return await saveAutomaticReport({
				type: isAdtType ? graphData.filters.selectedCardItem : graphData?.filters?.type,
				title: graphData?.automaticallyReport?.title,
				cardFilter,
				filter: {
					...filter,
					startDate: toSaveDate(filter.startDate),
					endDate: toSaveEndDate(filter.endDate),
				},
				dbData,
				page: PAGE_TYPE.ADMISSION,
				filterListData,
				automaticallyReport: graphData?.automaticallyReport,
				transferType,
				lockedByFacility: lockedByFacility?.length > 0 ? lockedByFacility?.map(item => ({ facilityId: item.facilityId, _id: item._id })) : null,
				lockedTotal,
				lockedTotalBy,
				isCensusTotalLocked,
				lastADTDate,
				isGraphReport: true,
				admissionReportType: isAdtType ? ADMISSION_FILTER_TYPE.ADT : ADMISSION_FILTER_TYPE.ADMISSION,
				graphData: graphDataSanitized,
				percentageBy,
			});
		} else {
			await downloadPdf({
				type: graphData?.filters?.type,
				cardFilter,
				filter,
				dbData,
				page: PAGE_TYPE.ADMISSION,
				filterListData,
				isTotalCard: false,
				selectedADTTableData,
				graphData,
				isGraphReport: true,
				isAdt: true,
				admissionReportType: isAdtType ? ADMISSION_FILTER_TYPE.ADT : ADMISSION_FILTER_TYPE.ADMISSION,
			});
		}
	};

	const [admissionDynamicCards, allDynamicCards] = useMemo(() => {
		if (dynamicCards?.length > 0) {
			return [
				dynamicCards.filter((ele) => ele.forType === ADT_TYPES.ADMISSIONS),
				dynamicCards.filter((ele) => ele.forType !== ADT_TYPES.ADMISSIONS),
			];
		}
		return [[], []];
	}, [dynamicCards]);

	const ADMISSION_CUSTOM_CARD_DATA = useAdditionalData(admissionDynamicCards, ADMISSION_CUSTOM_CARD, patientList?.customTabs);
	const { sharedUsersByTabId: sharedUsersByCustomTabId, sharedWithEveryoneByTabId } = useSharedUsersByCustomTab(
		patientList?.customTabs,
		admissionDynamicCards
	);

	// AI Report Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiReportActionsService.initialize(
			handleOnClickReport,
			downloadExcel,
			() => ({ admission: { filterListData, cardFilter, transferType, dbData, dynamicCards, patientList } })
		);
	}, [handleOnClickReport, downloadExcel, filterListData, cardFilter, transferType, dbData, dynamicCards, patientList]);
	*/

	// AI Transfer Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiTransferActionsService.initialize(
			handleOnclickCard,
			handleClickTotal,
			() => ({ admission: { dbData, transferType } })
		);
	}, [handleOnclickCard, handleClickTotal, dbData, transferType]);
	*/

	// AI Dialog Actions Service — disabled (dead under new agent API; callbacks never invoked)
	/*
	useEffect(() => {
		aiDialogActionsService.initialize(
			handleChartDialog,
			() => ({
				admission: {
					dbData,
					transferType,
					filterListData,
					cardFilter,
					activeFacilities,
					dynamicCards,
					patientList
				}
			})
		);
	}, [handleChartDialog, dbData, transferType, filterListData, cardFilter, activeFacilities, dynamicCards, patientList]);
	*/

	const handleAddCustomCard = useCallback(async (key) => {
		let cards = [...admissionCards];
		if (key === "selectAll") {
			cards = _.map(ADMISSION_CUSTOM_CARD_DATA, "value");
		} else if (key === "clearAll") {
			cards = []
		} else {
			if (!cards.includes(key)) {
				cards.push(key);
			} else {
				cards.splice(cards.indexOf(key), 1);
			}
		}
		dispatch(setAdmissionCards(cards));
	}, [ADMISSION_CUSTOM_CARD_DATA, admissionCards, dispatch]);

	// Auto-select all custom cards once everything is rendered
	useEffect(() => {
		// Check if data is loaded, not loading, and we have the necessary data
		if (dbData && !loading && !admissionLoading && activeFacilities && activeFacilities.length > 0) {
			// Always ensure all available cards are selected for all users
			const allAvailableValues = ADMISSION_CUSTOM_CARD_DATA.map(card => card.value);
			const missingCards = allAvailableValues.filter(val => !admissionCards.includes(val));
			
			if (missingCards.length > 0) {
				const updatedCards = [...admissionCards, ...missingCards];
				dispatch(setAdmissionCards(updatedCards));
			}
		}
	}, [dbData, loading, admissionLoading, activeFacilities, admissionCards, dispatch, ADMISSION_CUSTOM_CARD_DATA]);

	const handleCombineADTCardClickForTab = useCallback(
		async (tabItem, tabItemComparison, uniqueKey) => {
			const combineAccessor = tabItem?.accessor;
			const tabDef = tabItem?.customTab;
			if (isLayoutMode || !combineAccessor || !tabDef) return;
			const compositeKey = uniqueKey && combineAccessor ? `${combineAccessor}__${uniqueKey}` : null;
			if (!compositeKey) return;

			const combineData = Array.isArray(tabItem?.tableData)
				? tabItem.tableData
				: filterListData?.[combineAccessor] ?? [];
			const combineDataComparison = Array.isArray(tabItemComparison?.tableData)
				? tabItemComparison.tableData
				: filterListDataComparison?.[combineAccessor] ?? [];

			const currentCombineItem = combineData[0] ?? filterListData?.[combineAccessor]?.[0];
			const currentCombineItemComparison =
				combineDataComparison[0] ?? filterListDataComparison?.[combineAccessor]?.[0];

			const selectedFromTotalByPage =
				(uniqueKey && currentCombineItem?.totalByPage?.[uniqueKey]?.patientIds) ||
				currentCombineItem?.patientIds ||
				[];
			const selectedFromTotalByPageComparison =
				(uniqueKey && currentCombineItemComparison?.totalByPage?.[uniqueKey]?.patientIds) ||
				currentCombineItemComparison?.patientIds ||
				[];

			const selectedSpecialArr = cardFilter?.adtAdmitPatientIds?.find(
				(x) => x.childId === tabItem?.childId && x.cardId === tabItem?.cardId
			);

			const selectedSpecialArrComparison = cardFilterComparison?.adtAdmitPatientIds?.find(
				(x) => x.childId === tabItem?.childId && x.cardId === tabItem?.cardId
			);

			const adtSelectedIds = selectedSpecialArr?.selectedIds ?? [];
			const adtSelectedSpecialIds = selectedSpecialArr?.selectedSpecialIds ?? [];
			const isSelectedTotalCombine = adtSelectedIds.length > 0 || adtSelectedSpecialIds.length > 0;

			const prefix = `${combineAccessor}__`;
			const patientIdsForKeys = (keys, combineRow) => {
				const out = [];
				for (const selectedKey of keys) {
					if (typeof selectedKey !== "string" || !selectedKey.startsWith(prefix)) continue;
					const uk = selectedKey.slice(prefix.length);
					const p = combineRow?.totalByPage?.[uk]?.patientIds;
					if (Array.isArray(p)) out.push(...p);
				}
				return _.uniq(out);
			};

			const isCurrentSliceSelected = _.includes(adtSelectedIds, compositeKey);
			let nextSelectedIds;
			let nextSavedData;
			let nextSavedDataComparison;
			let nextTransferIds;
			let nextTransferIdsComparison;
			let combineAdtLockDelta = 0;

			if (isCurrentSliceSelected) {
				nextSelectedIds = adtSelectedIds.filter((k) => k !== compositeKey);
				combineAdtLockDelta = adtSelectedIds.length === 1 ? -1 : 0;
				if (nextSelectedIds.length === 0) {
					nextSavedData = [];
					nextSavedDataComparison = [];
					nextTransferIds = [];
					nextTransferIdsComparison = [];
				} else {
					nextSavedData = patientIdsForKeys(nextSelectedIds, currentCombineItem);
					nextSavedDataComparison = patientIdsForKeys(nextSelectedIds, currentCombineItemComparison);
					nextTransferIds = nextSavedData;
					nextTransferIdsComparison = nextSavedDataComparison;
				}
			} else {
				nextSelectedIds = [...adtSelectedIds, compositeKey];
				nextSavedData = _.union(
					Array.isArray(selectedSpecialArr?.ids) ? selectedSpecialArr.ids : [],
					Array.isArray(selectedFromTotalByPage) ? selectedFromTotalByPage : []
				);
				nextSavedDataComparison = _.union(
					Array.isArray(selectedSpecialArrComparison?.ids) ? selectedSpecialArrComparison.ids : [],
					Array.isArray(selectedFromTotalByPageComparison) ? selectedFromTotalByPageComparison : []
				);
				nextTransferIds = nextSavedData;
				nextTransferIdsComparison = nextSavedDataComparison;
				combineAdtLockDelta = !isSelectedTotalCombine ? 1 : 0;
			}

			await handleToggleADTTabRef.current?.({
				savedData: nextSavedData,
				savedDataComparison: nextSavedDataComparison,
				selectedTransferIds: nextTransferIds,
				selectedTransferIdsComparison: nextTransferIdsComparison,
				item: {
					type: ADT_TABLE_TYPE.CUSTOM,
					question: {
						isCustom: true,
						customQuestionInputType: tabDef?.question?.customQuestionInputType,
						isCustomTab: false,
						cardTitle: tabDef?.title || tabDef?.label || tabItem.subTitle,
						customTab: tabDef,
						accessor: combineAccessor,
						compositeKey,
						uniqueKey,
					},
					customTab: tabDef,
					accessor: combineAccessor,
				},
				itemComparison: {
					type: ADT_TABLE_TYPE.CUSTOM,
					question: {
						isCustom: true,
						customQuestionInputType: tabDef?.question?.customQuestionInputType,
						isCustomTab: false,
						cardTitle: tabDef?.title || tabDef?.label || tabItem.subTitle,
						customTab: tabDef,
						accessor: combineAccessor,
						compositeKey,
						uniqueKey,
					},
					customTab: tabDef,
					accessor: combineAccessor,
				},
				parentItem: tabItem,
				parentItemComparison: tabItemComparison || {},
				total: 1,
				selectedIds: nextSelectedIds,
				isChecked: false,
				combineAdtLockDelta,
				isSpacialItem: false,
			});
		},
		[isLayoutMode, cardFilter, cardFilterComparison, filterListData, filterListDataComparison]
	);

	const renderADTDataTables = useCallback(
		(item, i) => {
			const itemComparison = selectedADTTableDataComparison.find(
				(x) => x.childId === item?.childId && x.cardId === item?.cardId
			);
			const cardsThatDontCompareToDiffFacilities = [
				"Floor",
				"Doctor",
				"Per Nurse",
				"Hospitals resident transferred",
				"Per Facility",
			];
			const canBeSearchedCardSubTitles = [
				"Transfers Per Insurance",
				"Floor",
				"Doctor",
				"Per Nurse",
				"Diagnosis",
				"Hospitals resident transferred",
				"Safe discharges per Assisted Living",
				"Per Facility",
			];
			const dontCompareDiffFacilities = cardsThatDontCompareToDiffFacilities.some((x) => x === item?.subTitle);
			const canBeSearched = canBeSearchedCardSubTitles.some((x) => x === item.subTitle);
			const specificData = item;
			const selectedSpecialArr = cardFilter?.adtAdmitPatientIds?.find(
				(x) => x.childId === item?.childId && x.cardId === item?.cardId
			);

			const isAdtCombineTab =
				item?.type === ADT_TABLE_TYPE.CUSTOM && item?.customTab?.type === CUSTOM_TAB_TYPE.combineTab;
			const combineAccessor = item?.accessor;
			const tabDef = item?.customTab;

			const combineData = Array.isArray(item?.tableData)
				? item.tableData
				: filterListData?.[combineAccessor] ?? [];
			const combineDataComparison = Array.isArray(itemComparison?.tableData)
				? itemComparison.tableData
				: filterListDataComparison?.[combineAccessor] ?? [];

			// Same question shape as DynamicCardItem → DynamicDataCardList (combineTab branch: NinetyDaysAnalysis | ShiftCard | DynamicDataCardTotalCard).
			const combineQuestionForList =
				tabDef != null ? { ...tabDef, type: CUSTOM_TAB_TYPE.combineTab } : null;

			const combinePageForList = item?.parentId || PAGE_TYPE.ADMISSION;

			const adtSelectedIds = selectedSpecialArr?.selectedIds ?? [];
			const adtSelectedSpecialIds = selectedSpecialArr?.selectedSpecialIds ?? [];
			const isSelectedTotalCombine = adtSelectedIds.length > 0 || adtSelectedSpecialIds.length > 0;

			const handleCombineADTCardClick = async (_titleParam, uniqueKey) =>
				handleCombineADTCardClickForTab(item, itemComparison, uniqueKey);

			return item.id === "all" && disableTotalHospitalizationsCard ? null : (
				<Grid item xs={12} sm={12} md={6} lg={4} key={`gridItem${item.id}_${item?.parentId}`} sx={{ ...isMobile && { mb: "20px" } }}>
					<ADTCard
						key={`${item?.cardId}${item?.childId}_ADTCard`}
						item={item}
						title={item.subTitle}
						secondaryTitle={null}
						helperText={item.helperText}
						minimizable={true}
						loading={loading || loadingComparison}
						cardFilter={cardFilter}
						filters={selectedADTTableData}
						reloadAdmissionFilter={reloadAdmissionFilter}
						defaultADTData={defaultADTData}
						handleOnClickDetails={
							isAdtCombineTab && combineAccessor && tabDef
								? (adtCardItem, defaultTab) =>
									handleADTTabChartDialog(adtCardItem, null, defaultTab, {
										isCustom: true,
										customQuestionInputType:
											tabDef?.customQuestionInputType ?? tabDef?.question?.customQuestionInputType,
										isCustomTab: true,
										customTab: tabDef,
										accessor: combineAccessor,
										level: combineData[0]?.level ?? filterListData?.[combineAccessor]?.[0]?.level,
										cardTitle: item.subTitle,
									})
								: (selectedCardItem, defaultTab) =>
									handleADTTabChartDialog(selectedCardItem, null, defaultTab, {
										isCustom: true,
										customQuestionInputType: item?.customQuestionInputType,
									})
						}
						priorityNumber={getADTPriorityNumber(item)}
						handleOnClickReport={(title, otherData) => {
							if (isAdtCombineTab && combineAccessor && tabDef) {
								handleOnClickReport(combineAccessor, title, false, false, otherData, {
									questionId: tabDef?._id,
									isCustomCard: true,
									isCustomTab: true,
									cardTitle: title,
									question: tabDef,
								});
							} else if (item.type === ADT_TABLE_TYPE.CUSTOM) {
								handleOnClickReport(item, title, false, true, otherData, { questionId: item?.questionId, isCustomCard: true });
							} else {
								handleOnClickReport(item, title, false, true, otherData);
							}
						}}
						handleOnClickShareReport={(title) => handleOnClickShareReport(title, item, false)}
						secondaryTitleError={
							comparingAgainstDifferentFacility &&
							rangesSet &&
							dontCompareDiffFacilities &&
							"Comparison function disabled when comparing to other facilities"
						}
						secondaryTitleClassName="error"
						specificData={specificData}
						type={"adtAdmitPatientIds"}
						handleToggleAll={handleToggleAllADTTab}
						selectedItems={cardFilter.adtAdmitPatientIds}
						canBeSearched={isAdtCombineTab ? false : canBeSearched}
						isMobile={isMobile}
					>
						{isAdtCombineTab && combineAccessor && tabDef && combineQuestionForList ? (
							<DynamicDataCardList
								disableInteractions={isLayoutMode}
								totalTransfers={dbData?.total}
								totalTransfersComparison={dbDataComparison?.total}
								filterListData={{
									...filterListData,
									[combineAccessor]: combineData,
								}}
								filterListDataComparison={{
									...filterListDataComparison,
									[combineAccessor]: combineDataComparison,
								}}
								question={combineQuestionForList}
								cardTitle={tabDef?.title || tabDef?.label || item.subTitle}
								data={combineData}
								dataComparison={combineDataComparison}
								handleToggle={handleToggleADTTab}
								handleToggleAll={handleToggleAllADTTab}
								selectedItem={adtSelectedIds}
								spacialSelectedItem={adtSelectedSpecialIds}
								type={combineAccessor}
								filter={filter}
								loading={loading || loadingComparison}
								filterComparison={filterComparison}
								page={combinePageForList}
								averageCensus={percentageAgainst}
								projectionDays={projectionDays}
								isComparingAgainstAvgCensus={filterListData?.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(combineAccessor)}
								transferType={transferType}
								lockedTotalBy={filterListData?.lockedTotalBy}
								isCustomTab={true}
								filterTotal={filterTotal}
								handleCardClick={handleCombineADTCardClick}
								isSelectedTotalCard={isSelectedTotalCombine}
								cardFilter={cardFilter}
								isDisabled={false}
								admissionCompareAgainst={
									lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData?.bedCapacity
								}
								admissionCompareAgainstComparison={
									lockFilterTotalStateComparison?.isLocked
										? lockFilterTotalStateComparison?.lockedFilterTotal
										: dbDataComparison?.bedCapacity
								}
								reverseColorsAdmissionPage={reversedColorAdmission}
							/>
						) : (
							<TransferADTCardListTable
								item={item}
								itemComparison={itemComparison}
								dbSelectedFilters={dbSelectedFilters}
								filter={filter}
								filterComparison={filterComparison}
								dbSelectedFiltersComparison={dbSelectedFiltersComparison}
								handleToggleADTTab={handleToggleADTTab}
								handleToggleAll={handleToggleAllADTTab}
								filters={cardFilter.adtAdmitPatientIds}
								filtersComparison={cardFilterComparison?.adtAdmitPatientIds}
								type={"adtAdmitPatientIds"}
								page={PAGE_TYPE.ADMISSION}
								dbData={selectedADTTableData}
								dontCompareDiffFacilities={comparingAgainstDifferentFacility && dontCompareDiffFacilities}
								totalAdmissions={
									lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData?.bedCapacity
								}
								totalAdmissionsComparison={
									lockFilterTotalStateComparison?.isLocked
										? lockFilterTotalStateComparison?.lockedFilterTotal
										: dbDataComparison?.bedCapacity
								}
								projectionDays={projectionDays}
								isComparingAgainstAvgCensus={filterListData?.isComparingAgainstAvgCensus}
								priorityNumber={getADTPriorityNumber(item)}
								transferType={transferType}
								lockedTotalBy={filterListData?.lockedTotalBy}
								specificData={specificData}
								selectedSpecialIds={selectedSpecialArr?.selectedSpecialIds}
								selectedIds={selectedSpecialArr?.selectedIds}
							/>
						)}
					</ADTCard>
				</Grid>
			);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[
			selectedADTTableDataComparison,
			comparingAgainstDifferentFacility,
			rangesSet,
			loading,
			cardFilter,
			selectedADTTableData,
			reloadAdmissionFilter,
			defaultADTData,
			getADTPriorityNumber,
			getPriorityNumber,
			dbSelectedFilters,
			dbSelectedFiltersComparison,
			cardFilterComparison?.adtAdmitPatientIds,
			lockFilterTotalState?.isLocked,
			lockFilterTotalState?.lockedFilterTotal,
			dbData.total,
			dbData?.bedCapacity,
			lockFilterTotalStateComparison?.isLocked,
			lockFilterTotalStateComparison?.lockedFilterTotal,
			dbDataComparison?.total,
			dbDataComparison?.bedCapacity,
			handleADTTabChartDialog,
			handleChartDialog,
			handleOnClickReport,
			handleOnClickShareReport,
			handleToggle,
			handleToggleAll,
			filterListData,
			filterListDataComparison,
			filterTotal,
			projectionDays,
			percentageAgainst,
			isLayoutMode,
			reversedColorAdmission,
			handleToggleAllADTTab,
			handleToggleADTTab,
			handleCombineADTCardClickForTab,
			disableTotalHospitalizationsCard,
			isMobile,
			transferType,
		]
	);

	const [scrollPosition, setScrollPosition] = useState({ scrollTop: 0 });
	const scrollDemoRef = useRef(null);
	const handleScroll = () => {
		if (scrollDemoRef.current) {
			const { scrollTop } = scrollDemoRef.current;
			setScrollPosition({ scrollTop });
		}
	};

	const layoutZoomWrapperRef = useRef(null);
	const layoutZoomScale = isMobile
		? ADMISSION_LAYOUT_MODE_ZOOM_MOBILE
		: ADMISSION_LAYOUT_MODE_ZOOM_DESKTOP;
	useLayoutEffect(() => {
		const node = layoutZoomWrapperRef.current;
		if (!node) return undefined;
		if (!isLayoutMode) {
			node.style.marginBottom = "";
			return undefined;
		}
		let raf = null;
		const update = () => {
			const natural = node.offsetHeight;
			if (!(natural > 0)) return;
			const negative = natural * (1 - layoutZoomScale);
			node.style.marginBottom = `-${negative}px`;
		};
		update();
		let ro;
		if (typeof ResizeObserver !== "undefined") {
			ro = new ResizeObserver(() => {
				if (raf) cancelAnimationFrame(raf);
				raf = requestAnimationFrame(update);
			});
			ro.observe(node);
		}
		return () => {
			if (raf) cancelAnimationFrame(raf);
			if (ro) ro.disconnect();
			node.style.marginBottom = "";
		};
	}, [isLayoutMode, layoutZoomScale]);

	// Layout management functions
	const generateDefaultLayout = useCallback(() => {
		const layout = [];
		let position = 0;

		// Follow the exact same sequence as cardData
		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.DOCTOR_DATA) || isMobile) {
			layout.push({
				id: ADMISSION_CARDS_TYPE.DOCTOR_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.DOCTOR_DATA),
				position: position++,
			});
		}

		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.DAYS_DATA) || isMobile) {
			layout.push({
				id: ADMISSION_CARDS_TYPE.DAYS_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.DAYS_DATA),
				position: position++,
			});
		}

		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.DX_DATA) || isMobile) {
			layout.push({
				id: ADMISSION_CARDS_TYPE.DX_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.DX_DATA),
				position: position++,
			});
		}

		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.INSURANCE_DATA) || isMobile) {
			layout.push({
				id: ADMISSION_CARDS_TYPE.INSURANCE_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.INSURANCE_DATA),
				position: position++,
			});
		}

		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.FLOORS_DATA) || isMobile) {
			layout.push({
				id: ADMISSION_CARDS_TYPE.FLOORS_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.FLOORS_DATA),
				position: position++,
			});
		}

		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.HOSPITAL_DATA) || isMobile) {
			layout.push({
				id: ADMISSION_CARDS_TYPE.HOSPITAL_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.HOSPITAL_DATA, 'admission'),
				position: position++,
			});
		}

		// Add dynamic cards to the default layout
		if (admissionDynamicCards?.length > 0) {
			admissionDynamicCards.forEach((ele) => {
				if (_.includes(admissionCards, ele.accessor) || isMobile) {
					layout.push({
						id: getDynamicCardLayoutId(ele.accessor),
						width: 4, // Default width for dynamic cards
						position: position++,
					});
				}
			});
		}

		// Add custom tab cards to the default layout
		if (patientList?.customTabs?.length > 0) {
			patientList.customTabs.forEach((ele) => {
				if (_.includes(admissionCards, ele.accessor) || isMobile) {
					layout.push({
						id: getCustomTabCardLayoutId(ele.accessor),
						width: 4, // Default width for custom tab cards
						position: position++,
					});
				}
			});
		}

		return layout;
	}, [admissionCards, admissionDynamicCards, patientList?.customTabs, isMobile]);

	const migrateLayout = useCallback(
		(layout) => {
			if (!layout || (Array.isArray(layout) && layout.length === 0)) {
				return ensureHospitalRootOrder({
					version: "3.0",
					standalone: generateDefaultLayout().map((c) => ({ ...c, gridH: 24 })),
					categories: [],
				});
			}
			if (Array.isArray(layout)) {
				return ensureHospitalRootOrder({
					version: "3.0",
					standalone: layout.map((c) => ({ ...c, gridH: c.gridH || 24 })),
					categories: [],
				});
			}
			if (layout?.version === "2.0") {
				const generalCat = layout.categories.find((c) => c.id === "cat_general");
				const standardCategories = layout.categories.filter((c) => c.id !== "cat_general");
				return ensureHospitalRootOrder({
					version: "3.0",
					standalone: generalCat ? generalCat.cards.map((c) => ({ ...c, gridH: c.gridH || 24 })) : [],
					categories: standardCategories.map((cat) => ({
						...cat,
						gridH: cat.gridH || 94,
						cards: (cat.cards || []).map((c) => ({ ...c, gridH: c.gridH || 24 })),
					})),
				});
			}
			const categories = layout.categories || [];
			const standalone = layout.standalone || [];
			const hasCategoryWithCards = categories.some(
				(cat) => Array.isArray(cat.cards) && cat.cards.length > 0
			);
			if (!hasCategoryWithCards) {
				const merged = [];
				const seen = new Set();
				const pushCard = (c) => {
					if (c && c.id != null && !seen.has(c.id)) {
						seen.add(c.id);
						merged.push({ ...c, gridH: c.gridH || 24 });
					}
				};
				standalone.forEach(pushCard);
				categories.forEach((cat) => (cat.cards || []).forEach(pushCard));
				if (merged.length === 0) {
					return ensureHospitalRootOrder({
						version: "3.0",
						standalone: generateDefaultLayout().map((c) => ({ ...c, gridH: 24 })),
						categories: [],
					});
				}
				return ensureHospitalRootOrder({
					...layout,
					version: layout.version || "3.0",
					categories: [],
					standalone: merged,
					rootOrder: undefined,
				});
			}
			return ensureHospitalRootOrder(layout);
		},
		[generateDefaultLayout]
	);

	const patchAdmissionLayoutBase = useCallback(
		(base) => {
			if (!base) return base;
			const normalized = normalizeAdmissionLayoutCardIds(
				base,
				admissionDynamicCards,
				patientList?.customTabs
			);
			return augmentAdmissionLayoutWithSelectedCards(
				normalized,
				admissionCards,
				admissionDynamicCards,
				patientList?.customTabs
			);
		},
		[admissionCards, admissionDynamicCards, patientList?.customTabs]
	);

	const isV3LayoutActive = useMemo(() => {
		if (
			isLayoutMode &&
			tempLayout &&
			typeof tempLayout === "object" &&
			!Array.isArray(tempLayout) &&
			tempLayout.version
		) {
			return true;
		}
		if (!isLayoutMode && isStoredLayoutV3(admissionLayout)) {
			return true;
		}
		return false;
	}, [isLayoutMode, tempLayout, admissionLayout]);

	const getLegacyFlatLayout = useCallback(() => {
		if (isLayoutMode) {
			return Array.isArray(tempLayout) && tempLayout.length > 0 ? tempLayout : generateDefaultLayout();
		}
		if (Array.isArray(admissionLayout) && admissionLayout.length > 0) {
			return admissionLayout;
		}
		return generateDefaultLayout();
	}, [tempLayout, admissionLayout, isLayoutMode, generateDefaultLayout]);

	const getCurrentLayoutV3 = useCallback(() => {
		const base = isLayoutMode && tempLayout?.version ? tempLayout : migrateLayout(admissionLayout);
		const patched = patchAdmissionLayoutBase(base);
		return ensureHospitalRootOrder({
			version: patched?.version || "3.0",
			standalone: patched?.standalone || [],
			categories: patched?.categories || [],
			rootOrder: patched?.rootOrder,
		});
	}, [tempLayout, admissionLayout, isLayoutMode, migrateLayout, patchAdmissionLayoutBase]);

	const admissionHeaderPopoverDynamicCards = useMemo(
		() => [...(dynamicCards.filter((ele) => ele.forType === ADT_TYPES.ADMISSIONS) || []), ...(patientList?.customTabs || [])],
		[dynamicCards, patientList?.customTabs]
	);

	const admissionDynamicTabDataByAccessor = useMemo(() => {
		const out = {};
		const layout = getCurrentLayoutV3();
		const visit = (cards) => {
			if (!Array.isArray(cards)) return;
			for (const card of cards) {
				if (card?.component === "dynamic" && card?.data?.accessor != null) {
					out[card.data.accessor] = card.data;
				}
			}
		};
		visit(layout?.standalone);
		for (const cat of layout?.categories || []) {
			visit(cat?.cards);
		}
		return out;
	}, [getCurrentLayoutV3]);

	const admissionHeaderCardFilterPanelProps = useMemo(
		() => ({
			handleToggle,
			handleToggleAll,
			filterListData,
			filterListDataComparison,
			cardFilter,
			filter,
			filterComparison,
			loading,
			loadingComparison,
			projectionDays,
			filterTotal,
			dbData,
			dbDataComparison,
			transferType,
			lockedTotalBy,
			getPriorityNumber,
			comparingAgainstDifferentFacility,
			dynamicCards: admissionHeaderPopoverDynamicCards,
			admissionDynamicTabDataByAccessor,
			percentageAgainst,
			reversedColorAdmission,
			lockFilterTotalState,
			lockFilterTotalStateComparison,
		}),
		[
			handleToggle,
			handleToggleAll,
			filterListData,
			filterListDataComparison,
			cardFilter,
			filter,
			filterComparison,
			loading,
			loadingComparison,
			projectionDays,
			filterTotal,
			dbData,
			dbDataComparison,
			transferType,
			lockedTotalBy,
			getPriorityNumber,
			comparingAgainstDifferentFacility,
			admissionHeaderPopoverDynamicCards,
			admissionDynamicTabDataByAccessor,
			percentageAgainst,
			reversedColorAdmission,
			lockFilterTotalState,
			lockFilterTotalStateComparison,
		]
	);

	const admissionHeaderAdtPanelProps = useMemo(
		() => ({
			cardFilter,
			cardFilterComparison,
			selectedADTTableData,
			selectedADTTableDataComparison,
			filterListData,
			filterListDataComparison,
			handleToggleADTTab: (...args) => handleToggleADTTabRef.current?.(...args),
			handleToggleAllADTTab: (...args) => handleToggleAllADTTabRef.current?.(...args),
			handleCombineADTCardClickForTab,
			dbSelectedFilters,
			dbSelectedFiltersComparison,
			filter,
			filterComparison,
			comparingAgainstDifferentFacility,
			rangesSet,
			loading,
			loadingComparison,
			transferType,
			lockedTotalBy,
			filterTotal,
			projectionDays,
			percentageAgainst,
			dbData,
			dbDataComparison,
			lockFilterTotalState,
			lockFilterTotalStateComparison,
			reversedColorAdmission,
			getPriorityNumber,
			getADTPriorityNumber,
		}),
		[
			cardFilter,
			cardFilterComparison,
			selectedADTTableData,
			selectedADTTableDataComparison,
			filterListData,
			filterListDataComparison,
			handleCombineADTCardClickForTab,
			dbSelectedFilters,
			dbSelectedFiltersComparison,
			filter,
			filterComparison,
			comparingAgainstDifferentFacility,
			rangesSet,
			loading,
			loadingComparison,
			transferType,
			lockedTotalBy,
			filterTotal,
			projectionDays,
			percentageAgainst,
			dbData,
			dbDataComparison,
			lockFilterTotalState,
			lockFilterTotalStateComparison,
			reversedColorAdmission,
			getPriorityNumber,
			getADTPriorityNumber,
		]
	);

	const renderAdmissionCardFilterPopover = useCallback(
		({ dataKey, headerFilterPopoverOpen }) => (
			<AdmissionHeaderCardFilterPanel
				dataKey={dataKey}
				headerFilterPopoverOpen={headerFilterPopoverOpen}
				{...admissionHeaderCardFilterPanelProps}
			/>
		),
		[admissionHeaderCardFilterPanelProps]
	);

	const renderAdmissionAdtTabFilterPopover = useCallback(
		({ adtHeaderRow, onClose, headerFilterPopoverOpen }) => (
			<AdmissionHeaderAdtTabFilterPanel
				adtHeaderRow={adtHeaderRow}
				onClose={onClose}
				headerFilterPopoverOpen={headerFilterPopoverOpen}
				{...admissionHeaderAdtPanelProps}
			/>
		),
		[admissionHeaderAdtPanelProps]
	);

	const handleSaveLayout = useCallback(
		async (options = {}) => {
			const { skipExitAfterSave = false, saveForBothLayouts = false } = options;
			try {
				let layoutToSave;
				if (isV3LayoutActive) {
					layoutToSave = applyCollapsedStateToLayout(
						ensureHospitalRootOrder(
							patchAdmissionLayoutBase(tempLayout?.version ? tempLayout : migrateLayout(admissionLayout))
						),
						collapsedCategoryIds
					);
					const emptyCategory = (layoutToSave.categories || []).find(
						(cat) => !cat.cards || cat.cards.length === 0
					);
					if (emptyCategory) {
						dispatch({
							type: ADD_NOTIFICATION,
							payload: {
								label: "A category must contain at least one item.",
								type: "error",
								id: "emptyCategoryAdmission",
							},
						});
						return false;
					}
				} else {
					layoutToSave =
						Array.isArray(tempLayout) && tempLayout.length > 0 ? tempLayout : generateDefaultLayout();
				}

				await saveLayoutToDatabase(
					{
						page: PAGE_TYPE.ADMISSION,
						layout: layoutToSave,
						cards: admissionCards,
						timestamp: new Date().toISOString(),
					},
					currentLayoutType
				);
				if (saveForBothLayouts) {
					const mirrorLayoutType = currentLayoutType === "default" ? "personal" : "default";
					await saveLayoutToDatabase(
						{
							page: PAGE_TYPE.ADMISSION,
							layout: layoutToSave,
							cards: admissionCards,
							timestamp: new Date().toISOString(),
						},
						mirrorLayoutType
					);
				}

				dispatch(setAdmissionLayout(layoutToSave));
				setHasLayoutChanges(false);

				const layoutTypeText = saveForBothLayouts
					? "default and personal"
					: currentLayoutType === "default"
						? "default"
						: "personal";
				dispatch({
					type: ADD_NOTIFICATION,
					payload: {
						label: `Your ${layoutTypeText} layout has been saved successfully.`,
						type: "success",
						id: "savedCustomLayoutAdmission",
					},
				});
				if (!skipExitAfterSave) {
					handleToggleLayoutModeRef.current?.(true);
				}
				return true;
			} catch (error) {
				dispatch({
					type: ADD_NOTIFICATION,
					payload: {
						label: "Failed to save layout. Please try again.",
						type: "error",
						id: "saveFailedAdmission",
					},
				});
				return false;
			}
		},
		[
			isV3LayoutActive,
			tempLayout,
			migrateLayout,
			admissionLayout,
			admissionCards,
			currentLayoutType,
			dispatch,
			patchAdmissionLayoutBase,
			generateDefaultLayout,
			collapsedCategoryIds,
		]
	);

	const handleLayoutTypeChange = useCallback(
		async (layoutType) => {
			try {
				setLayoutTypeLoading(true);
				setCurrentLayoutType(layoutType);
				const rawLayout = await fetchLayoutByType(layoutType);
				if (rawLayout != null && typeof rawLayout === "object") {
					if (Array.isArray(rawLayout)) {
						dispatch(setAdmissionLayout(rawLayout));
						setCollapsedCategoryIds({});
						setTempLayout(rawLayout);
					} else {
						const nestedLayout = ensureHospitalRootOrder(
							patchAdmissionLayoutBase(migrateLayout(rawLayout))
						);
						dispatch(setAdmissionLayout(nestedLayout));
						setCollapsedCategoryIds(getCollapsedIdsFromLayout(nestedLayout, false));
						setTempLayout(nestedLayout);
					}
				} else {
					const defaultLayout = generateDefaultLayout();
					dispatch(setAdmissionLayout(defaultLayout));
					setCollapsedCategoryIds({});
					setTempLayout(defaultLayout);
				}

				setHasLayoutChanges(false);
				dispatch(setIsLayoutMode(true));
			} catch (error) {
				console.error("Error switching layout type:", error);
				const defaultLayout = generateDefaultLayout();
				dispatch(setAdmissionLayout(defaultLayout));
				setTempLayout(defaultLayout);
				dispatch(setIsLayoutMode(true));
			} finally {
				setTimeout(() => {
					setLayoutTypeLoading(false);
				}, 500);
			}
		},
		[dispatch, migrateLayout, patchAdmissionLayoutBase, generateDefaultLayout, fetchLayoutByType]
	);

	const handleToggleLayoutMode = useCallback(
		async (isSkipSave = false) => {
			if (isLayoutMode) {
				if (hasLayoutChanges && !isSkipSave) {
					const saved = await handleSaveLayout({ skipExitAfterSave: true });
					if (!saved) {
						return;
					}
				}

				if (isSuperUser && currentLayoutType === "default") {
					try {
						const rawLayout = await fetchLayoutByType("personal");
						if (rawLayout != null && typeof rawLayout === "object") {
							const normalizedLayout = ensureHospitalRootOrder(
								patchAdmissionLayoutBase(migrateLayout(rawLayout))
							);
							dispatch(setAdmissionLayout(normalizedLayout));
							setCollapsedCategoryIds(getCollapsedIdsFromLayout(normalizedLayout, false));
							setCurrentLayoutType("personal");
						} else {
							const defaultLayout = generateDefaultLayout();
							dispatch(setAdmissionLayout(defaultLayout));
							setCollapsedCategoryIds({});
							setCurrentLayoutType("personal");
						}
					} catch (error) {
						console.error("Error switching back to personal layout:", error);
						const defaultLayout = generateDefaultLayout();
						dispatch(setAdmissionLayout(defaultLayout));
						setCollapsedCategoryIds({});
						setCurrentLayoutType("personal");
					}
				}

				dispatch(setIsLayoutMode(false));
				setHasLayoutChanges(false);
				setTempLayout(
					(tempLayout &&
						typeof tempLayout === "object" &&
						!Array.isArray(tempLayout) &&
						tempLayout.version) ||
						isStoredLayoutV3(admissionLayout)
						? {}
						: []
				);
			} else {
				dispatch(setIsLayoutMode(true));
				if (isStoredLayoutV3(admissionLayout)) {
					setTempLayout(
						ensureHospitalRootOrder(patchAdmissionLayoutBase(migrateLayout(admissionLayout)))
					);
				} else {
					const cur =
						Array.isArray(admissionLayout) && admissionLayout.length > 0
							? admissionLayout
							: generateDefaultLayout();
					setTempLayout(cur);
				}
			}
		},
		[
			isLayoutMode,
			hasLayoutChanges,
			admissionLayout,
			generateDefaultLayout,
			currentLayoutType,
			dispatch,
			isSuperUser,
			migrateLayout,
			handleSaveLayout,
			patchAdmissionLayoutBase,
			tempLayout,
			fetchLayoutByType,
		]
	);

	handleToggleLayoutModeRef.current = handleToggleLayoutMode;

	const handleLayoutChangeInCategory = useCallback(
		(categoryId, newCards) => {
			const currentLayout = getCurrentLayoutV3();
			const updatedCategories = currentLayout.categories.map((cat) => {
				if (cat.id === categoryId) {
					return { ...cat, cards: newCards };
				}
				return cat;
			});
			setTempLayout(ensureHospitalRootOrder({ ...currentLayout, categories: updatedCategories }));
			setHasLayoutChanges(true);
		},
		[getCurrentLayoutV3]
	);

	const scrollToCategory = useCallback((categoryId) => {
		let attempts = 0;
		const maxAttempts = 20;
		const tryScroll = () => {
			const el = document.querySelector(`[data-category-id="${categoryId}"]`);
			if (el) {
				el.scrollIntoView({ behavior: "smooth", block: "center" });
				return;
			}
			if (attempts < maxAttempts) {
				attempts += 1;
				requestAnimationFrame(tryScroll);
			}
		};
		requestAnimationFrame(tryScroll);
	}, []);

	const handleCreateCategory = useCallback(() => {
		let base;
		if (
			isLayoutMode &&
			tempLayout &&
			typeof tempLayout === "object" &&
			!Array.isArray(tempLayout) &&
			tempLayout.version
		) {
			base = getCurrentLayoutV3();
		} else if (Array.isArray(tempLayout) && tempLayout.length > 0) {
			base = migrateLayout(tempLayout);
		} else if (Array.isArray(admissionLayout) && admissionLayout.length > 0) {
			base = migrateLayout(admissionLayout);
		} else {
			base = migrateLayout(generateDefaultLayout());
		}
		const newCategory = {
			id: `category_${Date.now()}`,
			title: "New Category",
			cards: [],
		};
		setTempLayout(
			ensureHospitalRootOrder({
				...base,
				categories: [...(base.categories || []), newCategory],
			})
		);
		setHasLayoutChanges(true);
		scrollToCategory(newCategory.id);
	}, [getCurrentLayoutV3, migrateLayout, admissionLayout, tempLayout, isLayoutMode, generateDefaultLayout, scrollToCategory]);

	const handleAddCategoryFromMenu = useAddCategoryFromMenu({
		pageLabel: "Admission",
		fetchLayoutByType,
		getCurrentLayout: getCurrentLayoutV3,
		patchLayoutBase: patchAdmissionLayoutBase,
		migrateLayout,
		dispatch,
		setPageLayout: setAdmissionLayout,
		setLayoutTypeLoading,
		setCurrentLayoutType,
		setTempLayout,
		setHasLayoutChanges,
		scrollToCategory,
	});

	const handleUpdateCategoryTitle = useCallback(
		(id, newTitle) => {
			const currentLayout = getCurrentLayoutV3();
			const updatedCategories = currentLayout.categories.map((cat) => {
				if (cat.id === id) {
					return { ...cat, title: newTitle };
				}
				return cat;
			});
			setTempLayout(ensureHospitalRootOrder({ ...currentLayout, categories: updatedCategories }));
			setHasLayoutChanges(true);
		},
		[getCurrentLayoutV3]
	);

	const handleDeleteCategory = useCallback(
		(id) => {
			const currentLayout = getCurrentLayoutV3();
			const categoryToDelete = currentLayout.categories.find((cat) => cat.id === id);
			const cardsToMove = categoryToDelete?.cards || [];

			const updatedCategories = currentLayout.categories.filter((cat) => cat.id !== id);
			const standaloneIds = new Set((currentLayout.standalone || []).map((c) => c.id));
			const cardsToAppend = cardsToMove.filter((c) => !standaloneIds.has(c.id));
			const updatedStandalone = [...(currentLayout.standalone || []), ...cardsToAppend];

			setTempLayout(
				ensureHospitalRootOrder({
					...currentLayout,
					standalone: updatedStandalone,
					categories: updatedCategories,
				})
			);
			setHasLayoutChanges(true);
		},
		[getCurrentLayoutV3]
	);

	const handleRootGapDrop = useCallback(
		(cardId, rootOrderIndex, _e, dragType) => {
			if (!cardId || typeof rootOrderIndex !== "number") return;
			const currentLayout = getCurrentLayoutV3();

			const isCategoryDrag =
				dragType === "category"
				|| currentLayout.categories.some((c) => c.id === cardId);
			if (isCategoryDrag) {
				const rootOrder = currentLayout.rootOrder || [];
				const fromIdx = rootOrder.findIndex((e) => e.id === cardId);
				if (fromIdx === -1) return;
				const targetIdx = Math.min(rootOrderIndex, rootOrder.length);
				const nextRootOrder = [...rootOrder];
				const [moved] = nextRootOrder.splice(fromIdx, 1);
				const adjusted = targetIdx > fromIdx ? targetIdx - 1 : targetIdx;
				nextRootOrder.splice(adjusted, 0, moved);
				const renumbered = nextRootOrder.map((e, i) => ({ ...e, position: i }));
				setTempLayout(
					ensureHospitalRootOrder({ ...currentLayout, rootOrder: renumbered })
				);
				setHasLayoutChanges(true);
				draggedCardIdRef.current = null;
				dragSourceRef.current = null;
				setTimeout(() => {
					setDraggedCardId(null);
					setHoveredCategoryId(null);
					setHoveredStandalone(false);
					setDragSource(null);
				}, 50);
				return;
			}

			// If the card is leaving its category and that was the last card, the
			// category becomes empty — drop it, matching the behavior of
			// `handleMoveCardToCategory`.
			const sourceCat = currentLayout.categories.find((cat) =>
				cat.cards.some((c) => c.id === cardId)
			);
			const removeEmptySourceCategoryId =
				sourceCat && sourceCat.cards.length === 1 ? sourceCat.id : null;

			let next = computeLayoutAfterRootGapInsert(currentLayout, cardId, rootOrderIndex);
			if (!next) return;

			if (removeEmptySourceCategoryId) {
				next = {
					...next,
					categories: next.categories.filter((c) => c.id !== removeEmptySourceCategoryId),
					rootOrder: (next.rootOrder || []).filter(
						(e) => e.id !== removeEmptySourceCategoryId
					),
				};
			}

			setTempLayout(ensureHospitalRootOrder(next));
			setHasLayoutChanges(true);

			// CRITICAL: clear the drag refs synchronously. After this drop event,
			// the source cell's `dragend` still fires and walks the category-source
			// `onDragStop` chain — that chain sees the release point over root area
			// (a gap has no `[data-category-id]` ancestor), classifies it as a
			// standalone drop, and calls `handleCardDrop("standalone", ...)`. That
			// would overwrite the gap-targeted insert with a plain append. Nulling
			// `draggedCardIdRef.current` here makes `handleCardDrop` early-return at
			// its `if (!activeId) return;` guard, so the gap insert wins.
			draggedCardIdRef.current = null;
			dragSourceRef.current = null;
			suppressCategoryInnerPersistRef.current = true;
			setTimeout(() => {
				setDraggedCardId(null);
				setHoveredCategoryId(null);
				setHoveredStandalone(false);
				setDragSource(null);
			}, 50);
			queueMicrotask(() => {
				suppressCategoryInnerPersistRef.current = false;
			});
		},
		[getCurrentLayoutV3]
	);

	const handleCardDropAtCategoryEdge = useCallback(
		(cardId, position, targetCategoryId) => {
			if (!cardId || !targetCategoryId) return;
			const layoutNow = getCurrentLayoutV3();
			const targetCat = layoutNow.categories.find((c) => c.id === targetCategoryId);
			if (!targetCat) return;
			// Filter out the moved card from the destination's existing cards so
			// we resolve the right "first card" when reordering within the same
			// category — otherwise dropping the first card on the start gap would
			// `insertBeforeId` itself and yield a no-op.
			const others = (targetCat.cards || []).filter((c) => c.id !== cardId);
			const insertBeforeId =
				position === 'start' && others.length > 0 ? others[0].id : null;
			handleMoveCardToCategory(cardId, targetCategoryId, {
				categoryInsertBeforeId: insertBeforeId,
			});
			// Same reasoning as `handleRootGapDrop`: clear refs synchronously so
			// the source's `onDragStop` chain (which fires after this drop event)
			// early-returns at `if (!activeId) return;` instead of re-applying a
			// generic standalone/category drop on top of our edge insert.
			draggedCardIdRef.current = null;
			dragSourceRef.current = null;
			suppressCategoryInnerPersistRef.current = true;
			setTimeout(() => {
				setDraggedCardId(null);
				setHoveredCategoryId(null);
				setHoveredStandalone(false);
				setDragSource(null);
			}, 50);
			queueMicrotask(() => {
				suppressCategoryInnerPersistRef.current = false;
			});
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[getCurrentLayoutV3]
	);

	const handleMoveCardToCategory = useCallback(
		(cardId, toCategoryId, moveOptions) => {
			const currentLayout = getCurrentLayoutV3();
			const normalizedTarget =
				toCategoryId === "standalone" || !toCategoryId ? "standalone" : toCategoryId;

			const sourceCat = currentLayout.categories.find((cat) =>
				cat.cards.some((c) => c.id === cardId)
			);
			const leavingCategory =
				sourceCat &&
				(normalizedTarget === "standalone" || normalizedTarget !== sourceCat.id);
			const removeEmptySourceCategoryId =
				sourceCat && sourceCat.cards.length === 1 && leavingCategory ? sourceCat.id : null;

			let next = computeLayoutAfterCardMove(
				currentLayout,
				cardId,
				normalizedTarget,
				moveOptions || {}
			);
			if (!next) return "noop";

			if (removeEmptySourceCategoryId) {
				next = {
					...next,
					categories: next.categories.filter((c) => c.id !== removeEmptySourceCategoryId),
				};
			}

			setTempLayout(ensureHospitalRootOrder(next));
			setHasLayoutChanges(true);
			return removeEmptySourceCategoryId ? "done_removed_empty_category" : "done";
		},
		[getCurrentLayoutV3]
	);

	const handleRootGridChange = useCallback(
		(orderedItems) => {
			const current = getCurrentLayoutV3();
			const catIds = new Set(current.categories.map((c) => c.id));
			const rootOrder = orderedItems.map((it, i) => ({
				id: it.id,
				type: catIds.has(it.id) ? "category" : "card",
				width: catIds.has(it.id) ? 12 : it.width || 4,
				position: i,
			}));
			setTempLayout(
				ensureHospitalRootOrder({
					...current,
					rootOrder,
				})
			);
			setHasLayoutChanges(true);
		},
		[getCurrentLayoutV3]
	);

	const handleCardDrop = useCallback(
		(targetId, targetTitle = "General Cards", dropEvent) => {
			const activeId = draggedCardIdRef.current;
			if (!activeId) return;

			const activeSource = dragSourceRef.current;

			if (activeSource === targetId) {
				draggedCardIdRef.current = null;
				dragSourceRef.current = null;
				setDraggedCardId(null);
				setHoveredCategoryId(null);
				setHoveredStandalone(false);
				setDragSource(null);
				return;
			}

			const isStandaloneTarget = targetId === "standalone" || !targetId;
			const pt =
				getPointerClientCoords(dropEvent) ||
				categoryDragPointerRef.current ||
				(Date.now() - lastPointerRef.current.timestamp < 500
					? lastPointerRef.current
					: null);
			const standaloneInsertBeforeId = isStandaloneTarget
				? getStandaloneInsertBeforeIdFromPoint(pt, activeId)
				: null;
			const categoryInsertTarget =
				!isStandaloneTarget && pt
					? getCategoryInsertBeforeTargetFromPoint(pt, activeId, {
						categoryId: targetId,
					})
					: null;
			const categoryInsertBeforeId =
				categoryInsertTarget && categoryInsertTarget.categoryId === targetId
					? categoryInsertTarget.insertBeforeId
					: null;

			const result = handleMoveCardToCategory(activeId, targetId, {
				...(isStandaloneTarget
					? { standaloneInsertBeforeId }
					: { categoryInsertBeforeId }),
			});
			draggedCardIdRef.current = null;
			dragSourceRef.current = null;
			setDraggedCardId(null);
			setHoveredCategoryId(null);
			setHoveredStandalone(false);
			setDragSource(null);

			if (result === "done" || result === "done_removed_empty_category") {


				if (targetId && targetId !== "standalone") {
					if (dropFlashTimeoutRef.current) {
						clearTimeout(dropFlashTimeoutRef.current);
					}
					setDropFlashCategoryId(targetId);
					dropFlashTimeoutRef.current = setTimeout(() => {
						setDropFlashCategoryId(null);
						dropFlashTimeoutRef.current = null;
					}, 750);
				}
			}
		},
		[handleMoveCardToCategory]
	);

	const handleLayoutChange = useCallback((newLayout) => {
		setTempLayout(newLayout);
		setHasLayoutChanges(true);
	}, []);

	const handleResetLayout = useCallback(async () => {
		try {
			const rawLayout = await fetchDefaultLayout();
			if (rawLayout != null && typeof rawLayout === "object") {
				if (Array.isArray(rawLayout)) {
					setTempLayout(rawLayout);
				} else {
					setTempLayout(migrateLayout(rawLayout));
				}
				setHasLayoutChanges(true);
			} else {
				const defaultLayout = generateDefaultLayout();
				setTempLayout(defaultLayout);
				setHasLayoutChanges(true);
			}
		} catch (error) {
			console.error("Error resetting layout:", error);
			const defaultLayout = generateDefaultLayout();
			setTempLayout(defaultLayout);
			setHasLayoutChanges(true);
		}
	}, [generateDefaultLayout, migrateLayout, fetchDefaultLayout]);

	// Prepare card data for drag-and-drop layout
	const cardData = useMemo(() => {
		const cards = [];

		// Only include cards that are actually selected/visible
		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.DOCTOR_DATA) || isMobile) {
			cards.push({
				id: ADMISSION_CARDS_TYPE.DOCTOR_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.DOCTOR_DATA),
				component: 'doctor'
			});
		}

		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.DAYS_DATA) || isMobile) {
			cards.push({
				id: ADMISSION_CARDS_TYPE.DAYS_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.DAYS_DATA),
				component: 'days'
			});
		}

		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.DX_DATA) || isMobile) {
			cards.push({
				id: ADMISSION_CARDS_TYPE.DX_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.DX_DATA),
				component: 'dx'
			});
		}

		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.INSURANCE_DATA) || isMobile) {
			cards.push({
				id: ADMISSION_CARDS_TYPE.INSURANCE_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.INSURANCE_DATA),
				component: 'insurance'
			});
		}

		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.FLOORS_DATA) || isMobile) {
			cards.push({
				id: ADMISSION_CARDS_TYPE.FLOORS_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.FLOORS_DATA),
				component: 'floors'
			});
		}

		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.HOSPITAL_DATA) || isMobile) {
			cards.push({
				id: ADMISSION_CARDS_TYPE.HOSPITAL_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.HOSPITAL_DATA, 'admission'),
				component: 'hospital'
			});
		}

		if (_.includes(admissionCards, ADMISSION_CARDS_TYPE.AVERAGE_STAY_DAYS_DATA) || isMobile) {
			cards.push({
				id: ADMISSION_CARDS_TYPE.AVERAGE_STAY_DAYS_DATA,
				width: getCardWidth(ADMISSION_CARDS_TYPE.AVERAGE_STAY_DAYS_DATA),
				component: 'averageStayDays'
			});
		}
		// Add dynamic cards to the drag-and-drop system
		if (admissionDynamicCards?.length > 0) {
			admissionDynamicCards.forEach((ele) => {
				if (_.includes(admissionCards, ele.accessor) || isMobile) {
					const row = ADMISSION_CUSTOM_CARD_DATA.find((r) => r.value === ele?.accessor && !r.isCustomTab);
					cards.push({
						id: getDynamicCardLayoutId(ele.accessor),
						width: 4, // Default width for dynamic cards (lg=4)
						component: 'dynamic',
						data: {
							...ele,
							isCustomTab: false,
							...(row && {
								_id: row._id || ele?._id,
								shareCount: row.shareCount ?? ele.shareCount,
								isUniversalAccess: row.isUniversalAccess ?? ele.isUniversalAccess,
								isUniversal: row.isUniversal ?? ele.isUniversal,
								isShared: row.isShared ?? ele.isShared,
								isCustomShare: row.isCustomShare ?? ele.isCustomShare,
								shareInfo: row.shareInfo ?? ele.shareInfo,
								sharedBy: row.sharedBy ?? ele.sharedBy,
								sharedByName: row.sharedByName ?? ele.sharedByName,
								shareId: row.shareId ?? ele.shareId,
							}),
						},
					});
				}
			});
		}

		// Add custom tab cards to the drag-and-drop system
		if (patientList?.customTabs?.length > 0) {
			patientList.customTabs.forEach((ele) => {
				if (_.includes(admissionCards, ele.accessor) || isMobile) {
					cards.push({
						id: getCustomTabCardLayoutId(ele.accessor),
						width: 4, // Default width for custom tab cards (lg=4)
						component: 'dynamic',
						data: { ...ele, isCustomTab: true }
					});
				}
			});
		}

		return cards;
	}, [admissionCards, admissionDynamicCards, patientList?.customTabs, isMobile, ADMISSION_CUSTOM_CARD_DATA]);

	const admissionMainGridPayload = useMemo(() => {
		const lo = getCurrentLayoutV3();
		const rootOrder = lo.rootOrder || [];
		const layoutForDrag = [];
		const cardsForGrid = [];
		rootOrder.forEach((entry) => {
			if (entry.type === "category") {
				const cat = lo.categories.find((c) => c.id === entry.id);
				if (!cat) return;
				const visibleCategoryCards = (cat.cards || [])
					.map((cardItem) => cardData.find((c) => c.id === cardItem.id))
					.filter(Boolean);
				if (!isLayoutMode && visibleCategoryCards.length === 0) return;
				const categoryForSizing = !isLayoutMode
					? { ...cat, cards: visibleCategoryCards }
					: cat;
				const isCollapsed = !isLayoutMode && Boolean(collapsedCategoryIds[entry.id]);
				const gridH = isCollapsed
					? 3
					: estimateCategoryGridRowUnits(categoryForSizing, cardData, {
						compactTwoCol: categoryInnerTwoCol,
					});
				const pos = layoutForDrag.length;
				layoutForDrag.push({
					id: entry.id,
					type: entry.type,
					width: entry.width,
					position: pos,
					title: entry.title,
				});
				cardsForGrid.push({
					id: entry.id,
					type: "category",
					width: 12,
					gridH,
				});
				return;
			}
			const def = cardData.find((c) => c.id === entry.id);
			if (!def?.component) return;
			const s = lo.standalone.find((c) => c.id === entry.id);
			const pos = layoutForDrag.length;
			layoutForDrag.push({
				id: entry.id,
				type: entry.type,
				width: entry.width,
				position: pos,
				title: entry.title,
			});
			cardsForGrid.push({
				...def,
				...s,
				id: entry.id,
				type: "card",
				width: s?.width ?? def?.width ?? 4,
				gridH: 24,
			});
		});
		return { layoutForDrag, cardsForGrid };
	}, [getCurrentLayoutV3, cardData, isLayoutMode, collapsedCategoryIds, categoryInnerTwoCol]);

	const persistCollapsedCategories = useCollapsedCategoriesPersistence({
		page: PAGE_TYPE.ADMISSION,
		layoutType: currentLayoutType,
		layout: admissionLayout,
		cards: admissionCards,
	});

	const handleToggleCategoryCollapse = useCallback(
		(categoryId) => {
			setCollapsedCategoryIds((prev) => {
				const next = {
					...prev,
					[categoryId]: !prev?.[categoryId],
				};
				persistCollapsedCategories(next);

				// Keep Redux in sync AFTER the animation settles so we don't
				// interrupt the 1400ms CategoryBox expand/collapse transition.
				setTimeout(() => {
					dispatch((dispatchArg, getState) => {
						const { admissionLayout: currentLayout } = getState().customCard;
						if (!currentLayout) return;
						const synced = applyCollapsedStateToLayout(currentLayout, next);
						dispatchArg(setAdmissionLayout(synced));
					});
				}, 1500);

				return next;
			});
		},
		[persistCollapsedCategories, dispatch]
	);

	const prepareScrollToCard = useCallback(
		async (targetId) => {
			if (isLayoutMode) return;
			const lo = getCurrentLayoutV3();
			const categoryId = findCategoryIdContainingCard(lo, targetId);
			if (!categoryId) return;
			const wasCollapsed = Boolean(collapsedCategoryIds[categoryId]);
			if (!wasCollapsed) return;
			// Bring the minimized category into view FIRST so the user can
			// actually see it expand — otherwise the animation plays off-screen.
			const categoryEl = document.querySelector(
				`[data-category-id="${categoryId}"]`
			);
			if (categoryEl) {
				try {
					categoryEl.scrollIntoView({ behavior: 'auto', block: 'center' });
				} catch { /* non-fatal */ }
			}
			await new Promise((resolve) => {
				requestAnimationFrame(() => requestAnimationFrame(resolve));
			});
			setCollapsedCategoryIds((prev) => {
				if (!prev[categoryId]) return prev;
				return { ...prev, [categoryId]: false };
			});
			// Wait for the CategoryBox maximize animation to visibly complete
			// BEFORE the caller scrolls to the target card and fires the
			// highlight flash. Must be >= the enter timing in CategoryBox's
			// Collapse (`timeout.enter`) and the matching outer
			// `.react-grid-item` CSS transition in DragDropLayout
			// (`:has([data-category-id][data-collapsed="false"])`). Both are
			// currently 1400ms — 1500ms adds a tiny buffer.
			await new Promise((resolve) => {
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						setTimeout(resolve, 1500);
					});
				});
			});
		},
		[getCurrentLayoutV3, isLayoutMode, collapsedCategoryIds]
	);

	// AI Chat handlers
	const handleAiChatToggle = useCallback(() => {
		setAiChatOpen(!aiChatOpen);
		if (!aiChatOpen) {
			setAiChatUnreadCount(0); // Clear unread count when opening
		}
	}, [aiChatOpen]);

	const handleAiChatClose = useCallback(() => {
		setAiChatOpen(false);
		setAiChatMinimized(false);
	}, []);

	const handleAiChatMinimizeStateChange = useCallback((isMinimized) => {
		setAiChatMinimized(isMinimized);
	}, []);

	// handleVectorStoreIdUpdate — disabled (new agent API never invokes this callback)
	/*
	const handleVectorStoreIdUpdate = useCallback((vectorStoreId) => {
		setAiVectorStoreId(vectorStoreId);
		// Vector store caching + cleanup registration — disabled (new agent API does not use vector stores)
		// Cache the vector store ID for the current context
		const cacheKey = getVectorStoreCacheKey();
		if (cacheKey && vectorStoreId) {
			localStorage.setItem(cacheKey, vectorStoreId);
			// Register for cleanup on logout
			registerVectorStoreId(vectorStoreId, 'admission');
		}
	}, [getVectorStoreCacheKey]);
	*/

	// Prepare AI chat context data using the new modular hooks
	const aiChatContext = useAIChatContext({
		// Page identification
		pageType: PAGE_TYPE.ADMISSION, // CRITICAL: Identifies this as Admission page for correct API endpoint and vector store

		// Core data dependencies
		dbData,
		filterListData,
		patientList,
		activeFacilities,
		facilities: activeFacilities,
		dynamicCards: admissionDynamicCards,

		// Filter and state dependencies
		filter,
		transferType,
		cardFilter,
		percentageBy,
		lockedTotalBy,
		specialComparisonSet: false,
		filterTotal,
		percentageAgainst,
		projectionDays,
		lastADTDate,

		// UI state dependencies
		admissionCards,
		rangesSet,
		isLayoutMode,

		// Function dependencies
		getPriorityNumber,
		lockedTotal,
		lockedByFacility,
		isCensusTotalLocked,
		facilityPercentage: adtFacilityPercentage,

		// Metadata dependencies
		ADMISSION_CUSTOM_CARD_DATA,
		tooltipsInfo,

		// Service dependencies — disabled (services not initialized; optional chaining inside the hook handles undefined)
		/*
		aiCensusActionsService,
		aiReportActionsService,
		aiTransferActionsService,
		aiDialogActionsService,
		aiDateSuggestionsService,
		*/

		// Chart data dependencies (if available)
		chartData: null,
		chartAggregationType: null,
		currentChartFilter: null,

		// ✅ ADMISSION-SPECIFIC PARAMETERS (for useAIAdmissionChatContext)
		lockFilterTotalState,
		reversedColorAdmission,
		comparingAgainstDifferentFacility
	});



	// Card renderer function
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const renderCard = useCallback((card) => {
		// Layout-mode fast path: render a per-card-type lightweight preview —
		// same UI shape as the real card, but the body is a dummy skeleton so
		// there are no redux subscriptions, filter math or data fetches during
		// drag. The saved layout payload is unchanged (same id/type/width/
		// position) — this only affects what is rendered while the user is
		// reorganizing the grid. See `features/admissions/components/layoutPreview/`
		// and the shared `components/shared/layoutPreview/` module for the details.
		if (isLayoutMode) {
			return (
				<AdmissionCardLayoutPreview
					card={card}
					dynamicCards={dynamicCards}
					sharedUsersByTabId={sharedUsersByCustomTabId}
				/>
			);
		}

		switch (card.component) {
			case 'averageStayDays':
				return (
					<CardAnimation id={`${ADMISSION_CARDS_TYPE.AVERAGE_STAY_DAYS_DATA}_scroll`} checked={_.includes(admissionCards, ADMISSION_CARDS_TYPE.AVERAGE_STAY_DAYS_DATA)} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.ADMISSION}
							loading={loading || loadingComparison}
							title={ADMISSION_CARDS_LABELS.averageStayDaysData}
							style={{ height: '100%' }}
							styleContent={{ height: 'auto', minHeight: 'fit-content', overflow: 'visible' }}
							disableInteractions={isLayoutMode}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, ADMISSION_CARDS_TYPE.AVERAGE_STAY_DAYS_DATA, PATIENT_RELATION.AVERAGE_STAY_DAYS, false, defaultTab)
							}
							priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.AVERAGE_STAY_DAYS_DATA)}
							tooltipContent={tooltipsInfo.admissionsPage?.averageStayDays}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(ADMISSION_CARDS_TYPE.AVERAGE_STAY_DAYS_DATA, title, false, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, ADMISSION_CARDS_TYPE.AVERAGE_STAY_DAYS_DATA, false)
							}
						>
							<AverageLengthOfStayCard
								data={filterListData.averageStayDaysData}
								comparisonData={filterListDataComparison?.averageStayDaysData}
								loading={loading}
								loadingComparison={loadingComparison}
								filter={filter}
								filterComparison={filterComparison}
								comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
								admissionCompareAgainst={
									lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData.bedCapacity
								}
								admissionCompareAgainstComparison={
									lockFilterTotalStateComparison?.isLocked
										? lockFilterTotalStateComparison?.lockedFilterTotal
										: dbDataComparison?.bedCapacity
								}
								reverseColorsAdmissionPage={reversedColorAdmission}
								isMobile={isMobile}
								page={PAGE_TYPE.ADMISSION}
							/>
						</Card>
					</CardAnimation>
				);

			case 'doctor':
				return (
					<CardAnimation id={`${ADMISSION_CARDS_TYPE.DOCTOR_DATA}_scroll`} checked={_.includes(admissionCards, ADMISSION_CARDS_TYPE.DOCTOR_DATA)} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.ADMISSION}
							loading={loading || loadingComparison}
							title={ADMISSION_CARDS_LABELS.doctorData}
							taggedList={
								<TaggedList
									type={ADMISSION_CARDS_TYPE.DOCTOR_DATA}
									data={filterListData.doctorData}
									selectedItem={cardFilter.doctorData}
								/>
							}
							tooltipContent={tooltipsInfo.admissionsPage.perDoctor}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, ADMISSION_CARDS_TYPE.DOCTOR_DATA, PATIENT_RELATION.DOCTOR, false, defaultTab)
							}
							priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.DOCTOR_DATA)}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(ADMISSION_CARDS_TYPE.DOCTOR_DATA, title, false, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, ADMISSION_CARDS_TYPE.DOCTOR_DATA, false)
							}
							secondaryTitleError={
								comparingAgainstDifferentFacility &&
								rangesSet &&
								"Comparison function disabled when comparing to other facilities"
							}
							secondaryTitleClassName="error"
							selectedItems={cardFilter.doctorData}
							data={filterListData.doctorData}
							type={ADMISSION_CARDS_TYPE.DOCTOR_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={ADMISSION_CARDS_TYPE.DOCTOR_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
						>
							<DoctorCard
								cardTitle={ADMISSION_CARDS_LABELS.doctorData}
								data={filterListData.doctorData}
								comparisonData={filterListDataComparison?.doctorData}
								totalAdmissions={dbData.total}
								totalAdmissionsComparison={dbDataComparison?.total}
								minimizable={true}
								admissionCompareAgainst={
									lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData.bedCapacity
								}
								admissionCompareAgainstComparison={
									lockFilterTotalStateComparison?.isLocked
										? lockFilterTotalStateComparison?.lockedFilterTotal
										: dbDataComparison?.bedCapacity
								}
								handleToggle={handleToggle}
								handleToggleAll={handleToggleAll}
								selectedItem={cardFilter.doctorData}
								type={ADMISSION_CARDS_TYPE.DOCTOR_DATA}
								page={PAGE_TYPE.ADMISSION}
								filter={filter}
								loading={loading || loadingComparison}
								reverseColorsAdmissionPage={reversedColorAdmission}
								filterComparison={filterComparison}
								comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
								projectionDays={projectionDays}
								averageCensus={percentageAgainst}
								filterTotal={filterTotal}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.DOCTOR_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
								isMobile={isMobile}
							/>
						</Card>
					</CardAnimation>
				);

			case 'days':
				return (
					<CardAnimation id={`${ADMISSION_CARDS_TYPE.DAYS_DATA}_scroll`} checked={_.includes(admissionCards, ADMISSION_CARDS_TYPE.DAYS_DATA)} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.ADMISSION}
							loading={loading || loadingComparison}
							title={ADMISSION_CARDS_LABELS.daysData}
							handleOnClickAction={(title, defaultTab) => handleChartDialog(title, ADMISSION_CARDS_TYPE.DAYS_DATA, null, false, defaultTab)}
							taggedList={
								<TaggedList
									type={ADMISSION_CARDS_TYPE.DAYS_DATA}
									data={filterListData.daysData}
									selectedItem={cardFilter.daysData}
								/>
							}
							tooltipContent={tooltipsInfo.admissionsPage.perDayOfWeek}
							priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.DAYS_DATA)}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(ADMISSION_CARDS_TYPE.DAYS_DATA, title, false, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, ADMISSION_CARDS_TYPE.DAYS_DATA, false)
							}
							cardType={ADMISSION_CARDS_TYPE.DAYS_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
						>
							{!isMobile ? (
								<DayCardList
									isMobile={isMobile}
									cardTitle={ADMISSION_CARDS_LABELS.daysData}
									dbData={dbData}
									dbDataComparison={dbDataComparison}
									data={filterListData.daysData}
									dataComparison={filterListDataComparison?.daysData}
									totalAdmissions={dbData.total}
									totalAdmissionsComparison={dbDataComparison?.total}
									handleToggle={handleToggle}
									filter={filter}
									filterComparison={filterComparison}
									admissionCompareAgainst={
										lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData.bedCapacity
									}
									admissionCompareAgainstComparison={
										lockFilterTotalStateComparison?.isLocked
											? lockFilterTotalStateComparison?.lockedFilterTotal
											: dbDataComparison?.bedCapacity
									}
									selectedItem={cardFilter.daysData}
									type={ADMISSION_CARDS_TYPE.DAYS_DATA}
									page={PAGE_TYPE.ADMISSION}
									loading={loading || loadingComparison}
									reverseColorsAdmissionPage={reversedColorAdmission}
									comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
									projectionDays={projectionDays}
									filterTotal={filterTotal}
									priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.DAYS_DATA)}
									disableInteractions={isLayoutMode}
								/>
							) : (
								<FloorCardList
									cardTitle={ADMISSION_CARDS_LABELS.daysData}
									data={filterListData?.daysData?.map(item => ({ ...item, total: item.value })) || []}
									dataComparison={filterListDataComparison?.daysData?.map(item => ({ ...item, total: item.value })) || []}
									handleToggle={handleToggle}
									handleToggleAll={handleToggleAll}
									loading={loading || loadingComparison}
									selectedItem={cardFilter.daysData}
									type={ADMISSION_CARDS_TYPE.DAYS_DATA}
									page={PAGE_TYPE.ADMISSION}
									filter={filter}
									filterComparison={filterComparison}
									averageCensus={percentageAgainst}
									admissionCompareAgainst={
										lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData.bedCapacity
									}
									admissionCompareAgainstComparison={
										lockFilterTotalStateComparison?.isLocked
											? lockFilterTotalStateComparison?.lockedFilterTotal
											: dbDataComparison?.bedCapacity
									}
									projectionDays={projectionDays}
									filterTotal={filterTotal}
									isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
									priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.DAYS_DATA)}
									transferType={transferType}
									lockedTotalBy={lockedTotalBy}
									disableInteractions={isLayoutMode}
								/>
							)}
						</Card>
					</CardAnimation>
				);

			case 'dx':
				return (
					<CardAnimation id={`${ADMISSION_CARDS_TYPE.DX_DATA}_scroll`} checked={_.includes(admissionCards, ADMISSION_CARDS_TYPE.DX_DATA)} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.ADMISSION}
							loading={loading || loadingComparison}
							title="Per Diagnosis"
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, ADMISSION_CARDS_TYPE.DX_DATA, PATIENT_RELATION.DX, false, defaultTab)
							}
							taggedList={
								<TaggedList
									type={ADMISSION_CARDS_TYPE.DX_DATA}
									data={filterListData.dxData}
									selectedItem={cardFilter.dxData}
								/>
							}
							tooltipContent={tooltipsInfo.admissionsPage.perDiagnosis}
							priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.DX_DATA)}
							handleOnClickReport={(title) => handleOnClickReport(ADMISSION_CARDS_TYPE.DX_DATA, title)}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, ADMISSION_CARDS_TYPE.DX_DATA, false)
							}
							selectedItems={cardFilter.dxData}
							data={filterListData.dxData}
							type={ADMISSION_CARDS_TYPE.DX_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={ADMISSION_CARDS_TYPE.DX_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
						>
							<DxCardList
								cardTitle="Per Diagnosis"
								data={filterListData.dxData}
								dataComparison={filterListDataComparison?.dxData}
								filter={filter}
								filterComparison={filterComparison}
								admissionCompareAgainst={
									lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData.bedCapacity
								}
								admissionCompareAgainstComparison={
									lockFilterTotalStateComparison?.isLocked
										? lockFilterTotalStateComparison?.lockedFilterTotal
										: dbDataComparison?.bedCapacity
								}
								handleToggle={handleToggle}
								selectedItem={cardFilter.dxData}
								type={ADMISSION_CARDS_TYPE.DX_DATA}
								page={PAGE_TYPE.ADMISSION}
								loading={loading || loadingComparison}
								reverseColorsAdmissionPage={reversedColorAdmission}
								comparingAgainstDifferentFacility={false}
								projectionDays={projectionDays}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.DX_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
							/>
						</Card>
					</CardAnimation>
				);

			case 'insurance':
				return (
					<CardAnimation id={`${ADMISSION_CARDS_TYPE.INSURANCE_DATA}_scroll`} checked={_.includes(admissionCards, ADMISSION_CARDS_TYPE.INSURANCE_DATA)} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.ADMISSION}
							loading={loading || loadingComparison}
							title={ADMISSION_CARDS_LABELS.insuranceData}
							itemAlign={"ais"}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, ADMISSION_CARDS_TYPE.INSURANCE_DATA, PATIENT_RELATION.PAYER_INSURANCE, false, defaultTab)
							}
							tooltipContent={tooltipsInfo.admissionsPage.perInsurance}
							priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.INSURANCE_DATA)}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(ADMISSION_CARDS_TYPE.INSURANCE_DATA, title, false, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, ADMISSION_CARDS_TYPE.INSURANCE_DATA, false)
							}
							selectedItems={cardFilter.insuranceData}
							data={filterListData.insuranceData}
							type={ADMISSION_CARDS_TYPE.INSURANCE_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={ADMISSION_CARDS_TYPE.INSURANCE_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
						>
							<InsuranceCard
								dbData={dbData}
								dbDataComparison={dbDataComparison}
								cardTitle={ADMISSION_CARDS_LABELS.insuranceData}
								data={filterListData.insuranceData}
								dataComparison={filterListDataComparison?.insuranceData}
								totalAdmissions={dbData.total}
								totalAdmissionsComparison={dbDataComparison?.total}
								handleToggle={handleToggle}
								selectedItem={cardFilter.insuranceData}
								type={ADMISSION_CARDS_TYPE.INSURANCE_DATA}
								page={PAGE_TYPE.ADMISSION}
								filter={filter}
								admissionCompareAgainst={
									lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData.bedCapacity
								}
								admissionCompareAgainstComparison={
									lockFilterTotalStateComparison?.isLocked
										? lockFilterTotalStateComparison?.lockedFilterTotal
										: dbDataComparison?.bedCapacity
								}
								filterComparison={filterComparison}
								reverseColorsAdmissionPage={reversedColorAdmission}
								comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
								loading={loading || loadingComparison}
								projectionDays={projectionDays}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.INSURANCE_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
							/>
						</Card>
					</CardAnimation>
				);

			case 'floors':
				return (
					<CardAnimation id={`${ADMISSION_CARDS_TYPE.FLOORS_DATA}_scroll`} checked={_.includes(admissionCards, ADMISSION_CARDS_TYPE.FLOORS_DATA)} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.ADMISSION}
							loading={loading || loadingComparison}
							title={ADMISSION_CARDS_LABELS.floorsData}
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, ADMISSION_CARDS_TYPE.FLOORS_DATA, PATIENT_RELATION.UNIT, false, defaultTab)
							}
							taggedList={
								<TaggedList
									type={ADMISSION_CARDS_TYPE.FLOORS_DATA}
									data={filterListData.floorsData}
									selectedItem={cardFilter.floorsData}
								/>
							}
							tooltipContent={tooltipsInfo.admissionsPage.perFloor}
							priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.FLOORS_DATA)}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(ADMISSION_CARDS_TYPE.FLOORS_DATA, title, false, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, ADMISSION_CARDS_TYPE.FLOORS_DATA, false)
							}
							secondaryTitleError={
								comparingAgainstDifferentFacility &&
								rangesSet &&
								"Comparison function disabled when comparing to other facilities"
							}
							secondaryTitleClassName="error"
							selectedItems={cardFilter.floorsData}
							data={filterListData.floorsData}
							type={ADMISSION_CARDS_TYPE.FLOORS_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={ADMISSION_CARDS_TYPE.FLOORS_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
						>
							<FloorCardList
								cardTitle={ADMISSION_CARDS_LABELS.floorsData}
								data={filterListData.floorsData}
								dataComparison={filterListDataComparison?.floorsData}
								totalAdmissions={dbData.total}
								totalAdmissionsComparison={dbDataComparison?.total}
								handleToggle={handleToggle}
								filter={filter}
								filterComparison={filterComparison}
								selectedItem={cardFilter.floorsData}
								type={ADMISSION_CARDS_TYPE.FLOORS_DATA}
								page={PAGE_TYPE.ADMISSION}
								admissionCompareAgainst={
									lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData.bedCapacity
								}
								admissionCompareAgainstComparison={
									lockFilterTotalStateComparison?.isLocked
										? lockFilterTotalStateComparison?.lockedFilterTotal
										: dbDataComparison?.bedCapacity
								}
								reverseColorsAdmissionPage={reversedColorAdmission}
								comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
								loading={loading || loadingComparison}
								projectionDays={projectionDays}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.FLOORS_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
							/>
						</Card>
					</CardAnimation>
				);

			case 'hospital':
				return (
					<CardAnimation id={`${ADMISSION_CARDS_TYPE.HOSPITAL_DATA}_scroll`} checked={_.includes(admissionCards, ADMISSION_CARDS_TYPE.HOSPITAL_DATA)} style={{ height: '100%' }}>
						<Card
							pageType={PAGE_TYPE.ADMISSION}
							loading={loading || loadingComparison}
							title="Per Hospital"
							handleOnClickAction={(title, defaultTab) =>
								handleChartDialog(title, ADMISSION_CARDS_TYPE.HOSPITAL_DATA, PATIENT_RELATION.HOSPITAL, false, defaultTab)
							}
							taggedList={
								<TaggedList
									type={ADMISSION_CARDS_TYPE.HOSPITAL_DATA}
									data={filterListData.hospitalData}
									selectedItem={cardFilter.hospitalData}
								/>
							}
							tooltipContent={tooltipsInfo.admissionsPage.perHospital}
							priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.HOSPITAL_DATA)}
							handleOnClickReport={(title, otherData) =>
								handleOnClickReport(ADMISSION_CARDS_TYPE.HOSPITAL_DATA, title, false, false, otherData)
							}
							handleOnClickShareReport={(title) =>
								handleOnClickShareReport(title, ADMISSION_CARDS_TYPE.HOSPITAL_DATA, false)
							}
							secondaryTitleError={
								comparingAgainstDifferentFacility &&
								rangesSet &&
								"Comparison function disabled when comparing to other facilities"
							}
							secondaryTitleClassName="error"
							selectedItems={cardFilter.hospitalData}
							data={filterListData.hospitalData}
							type={ADMISSION_CARDS_TYPE.HOSPITAL_DATA}
							handleToggleAll={handleToggleAll}
							canBeSearched={true}
							cardType={ADMISSION_CARDS_TYPE.HOSPITAL_DATA}
							style={{ height: '100%' }}
							disableInteractions={isLayoutMode}
						>
							<HospitalList
								dbData={dbData}
								dbDataComparison={dbDataComparison}
								cardTitle="Per Hospital"
								total={dbData.total}
								totalComparison={dbDataComparison?.total}
								data={filterListData.hospitalData}
								dataComparison={filterListDataComparison?.hospitalData}
								filter={filter}
								filterComparison={filterComparison}
								handleToggle={handleToggle}
								selectedItem={cardFilter.hospitalData}
								type={ADMISSION_CARDS_TYPE.HOSPITAL_DATA}
								page={PAGE_TYPE.ADMISSION}
								admissionCompareAgainst={
									lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData.bedCapacity
								}
								admissionCompareAgainstComparison={
									lockFilterTotalStateComparison?.isLocked
										? lockFilterTotalStateComparison?.lockedFilterTotal
										: dbDataComparison?.bedCapacity
								}
								loading={loading || loadingComparison}
								reverseColorsAdmissionPage={reversedColorAdmission}
								comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
								projectionDays={projectionDays}
								filterTotal={filterTotal}
								averageCensus={percentageAgainst}
								priorityData={cardFilter.mainPriorityData}
								priorityNumber={getPriorityNumber(ADMISSION_CARDS_TYPE.HOSPITAL_DATA)}
								transferType={transferType}
								lockedTotalBy={lockedTotalBy}
								disableInteractions={isLayoutMode}
							/>
						</Card>
					</CardAnimation>
				);

			case 'dynamic':
				return (
					<div style={{ height: '100%' }}>
						<DynamicCardItem
							filterTotal={filterTotal}
							key={card.data?.accessor}
							ele={card.data}
							pageType={PAGE_TYPE.ADMISSION}
							selectedCards={admissionCards}
							loading={loading}
							loadingComparison={loadingComparison}
							filterListData={filterListData}
							filterListDataComparison={filterListDataComparison}
							cardFilter={cardFilter}
							handleChartDialog={handleChartDialog}
							handleOnClickReport={handleOnClickReport}
							handleOnClickShareReport={handleOnClickShareReport}
							handleToggle={handleToggle}
							handleToggleAll={handleToggleAll}
							filter={filter}
							filterComparison={filterComparison}
							dbData={dbData}
							dbDataComparison={dbDataComparison}
							percentageAgainst={percentageAgainst}
							projectionDays={projectionDays}
							getPriorityNumber={getPriorityNumber}
							transferType={transferType}
							lockedTotalBy={lockedTotalBy}
							isCustomTab={card.data.isCustomTab}
							disableInteractions={isLayoutMode}
							admissionCompareAgainst={
								lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData.bedCapacity
							}
							admissionCompareAgainstComparison={
								lockFilterTotalStateComparison?.isLocked
									? lockFilterTotalStateComparison?.lockedFilterTotal
									: dbDataComparison?.bedCapacity
							}
							reverseColorsAdmissionPage={reversedColorAdmission}
							sharedUsersByTabId={sharedUsersByCustomTabId}
							sharedWithEveryoneByTabId={sharedWithEveryoneByTabId}
						/>
					</div>
				);

			default:
				return null;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		loading,
		loadingComparison,
		filterListData,
		filterListDataComparison,
		cardFilter,
		handleChartDialog,
		handleOnClickReport,
		handleOnClickShareReport,
		handleToggle,
		handleToggleAll,
		filter,
		filterComparison,
		dbData,
		dbDataComparison,
		percentageAgainst,
		projectionDays,
		getPriorityNumber,
		transferType,
		lockedTotalBy,
		comparingAgainstDifferentFacility,
		rangesSet,
		admissionCards,
		filterTotal,
		isLayoutMode,
		sharedUsersByCustomTabId,
		sharedWithEveryoneByTabId
	]);

	return (
		<Page title="Dashboard: Admissions">
			{detailsDialog.isOpen && (
				<AdmissionCardDetailsDialog
					handleGenerateExcelReport={downloadExcel}
					handleOnClickReport={handleOnClickReportGraph}
					handleOnClickShareReport={handleOnClickShareReport}
				/>
			)}
			{detailsADTDialog.isOpen && (
				<AdmissionADTDetailsDialog
					handleGenerateExcelReport={downloadExcel}
					handleOnClickReport={(data) => handleOnClickReportGraph(data, true)}
					handleOnClickShareReport={handleOnClickShareReport}
				/>
			)}
			<div
				id="scroll-container"
				ref={scrollDemoRef}
				className={dashboardStyles.content}
				onScroll={handleScroll}
				style={{
					position: 'relative',
					...(isLayoutMode ? { overflowX: 'hidden' } : {}),
				}}
			>
				{/* Layout Type Loading Overlay */}
				{layoutTypeLoading && (
					<div style={{
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(255, 255, 255, 0.9)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 99999,
						flexDirection: 'column',
						gap: '16px'
					}}>
						<CircularProgress size={40} />
						<div style={{ fontSize: '16px', color: '#333', fontWeight: '500' }}>Loading layout...</div>
					</div>
				)}
				{!isLayoutMode && (
					<div className={`df aic ${styles.header}`}>
						<div className={`df aic ${styles.aoWrapper}`}>
							<AdmissionHeader
								isHeaderVisible={isHeaderVisible}
								setIsHeaderVisible={setIsHeaderVisible}
								filterListData={filterListData}
								handleFilterUpdate={() => setIsDateUpdated(true)}
								loading={loading || loadingComparison}
								setLoading={setLoading}
								setLoadingComparison={setLoadingComparison}
								projectionDays={projectionDays}
								isComparingAgainstAvgCensus={filterListData.isComparingAgainstAvgCensus}
								percentageAgainst={percentageAgainst}
								projectionSelectionBlock={<PickProjectionDaysPopup open={projectionPopupOpen} setOpen={setProjectionPopupOpen} loading={loading} />}
								dynamicCards={admissionHeaderPopoverDynamicCards}
								renderCardFilterPopover={renderAdmissionCardFilterPopover}
								renderAdtTabFilterPopover={renderAdmissionAdtTabFilterPopover}
								interactiveHeaderFilterPopoverSlowTransition
								isOnlyHospitalDashboard={isOnlyHospitalDashboard}
								isLayoutMode={isLayoutMode}
								isMobile={isMobile}
								isDataFromCache={isDataFromCache}
							/>
						</div>
					</div>
				)}
				{(loading || admissionLoading) ?
					<div style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						height: "90vh"
					}}>
						<CircularProgress />
					</div> : (
						<Box
							ref={layoutZoomWrapperRef}
							sx={{
								...(isLayoutMode
									? {
										transform: `scale(${isMobile ? ADMISSION_LAYOUT_MODE_ZOOM_MOBILE : ADMISSION_LAYOUT_MODE_ZOOM_DESKTOP})`,
										transformOrigin: 'top left',
										width: `calc(100% / ${isMobile ? ADMISSION_LAYOUT_MODE_ZOOM_MOBILE : ADMISSION_LAYOUT_MODE_ZOOM_DESKTOP})`,
										maxWidth: 'none',
										transition: 'transform 0.22s ease-out, width 0.22s ease-out',
										willChange: 'transform',
									}
									: {}),
							}}
						>
							<NoteContainer page={PAGE_TYPE.ADMISSION} isMobile={isMobile} isHeaderVisible={isHeaderVisible}>
								<Grid container justifyContent={"center"} sx={{ mt: "30px" }}>
									<Grid item xs={12} position={"relative"}>
										{rangesSet && !isMobile && <ColorInfoBox isLayoutMode={isLayoutMode} style={{ right: "1%" }} loading={loading || loadingComparison} />}
										{!isMobile && (
											<AddCardDrawer
												listData={ADMISSION_CUSTOM_CARD_DATA}
												selectedCards={admissionCards}
												handleAddCustomCard={handleAddCustomCard}
												scrollTop={scrollPosition?.scrollTop}
												filter={filter}
												isLayoutMode={isLayoutMode}
												pinTopInLayoutMode={true}
												prepareScrollToCard={prepareScrollToCard}
											/>
										)}
										<TotalCountCircle
											isHeaderVisible={isHeaderVisible}
											isLayoutMode={isLayoutMode}
											page={PAGE_TYPE.ADMISSION}
											loading={loading || loadingComparison}
											totalTitle="Total Admissions"
											projectTitle={percentageBy}
											selected={transferType === ADMISSION_TYPES.ALL}
											handleClickTotal={() => {
												triggerFilterTutorial();
												handleClickTotal(dbData.total, dbDataComparison?.total)
											}}
											total={dbData.total}
											totalComparison={dbDataComparison?.total}
											admissionCompareAgainst={
												lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : percentageAgainst
											}
											admissionCompareAgainstComparison={
												lockFilterTotalStateComparison?.isLocked
													? lockFilterTotalStateComparison?.lockedFilterTotal
													: dbDataComparison?.bedCapacity
											}
											dbData={dbData}
											dbDataComparison={dbDataComparison}
											filter={filter}
											filterComparison={filterComparison}
											totalPercentage={itemPercentage(dbData.total, percentageAgainst, "number")}
											totalComparisonPercentage={dbDataComparison?.total}
											totalProjectionPercentage={itemPercentage(
												projectionPerMonth(dbData.total, filter, projectionDays),
												percentageAgainst,
												"number"
											)}
											totalProjectionComparisonPercentage={itemPercentage(
												projectionPerMonth(dbDataComparison?.total, filterComparison, projectionDays),
												dbDataComparison?.total,
												"number"
											)}
											projectTotal={projectionPerMonth(dbData.total, filter, projectionDays)}
											projectTotalComparison={projectionPerMonth(dbDataComparison?.total, filterComparison, projectionDays)}
											tooltipContent={tooltipsInfo.admissionsPage.totalAdmissions}
											handleOnClickAction={(title, defaultTab) => handleChartDialog(title, ADMISSION_CARDS_TYPE.TOTAL, null, true, defaultTab)}
											handleOnClickReport={(title) => handleOnClickReport(ADMISSION_CARDS_TYPE.TOTAL, title, true)}
											handleOnClickShareReport={(title) => handleOnClickShareReport(title, ADMISSION_CARDS_TYPE.TOTAL, true)}
											comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
											projectionDays={projectionDays}
											totalCardType={"total"}
											isMobile={isMobile}
										/>
									</Grid>
								</Grid>
								<Box sx={{ p: 2, pl: 2, pr: 2, ...(isMobile && { marginBottom: "20px" }) }}>
									{/* Transfer Type Selection */}
									<Grid container spacing={isMobile ? 0 : 2} direction={"row"} display="flex" justifyContent="center">
										<Grid item xs={6} sm={6} md={6}>
											<SelectableCard
												pageType={PAGE_TYPE.ADMISSION}
												loading={loading || loadingComparison}
												title="New Admissions"
												disabled={isLayoutMode || transferType === ADMISSION_TYPES.READMISSION}
												selected={transferType === ADMISSION_TYPES.ADMISSION}
												handleOnclickCard={() => {
													triggerFilterTutorial();
													handleOnclickCard(
														ADMISSION_TYPES.ADMISSION,
														dbData.totalAdmissions,
														dbData.total,
														dbDataComparison?.totalAdmissions,
														dbDataComparison?.total
													)
												}}
												handleOnClickAction={(title, defaultTab) => handleChartDialog(title, ADMISSION_CARDS_TYPE.ADMISSION, null, true, defaultTab)}
												tooltipContent={tooltipsInfo.admissionsPage.newAdmissions}
												handleOnClickReport={(title, otherData) =>
													handleOnClickReport(ADMISSION_CARDS_TYPE.TOTAL_ADMISSIONS, title, true, false, otherData)
												}
												handleOnClickShareReport={(title) =>
													handleOnClickShareReport(title, ADMISSION_CARDS_TYPE.TOTAL_ADMISSIONS, true)
												}
												isLayoutMode={isLayoutMode}
												isMobile={isMobile}
											>
												<TotalTransferCard
													page={PAGE_TYPE.ADMISSION}
													title={"Total Admissions"}
													secondaryTitle={percentageBy}
													dbData={dbData}
													loading={loading || loadingComparison}
													dbDataComparison={dbDataComparison}
													total={dbData.totalAdmissions}
													totalComparison={dbDataComparison?.totalAdmissions}
													totalPercentage={itemPercentage(dbData.totalAdmissions, percentageAgainst, "number")}
													totalProjection={projectionPerMonth(dbData.totalAdmissions, filter, projectionDays)}
													totalProjectionComparison={projectionPerMonth(
														dbDataComparison?.totalAdmissions,
														filterComparison,
														projectionDays
													)}
													filter={filter}
													filterComparison={filterComparison}
													admissionCompareAgainst={
														lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData.bedCapacity
													}
													admissionCompareAgainstComparison={
														lockFilterTotalStateComparison?.isLocked
															? lockFilterTotalStateComparison?.lockedFilterTotal
															: dbDataComparison?.bedCapacity
													}
													totalComparisonPercentage={dbDataComparison?.totalAdmissions}
													totalProjectionPercentage={itemPercentage(
														projectionPerMonth(dbData.totalAdmissions, filter, projectionDays),
														percentageAgainst,
														"number"
													)}
													reverseColorsAdmissionPage={reversedColorAdmission}
													secondaryText={""}
													comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
													projectionDays={projectionDays}
													isMobile={isMobile}
												/>
											</SelectableCard>
										</Grid>
										<Grid item xs={6} sm={6} md={6}>
											<SelectableCard
												flex="1"
												pageType={PAGE_TYPE.ADMISSION}
												title="Re-Admissions"
												disabled={isLayoutMode || transferType === ADMISSION_TYPES.ADMISSION}
												selected={transferType === ADMISSION_TYPES.READMISSION}
												handleOnclickCard={() => {
													triggerFilterTutorial();
													handleOnclickCard(
														ADMISSION_TYPES.READMISSION,
														dbData.totalReAdmissions,
														dbData.total,
														dbDataComparison?.totalAdmissions,
														dbDataComparison?.total
													)
												}}
												handleOnClickAction={(title, defaultTab) => handleChartDialog(title, ADMISSION_CARDS_TYPE.READMISSION, null, true, defaultTab)}
												tooltipContent={tooltipsInfo.admissionsPage.reAdmissions}
												loading={loading || loadingComparison}
												handleOnClickReport={(title) => handleOnClickReport(ADMISSION_CARDS_TYPE.READMISSION, title, true)}
												handleOnClickShareReport={(title) =>
													handleOnClickShareReport(title, ADMISSION_CARDS_TYPE.READMISSION, true)
												}
												isLayoutMode={isLayoutMode}
												isMobile={isMobile}
												lastCard={true}
											>
												<TotalTransferCard
													page={PAGE_TYPE.ADMISSION}
													title={"Total Re-Admissions"}
													dbData={dbData}
													dbDataComparison={dbDataComparison}
													total={dbData.totalReAdmissions}
													loading={loading || loadingComparison}
													admissionCompareAgainst={
														lockFilterTotalState?.isLocked ? lockFilterTotalState?.lockedFilterTotal : dbData.bedCapacity
													}
													admissionCompareAgainstComparison={
														lockFilterTotalStateComparison?.isLocked
															? lockFilterTotalStateComparison?.lockedFilterTotal
															: dbDataComparison?.bedCapacity
													}
													totalComparison={dbDataComparison?.totalReAdmissions}
													totalPercentage={itemPercentage(dbData.totalReAdmissions, percentageAgainst, "number")}
													totalProjection={projectionPerMonth(dbData.totalReAdmissions, filter, projectionDays)}
													totalProjectionComparison={projectionPerMonth(
														dbDataComparison?.totalReAdmissions,
														filterComparison,
														projectionDays
													)}
													filter={filter}
													filterComparison={filterComparison}
													totalComparisonPercentage={dbDataComparison?.totalReAdmissions}
													totalProjectionPercentage={itemPercentage(
														projectionPerMonth(dbData.totalReAdmissions, filter, projectionDays),
														percentageAgainst,
														"number"
													)}
													reverseColorsAdmissionPage={reversedColorAdmission}
													secondaryTitle={percentageBy}
													secondaryText={""}
													comparingAgainstDifferentFacility={comparingAgainstDifferentFacility}
													projectionDays={projectionDays}
													isMobile={isMobile}
												/>
											</SelectableCard>
										</Grid>
									</Grid>
									{/* End of Transfer Type Selection */}

									<ShadowLineWithText data={admissionCards} />

									{/* Drag & Drop Layout for Cards */}
									<Grid
										container
										spacing={isMobile ? 0 : 2}
										sx={{
											mb: isMobile ? "0px" : "20px",
											...!isMobile && { mt: "8px" }
										}}
										display="flex"
										direction={"row"}
									>
										{isV3LayoutActive ? (
											<Box sx={{ width: "100%", mt: 2, mb: 2, pb: 1, pl: 2, pr: 2 }}>
												{(() => {
													const lo = getCurrentLayoutV3();
													const { layoutForDrag, cardsForGrid } = admissionMainGridPayload;
													const hasRoot =
														(lo.categories?.length || 0) + (lo.standalone?.length || 0) > 0;
													if (!isLayoutMode && (!hasRoot || cardsForGrid.length === 0)) return null;
													const categoryIdSet = new Set((lo.categories || []).map((c) => c.id));
													const hasStandaloneCards = (lo.standalone?.length || 0) > 0;
													const showStandaloneFallbackDropZone =
														isLayoutMode &&
														!hasStandaloneCards &&
														(Boolean(draggedCardId) || Boolean(draggedCardIdRef.current)) &&
														dragSource &&
														dragSource !== "standalone";

													return (
														<>
															<DragDropLayout
																isBoundedLayout={true}
																cards={cardsForGrid}
																layout={layoutForDrag}
																onLayoutChange={handleRootGridChange}
																isLayoutMode={isLayoutMode}
																disabled={loading || admissionLoading}
																isMobile={isMobile}
																uniformCardHeight={false}
																strictOverlapReorder
																strictOverlapThreshold={0.62}
																draggableCancel=".hospital-category-inner-dnd"
																hospitalRootLayoutMarker
																enableRootGaps={isLayoutMode}
																onRootGapDrop={handleRootGapDrop}
																layoutScrollContainerRef={scrollDemoRef}
																transformScale={
																	isLayoutMode
																		? (isMobile
																			? ADMISSION_LAYOUT_MODE_ZOOM_MOBILE
																			: ADMISSION_LAYOUT_MODE_ZOOM_DESKTOP)
																		: 1
																}
																generalDropHighlight={admissionGeneralDropHighlight}
																shouldPersistLayoutAfterDrag={() => {
																	if (!isLayoutMode) return true;
																	const dragging =
																		draggedCardId || draggedCardIdRef.current;
																	if (dragging && hoveredCategoryId != null) return false;
																	return true;
																}}
																onDragStart={(layout, oldItem, newItem) => {
																	const id = newItem?.i;
																	if (!id) return;
																	if (categoryIdSet.has(id)) {
																		draggedCardIdRef.current = null;
																		dragSourceRef.current = null;
																		setDraggedCardId(null);
																		setDragSource(null);
																		setHoveredCategoryId(null);
																		setHoveredStandalone(false);
																		return;
																	}
																	draggedCardIdRef.current = id;
																	dragSourceRef.current = "standalone";
																	setDraggedCardId(id);
																	setDragSource("standalone");
																	setHoveredCategoryId(null);
																	setHoveredStandalone(true);
																}}
																onDragStop={(layout, oldItem, newItem, placeholder, e) => {
																	// Bulletproof Drop: Use the exact coordinates at release to find the target.
																	const pt = getPointerClientCoords(e);
																	let targetId = hoveredCategoryId;

																	if (pt) {
																		const cid = resolveHospitalCategoryIdUnderPointer(pt.x, pt.y);
																		if (cid) targetId = cid;
																	}

																	if (targetId != null) {
																		handleCardDrop(targetId, "General Cards", e);
																	}
																	setTimeout(() => {
																		draggedCardIdRef.current = null;
																		dragSourceRef.current = null;
																		setDraggedCardId(null);
																		setHoveredCategoryId(null);
																		setHoveredStandalone(false);
																		setDragSource(null);
																	}, 50);
																}}
															>
																{(gridCard) => {
																	if (gridCard.type === "category") {
																		const category = lo.categories.find((c) => c.id === gridCard.id);
																		if (!category) return null;
																		const categoryCards = (category.cards || [])
																			.map((cardItem) => {
																				const def = cardData.find((c) => c.id === cardItem.id);
																				return def ? { ...def, ...cardItem } : null;
																			})
																			.filter(Boolean);
																		return (
																			<CategoryBox
																				id={category.id}
																				title={category.title}
																				cards={categoryCards}
																				dynamicCards={[...(dynamicCards || []), ...(patientList?.customTabs || [])]}
																				isCollapsed={Boolean(collapsedCategoryIds[category.id])}
																				onToggleCollapse={handleToggleCategoryCollapse}
																				onLayoutChange={handleLayoutChangeInCategory}
																				onDelete={handleDeleteCategory}
																				onUpdateTitle={handleUpdateCategoryTitle}
																				renderCard={renderCard}
																				isLayoutMode={isLayoutMode}
																				loading={loading || admissionLoading}
																				isMobile={isMobile}
																				innerTwoColumnDesktop={categoryInnerTwoCol}
																				layoutScrollContainerRef={scrollDemoRef}
																				useNativeCategoryReorder={false}
																				transformScale={
																					isLayoutMode
																						? (isMobile
																							? ADMISSION_LAYOUT_MODE_ZOOM_MOBILE
																							: ADMISSION_LAYOUT_MODE_ZOOM_DESKTOP)
																						: 1
																				}
																				onMouseEnter={(cid) => {
																					setHoveredCategoryId(cid);
																					setHoveredStandalone(false);
																				}}
																				onMouseLeave={() => setHoveredCategoryId(null)}
																				draggedCardId={draggedCardId}
																				dragSourceId={dragSource}
																				hoveredCategoryId={hoveredCategoryId}
																				hoveredStandalone={hoveredStandalone}
																				suppressCategoryInnerPersistRef={
																					suppressCategoryInnerPersistRef
																				}
																				onInnerLayoutDrag={(layout, oldItem, newItem, placeholder, ev) => {
																					const c = getPointerClientCoords(ev);
																					if (c) categoryDragPointerRef.current = c;
																				}}
																				onDragStart={(cardId, sourceCategoryId) => {
																					categoryDragPointerRef.current = null;
																					draggedCardIdRef.current = cardId;
																					dragSourceRef.current = sourceCategoryId;
																					setDraggedCardId(cardId);
																					setDragSource(sourceCategoryId);
																					setHoveredCategoryId(null);
																					setHoveredStandalone(false);
																				}}
																				onDragStop={(cardId, sourceCategoryId, e) => {
																					const pt =
																						getPointerClientCoords(e) ||
																						categoryDragPointerRef.current ||
																						(Date.now() - lastPointerRef.current.timestamp < 500
																							? lastPointerRef.current
																							: null);
																					let droppedOnStandalone = false;
																					const zoneEl = standaloneDropZoneRef.current;
																					if (pt && zoneEl) {
																						const r = zoneEl.getBoundingClientRect();
																						if (pointInRect(pt, r)) {
																							droppedOnStandalone = true;
																						}
																					}
																					if (!droppedOnStandalone && pt) {
																						let el = document.elementFromPoint(pt.x, pt.y);
																						if (!el?.closest?.("[data-hospital-drop='standalone']")) {
																							const offsets = [[5, 0], [-5, 0], [0, 5], [0, -5]];
																							for (const [dx, dy] of offsets) {
																								el = document.elementFromPoint(pt.x + dx, pt.y + dy);
																								if (el?.closest?.("[data-hospital-drop='standalone']")) break;
																							}
																						}
																						if (el?.closest?.("[data-hospital-drop='standalone']")) {
																							droppedOnStandalone = true;
																						}
																					}
																					if (!droppedOnStandalone && hoveredStandaloneRef.current) {
																						droppedOnStandalone = true;
																					}
																					if (!droppedOnStandalone && pt && pointerOverHospitalRootStandaloneArea(pt)) {
																						droppedOnStandalone = true;
																					}
																					categoryDragPointerRef.current = null;
																					const geometricTargetCategoryId =
																						!droppedOnStandalone && pt
																							? resolveHospitalCategoryIdUnderPointer(pt.x, pt.y)
																							: null;
																					if (droppedOnStandalone) {
																						suppressCategoryInnerPersistRef.current = true;
																						handleCardDrop("standalone", "General Cards", e);
																					} else if (
																						geometricTargetCategoryId != null &&
																						geometricTargetCategoryId !== category.id
																					) {
																						suppressCategoryInnerPersistRef.current = true;
																						handleCardDrop(geometricTargetCategoryId, "General Cards", e);
																					} else if (hoveredCategoryId != null && hoveredCategoryId !== category.id) {
																						// Support direct category-to-category drops.
																						suppressCategoryInnerPersistRef.current = true;
																						handleCardDrop(hoveredCategoryId, "General Cards", e);
																					} else {
																						setTimeout(() => {
																							draggedCardIdRef.current = null;
																							dragSourceRef.current = null;
																							setDraggedCardId(null);
																							setHoveredCategoryId(null);
																							setHoveredStandalone(false);
																							setDragSource(null);
																						}, 50);
																					}
																					queueMicrotask(() => {
																						suppressCategoryInnerPersistRef.current = false;
																					});
																				}}
																				onCardDrop={() => handleCardDrop(category.id, category.title)}
																				onCardDropAtEdge={handleCardDropAtCategoryEdge}
																				isCardOver={hoveredCategoryId === category.id}
																				showDropSuccessFlash={dropFlashCategoryId === category.id}
																			/>
																		);
																	}
																	return renderCard(gridCard);
																}}
															</DragDropLayout>
															{showStandaloneFallbackDropZone && (
																<Box
																	ref={standaloneDropZoneRef}
																	data-hospital-drop="standalone"
																	onMouseEnter={() =>
																		(draggedCardId || draggedCardIdRef.current) &&
																		setHoveredStandalone(true)
																	}
																	onMouseLeave={() => setHoveredStandalone(false)}
																	onMouseUp={(ev) => handleCardDrop("standalone", "General Cards", ev)}
																	sx={{
																		mb: 2,
																		ml: 1,
																		mt: 1,
																		px: 1,
																		py: 2,
																		minHeight: 88,
																		position: "relative",
																		zIndex: 10,
																		border: "1px dashed rgba(224, 228, 234, 0.95)",
																		borderRadius: "8px",
																		backgroundColor: "rgba(250, 251, 252, 0.95)",
																	}}
																>
																	<Typography variant="body2" color="text.secondary" align="center">
																		Drop here to move a card to the general area (no general cards in the
																		grid yet)
																	</Typography>
																</Box>
															)}
														</>
													);
												})()}
											</Box>
										) : (
											<DragDropLayout
												isBoundedLayout={true}
												cards={cardData}
												layout={getLegacyFlatLayout()}
												onLayoutChange={handleLayoutChange}
												isLayoutMode={isLayoutMode}
												disabled={loading || admissionLoading}
												isMobile={isMobile}
												strictOverlapReorder
												strictOverlapThreshold={0.62}
												transformScale={
													isLayoutMode
														? (isMobile
															? ADMISSION_LAYOUT_MODE_ZOOM_MOBILE
															: ADMISSION_LAYOUT_MODE_ZOOM_DESKTOP)
														: 1
												}
											>
												{renderCard}
											</DragDropLayout>
										)}
									</Grid>
									{/* ViewTransferStatusOfAdmission Section (excluded from drag and drop) */}
									{(!(selectedTab && selectedTab.length === 1 && _.includes(selectedTab, 'admission')) || isMobile) && (
										<>
											<HospitalRowContainer sx={{
												mb: "20px",
												...isMobile && {
													mt: "8px",
												}
											}}
												spacing={isMobile ? 0 : 1.2}
											>
												<CardAnimation id={`${ADMISSION_CARDS_TYPE.ADT_TAB}_scroll`} checked={_.includes(admissionCards, ADMISSION_CARDS_TYPE.ADT_TAB)} style={{ width: "100%" }}>
													<Grid item xs={12}>
														<ViewTransferStatusOfAdmission
															isDetailsOpen={true}
															allDynamicCards={allDynamicCards}
															allPagesCustomTabs={patientList?.allPagesCustomTabs ?? {}}
															handleOnClickRun={handleTransferStatusRun}
															loading={loading || loadingComparison}
															isMobile={isMobile}
															defaultCardEdited={defaultCardEdited}
															pageConverterSourcePage={pageConverterSourcePage}
														/>
													</Grid>
												</CardAnimation>
												{!isAdtLoading &&
													!loading &&
													selectedADTTableData &&
													selectedADTTableData.length > 0 &&
													Object.entries(_.groupBy(selectedADTTableData, "cardId")).map(([cardId, group], index) => (
														<Box key={cardId} sx={{
															width: "100%",
															...(index === 0 && { mt: 3 }),
															mb: 3,
															p: 2,
															backgroundColor: "#f9fafb",
															borderRadius: "16px",
															border: "1px solid #e0e4ead9",
															boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
														}}>
															<Box sx={{
																display: 'flex',
																alignItems: 'center',
																mb: 2,
																ml: 0.5
															}}>
																<Typography
																	variant="h6"
																	className="ffmar fw700"
																	sx={{
																		color: "#4879f5",
																		textTransform: 'capitalize',
																		letterSpacing: '1.2px',
																		fontSize: '0.85rem',
																		mr: 2,
																		whiteSpace: 'nowrap'
																	}}
																>
																	{cardId === "communityTransfer" ? "Community Transfer" :
																		cardId === "hospital" ? "Hospital" :
																			cardId === "deceased" ? "Deceased" :
																				cardId === "overall" ? "Overall" :
																					cardId}
																</Typography>
																<Divider sx={{ flexGrow: 1, borderColor: "#e0e4ead9" }} />
															</Box>
															<Grid container spacing={2}>
																{group.map(renderADTDataTables)}
															</Grid>
														</Box>
													))}
											</HospitalRowContainer>
										</>
									)}
								</Box>
							</NoteContainer>
						</Box>)
				}
			</div >

			{/* Share Notification Dialog for Admission Page */}
			<ShareNotificationDialog
				open={showShareDialog}
				notifications={shareNotifications}
				onClose={handleCloseShareDialog}
				onResponse={handleNotificationResponse}
				onViewTab={handleViewTab}
			/>

			{/* Layout Controller for Drag-and-Drop */}
			<LayoutController
				isLayoutMode={isLayoutMode}
				onToggleLayoutMode={handleToggleLayoutMode}
				onSaveLayout={handleSaveLayout}
				onResetLayout={handleResetLayout}
				onLayoutTypeChange={handleLayoutTypeChange}
				currentLayoutType={currentLayoutType}
				hasChanges={hasLayoutChanges}
				disabled={loading || admissionLoading}
				pageType={PAGE_TYPE.ADMISSION}
				onCreateCategory={handleCreateCategory}
				onAddCategoryFromMenu={handleAddCategoryFromMenu}
			/>

			{/* Toast Notification */}
			<ToastNotification
				open={toastNotification.open}
				type={toastNotification.type}
				title={toastNotification.title}
				message={toastNotification.message}
				onClose={() => setToastNotification({ ...toastNotification, open: false })}
			/>

			{/* AI Chat Float Button - Only show when drawer is closed or maximized and user has access */}
			{hasAiChatAccess && !aiChatAccessLoading && !isLayoutMode && (!aiChatOpen || !aiChatMinimized) && (
				<AiChatFloatButton
					onClick={handleAiChatToggle}
					isOpen={aiChatOpen}
					unreadCount={aiChatUnreadCount}
					disabled={loading || admissionLoading || !dbData || dbData.total === undefined || patientList?.list?.length === 0}
					showPulse={!loading && !admissionLoading && dbData && (dbData.total >= 0) && patientList?.list?.length > 0 && !aiChatOpen}
					tooltipText="Ask AI about your admission data"
				/>
			)}

			{/* AI Chat Drawer - Only show if user has access */}
			{hasAiChatAccess && !aiChatAccessLoading && (
				<AiChatDrawer
					open={aiChatOpen}
					onClose={handleAiChatClose}
					pageType={PAGE_TYPE.ADMISSION}
					pageData={aiChatContext}
					onMinimizeStateChange={handleAiChatMinimizeStateChange}
					handleOnClickReport={handleOnClickReport}
					downloadExcel={downloadExcel}
					conversationId={aiConversationId}
					filter={filter}
					disabled={loading || admissionLoading || !dbData || dbData.total === undefined || patientList?.list?.length === 0}
					loadingMessage={
						loading || admissionLoading
							? "Loading admission data... Please wait before asking questions."
							: !dbData || dbData.total === undefined || patientList?.list?.length === 0
								? "No admission data available. Please ensure data is loaded before using AI chat."
								: undefined
					}
				/>
			)}

			{/* Share Report Dialog */}
			{shareReportState.open && (
				<ShareNotesDialog
					handleClose={handleCloseShareReport}
					handleSubmit={handleShareReport}
					isShare={shareReportState.open}
					noteText={`Report: ${shareReportState.reportTitle || 'Generated Report'}`}
					users={users}
					availableIntegrations={availableIntegrations}
					isSubmitting={shareReportState.isSharing}
					accountId={accountIdFromHook}
					facilityId={facilityIdFromHook}
					redirectAfter={handleCloseShareReport}
				/>
			)}
		</Page >
	);
};

export default AdmissionPage;